export const COLOR_TRANSPARENT = "eon-transparent";
export const COLOR_WHITE = "eon-white";
export const COLOR_SYSTEM_SUCCESS_LIGHT = "eon-system-success-light";
export const COLOR_SYSTEM_SUCCESS = "eon-system-success";
export const COLOR_SYSTEM_SUCCESS_DARK = "eon-system-success-dark";
export const COLOR_SYSTEM_WARNING_LIGHT = "eon-system-warning-light";
export const COLOR_SYSTEM_WARNING = "eon-system-warning";
export const COLOR_SYSTEM_WARNING_DARK = "eon-system-warning-dark";
export const COLOR_SYSTEM_ERROR_LIGHT = "eon-system-error-light";
export const COLOR_SYSTEM_ERROR = "eon-system-error";
export const COLOR_SYSTEM_ERROR_DARK = "eon-system-error-dark";
export const COLOR_SYSTEM_HIGHLIGHT_LIGHT = "eon-system-highlight-light";
export const COLOR_SYSTEM_HIGHLIGHT = "eon-system-highlight";
export const COLOR_SYSTEM_HIGHLIGHT_DARK = "eon-system-highlight-dark";
export const COLOR_GREY100 = "eon-grey100";
export const COLOR_GREY200 = "eon-grey200";
export const COLOR_GREY300 = "eon-grey300";
export const COLOR_GREY400 = "eon-grey400";
export const COLOR_GREY500 = "eon-grey500";
export const COLOR_GREY600 = "eon-grey600";
export const COLOR_GREY700 = "eon-grey700";
export const COLOR_GREY800 = "eon-grey800";
export const COLOR_GREY900 = "eon-grey900";

export const COLOR_BRIGHT = "eon-bright";
export const COLOR_DARK = "eon-dark";
export const COLOR_BLACK = "eon-black";
export const COLOR_NEUTRAL100 = "eon-neutral100";
export const COLOR_NEUTRAL300 = "eon-neutral300";
export const COLOR_NEUTRAL800 = "eon-neutral800";
export const COLOR_RED100 = "eon-red100";
export const COLOR_RED300 = "eon-red300";
export const COLOR_RED500 = "eon-red500";
export const COLOR_RED800 = "eon-red800";
export const COLOR_YELLOW100 = "eon-yellow100";
export const COLOR_YELLOW300 = "eon-yellow300";
export const COLOR_YELLOW500 = "eon-yellow500";
export const COLOR_TURQUOISE100 = "eon-turquoise100";
export const COLOR_TURQUOISE300 = "eon-turquoise300";
export const COLOR_TURQUOISE500 = "eon-turquoise500";
export const COLOR_BRIGHT_FONT = "eon-bright-font";
export const COLOR_DARK_FONT = "eon-dark-font";
export const COLOR_WHITE_FONT = "eon-white-font";
export const COLOR_BLACK_FONT = "eon-black-font";
export const COLOR_GREY100_FONT = "eon-grey100-font";
export const COLOR_GREY900_FONT = "eon-grey900-font";
export const COLOR_NEUTRAL100_FONT = "eon-neutral100-font";
export const COLOR_NEUTRAL300_FONT = "eon-neutral300-font";
export const COLOR_NEUTRAL800_FONT = "eon-neutral800-font";
export const COLOR_RED100_FONT = "eon-red100-font";
export const COLOR_RED300_FONT = "eon-red300-font";
export const COLOR_RED500_FONT = "eon-red500-font";
export const COLOR_RED800_FONT = "eon-red800-font";
export const COLOR_YELLOW100_FONT = "eon-yellow100-font";
export const COLOR_YELLOW300_FONT = "eon-yellow300-font";
export const COLOR_YELLOW500_FONT = "eon-yellow500-font";
export const COLOR_TURQUOISE100_FONT = "eon-turquoise100-font";
export const COLOR_TURQUOISE300_FONT = "eon-turquoise300-font";
export const COLOR_TURQUOISE500_FONT = "eon-turquoise500-font";
export const COLOR_VIOLET_DARK = "eon-violet-dark";
export const COLOR_RED200 = "eon-red200";
export const COLOR_RED200_OPACITY_25 = "eon-red200-opacity-25";
export const COLOR_RED400 = "eon-red400";
export const COLOR_RED400_OPACITY_25 = "eon-red400-opacity-25";
export const COLOR_RED600 = "eon-red600";
export const COLOR_RED700 = "eon-red700";
export const COLOR_RED700_OPACITY_20 = "eon-red700-opacity-20";
export const COLOR_RED900 = "eon-red900";
export const COLOR_YELLOW200 = "eon-yellow200";
export const COLOR_YELLOW400 = "eon-yellow400";
export const COLOR_YELLOW600 = "eon-yellow600";
export const COLOR_YELLOW700 = "eon-yellow700";
export const COLOR_YELLOW800 = "eon-yellow800";
export const COLOR_YELLOW900 = "eon-yellow900";
export const COLOR_TURQUOISE200 = "eon-turquoise200";
export const COLOR_TURQUOISE400 = "eon-turquoise400";
export const COLOR_TURQUOISE600 = "eon-turquoise600";
export const COLOR_TURQUOISE700 = "eon-turquoise700";
export const COLOR_TURQUOISE800 = "eon-turquoise800";
export const COLOR_TURQUOISE900 = "eon-turquoise900";
export const COLOR_NEUTRAL200 = "eon-neutral200";
export const COLOR_NEUTRAL400 = "eon-neutral400";
export const COLOR_NEUTRAL500 = "eon-neutral500";
export const COLOR_NEUTRAL600 = "eon-neutral600";
export const COLOR_NEUTRAL600_OPACITY_25 = "eon-neutral600-opacity-25";
export const COLOR_NEUTRAL700 = "eon-neutral700";
export const COLOR_NEUTRAL700_OPACITY_25 = "eon-neutral700-opacity-25";
export const COLOR_NEUTRAL800_RGB = "eon-neutral800-rgb";
export const COLOR_NEUTRAL900 = "eon-neutral900";
export const COLOR_GREY800_OPACITY_50 = "eon-grey800-opacity-50";
export const COLOR_GREY900_OPACITY_8 = "eon-grey900-opacity-8";
export const COLOR_BLUE100 = "eon-blue100";
export const COLOR_BLUE200 = "eon-blue200";
export const COLOR_BLUE300 = "eon-blue300";
export const COLOR_BLUE400 = "eon-blue400";
export const COLOR_BLUE500 = "eon-blue500";
export const COLOR_BLUE600 = "eon-blue600";
export const COLOR_BLUE700 = "eon-blue700";
export const COLOR_BLUE800 = "eon-blue800";
export const COLOR_BLUE900 = "eon-blue900";
export const COLOR_PURPLE100 = "eon-purple100";
export const COLOR_PURPLE200 = "eon-purple200";
export const COLOR_PURPLE300 = "eon-purple300";
export const COLOR_PURPLE400 = "eon-purple400";
export const COLOR_PURPLE500 = "eon-purple500";
export const COLOR_PURPLE600 = "eon-purple600";
export const COLOR_PURPLE700 = "eon-purple700";
export const COLOR_PURPLE800 = "eon-purple800";
export const COLOR_PURPLE900 = "eon-purple900";
export const COLOR_RED500GRADIENT = "eon-red500gradient";
export const COLOR_BRIGHT_SHADE_1 = "eon-bright-shade-1";
export const COLOR_BRIGHT_SHADE_2 = "eon-bright-shade-2";
export const COLOR_BRIGHT_TINT_1 = "eon-bright-tint-1";
export const COLOR_BRIGHT_TINT_2 = "eon-bright-tint-2";
export const COLOR_BRIGHT_5 = "eon-bright-5";
export const COLOR_BRIGHT_10 = "eon-bright-10";
export const COLOR_BRIGHT_15 = "eon-bright-15";
export const COLOR_BRIGHT_20 = "eon-bright-20";
export const COLOR_BRIGHT_25 = "eon-bright-25";
export const COLOR_BRIGHT_30 = "eon-bright-30";
export const COLOR_BRIGHT_35 = "eon-bright-35";
export const COLOR_BRIGHT_40 = "eon-bright-40";
export const COLOR_BRIGHT_45 = "eon-bright-45";
export const COLOR_BRIGHT_50 = "eon-bright-50";
export const COLOR_BRIGHT_55 = "eon-bright-55";
export const COLOR_BRIGHT_60 = "eon-bright-60";
export const COLOR_BRIGHT_65 = "eon-bright-65";
export const COLOR_BRIGHT_70 = "eon-bright-70";
export const COLOR_BRIGHT_75 = "eon-bright-75";
export const COLOR_BRIGHT_80 = "eon-bright-80";
export const COLOR_BRIGHT_85 = "eon-bright-85";
export const COLOR_BRIGHT_90 = "eon-bright-90";
export const COLOR_BRIGHT_95 = "eon-bright-95";
export const COLOR_BRIGHT_OPACITY_5 = "eon-bright-opacity-5";
export const COLOR_BRIGHT_OPACITY_10 = "eon-bright-opacity-10";
export const COLOR_BRIGHT_OPACITY_15 = "eon-bright-opacity-15";
export const COLOR_BRIGHT_OPACITY_20 = "eon-bright-opacity-20";
export const COLOR_BRIGHT_OPACITY_25 = "eon-bright-opacity-25";
export const COLOR_BRIGHT_OPACITY_30 = "eon-bright-opacity-30";
export const COLOR_BRIGHT_OPACITY_35 = "eon-bright-opacity-35";
export const COLOR_BRIGHT_OPACITY_40 = "eon-bright-opacity-40";
export const COLOR_BRIGHT_OPACITY_45 = "eon-bright-opacity-45";
export const COLOR_BRIGHT_OPACITY_50 = "eon-bright-opacity-50";
export const COLOR_BRIGHT_OPACITY_55 = "eon-bright-opacity-55";
export const COLOR_BRIGHT_OPACITY_60 = "eon-bright-opacity-60";
export const COLOR_BRIGHT_OPACITY_65 = "eon-bright-opacity-65";
export const COLOR_BRIGHT_OPACITY_70 = "eon-bright-opacity-70";
export const COLOR_BRIGHT_OPACITY_75 = "eon-bright-opacity-75";
export const COLOR_BRIGHT_OPACITY_80 = "eon-bright-opacity-80";
export const COLOR_BRIGHT_OPACITY_85 = "eon-bright-opacity-85";
export const COLOR_BRIGHT_OPACITY_90 = "eon-bright-opacity-90";
export const COLOR_BRIGHT_OPACITY_95 = "eon-bright-opacity-95";
export const COLOR_DARK_SHADE_1 = "eon-dark-shade-1";
export const COLOR_DARK_SHADE_2 = "eon-dark-shade-2";
export const COLOR_DARK_TINT_1 = "eon-dark-tint-1";
export const COLOR_DARK_TINT_2 = "eon-dark-tint-2";
export const COLOR_DARK_5 = "eon-dark-5";
export const COLOR_DARK_10 = "eon-dark-10";
export const COLOR_DARK_15 = "eon-dark-15";
export const COLOR_DARK_20 = "eon-dark-20";
export const COLOR_DARK_25 = "eon-dark-25";
export const COLOR_DARK_30 = "eon-dark-30";
export const COLOR_DARK_35 = "eon-dark-35";
export const COLOR_DARK_40 = "eon-dark-40";
export const COLOR_DARK_45 = "eon-dark-45";
export const COLOR_DARK_50 = "eon-dark-50";
export const COLOR_DARK_55 = "eon-dark-55";
export const COLOR_DARK_60 = "eon-dark-60";
export const COLOR_DARK_65 = "eon-dark-65";
export const COLOR_DARK_70 = "eon-dark-70";
export const COLOR_DARK_75 = "eon-dark-75";
export const COLOR_DARK_80 = "eon-dark-80";
export const COLOR_DARK_85 = "eon-dark-85";
export const COLOR_DARK_90 = "eon-dark-90";
export const COLOR_DARK_95 = "eon-dark-95";
export const COLOR_DARK_OPACITY_5 = "eon-dark-opacity-5";
export const COLOR_DARK_OPACITY_10 = "eon-dark-opacity-10";
export const COLOR_DARK_OPACITY_15 = "eon-dark-opacity-15";
export const COLOR_DARK_OPACITY_20 = "eon-dark-opacity-20";
export const COLOR_DARK_OPACITY_25 = "eon-dark-opacity-25";
export const COLOR_DARK_OPACITY_30 = "eon-dark-opacity-30";
export const COLOR_DARK_OPACITY_35 = "eon-dark-opacity-35";
export const COLOR_DARK_OPACITY_40 = "eon-dark-opacity-40";
export const COLOR_DARK_OPACITY_45 = "eon-dark-opacity-45";
export const COLOR_DARK_OPACITY_50 = "eon-dark-opacity-50";
export const COLOR_DARK_OPACITY_55 = "eon-dark-opacity-55";
export const COLOR_DARK_OPACITY_60 = "eon-dark-opacity-60";
export const COLOR_DARK_OPACITY_65 = "eon-dark-opacity-65";
export const COLOR_DARK_OPACITY_70 = "eon-dark-opacity-70";
export const COLOR_DARK_OPACITY_75 = "eon-dark-opacity-75";
export const COLOR_DARK_OPACITY_80 = "eon-dark-opacity-80";
export const COLOR_DARK_OPACITY_85 = "eon-dark-opacity-85";
export const COLOR_DARK_OPACITY_90 = "eon-dark-opacity-90";
export const COLOR_DARK_OPACITY_95 = "eon-dark-opacity-95";
export const COLOR_WHITE_SHADE_1 = "eon-white-shade-1";
export const COLOR_WHITE_SHADE_2 = "eon-white-shade-2";
export const COLOR_WHITE_TINT_1 = "eon-white-tint-1";
export const COLOR_WHITE_TINT_2 = "eon-white-tint-2";
export const COLOR_WHITE_5 = "eon-white-5";
export const COLOR_WHITE_10 = "eon-white-10";
export const COLOR_WHITE_15 = "eon-white-15";
export const COLOR_WHITE_20 = "eon-white-20";
export const COLOR_WHITE_25 = "eon-white-25";
export const COLOR_WHITE_30 = "eon-white-30";
export const COLOR_WHITE_35 = "eon-white-35";
export const COLOR_WHITE_40 = "eon-white-40";
export const COLOR_WHITE_45 = "eon-white-45";
export const COLOR_WHITE_50 = "eon-white-50";
export const COLOR_WHITE_55 = "eon-white-55";
export const COLOR_WHITE_60 = "eon-white-60";
export const COLOR_WHITE_65 = "eon-white-65";
export const COLOR_WHITE_70 = "eon-white-70";
export const COLOR_WHITE_75 = "eon-white-75";
export const COLOR_WHITE_80 = "eon-white-80";
export const COLOR_WHITE_85 = "eon-white-85";
export const COLOR_WHITE_90 = "eon-white-90";
export const COLOR_WHITE_95 = "eon-white-95";
export const COLOR_WHITE_OPACITY_5 = "eon-white-opacity-5";
export const COLOR_WHITE_OPACITY_10 = "eon-white-opacity-10";
export const COLOR_WHITE_OPACITY_15 = "eon-white-opacity-15";
export const COLOR_WHITE_OPACITY_20 = "eon-white-opacity-20";
export const COLOR_WHITE_OPACITY_25 = "eon-white-opacity-25";
export const COLOR_WHITE_OPACITY_30 = "eon-white-opacity-30";
export const COLOR_WHITE_OPACITY_35 = "eon-white-opacity-35";
export const COLOR_WHITE_OPACITY_40 = "eon-white-opacity-40";
export const COLOR_WHITE_OPACITY_45 = "eon-white-opacity-45";
export const COLOR_WHITE_OPACITY_50 = "eon-white-opacity-50";
export const COLOR_WHITE_OPACITY_55 = "eon-white-opacity-55";
export const COLOR_WHITE_OPACITY_60 = "eon-white-opacity-60";
export const COLOR_WHITE_OPACITY_65 = "eon-white-opacity-65";
export const COLOR_WHITE_OPACITY_70 = "eon-white-opacity-70";
export const COLOR_WHITE_OPACITY_75 = "eon-white-opacity-75";
export const COLOR_WHITE_OPACITY_80 = "eon-white-opacity-80";
export const COLOR_WHITE_OPACITY_85 = "eon-white-opacity-85";
export const COLOR_WHITE_OPACITY_90 = "eon-white-opacity-90";
export const COLOR_WHITE_OPACITY_95 = "eon-white-opacity-95";
export const COLOR_BLACK_SHADE_1 = "eon-black-shade-1";
export const COLOR_BLACK_SHADE_2 = "eon-black-shade-2";
export const COLOR_BLACK_TINT_1 = "eon-black-tint-1";
export const COLOR_BLACK_TINT_2 = "eon-black-tint-2";
export const COLOR_BLACK_5 = "eon-black-5";
export const COLOR_BLACK_10 = "eon-black-10";
export const COLOR_BLACK_15 = "eon-black-15";
export const COLOR_BLACK_20 = "eon-black-20";
export const COLOR_BLACK_25 = "eon-black-25";
export const COLOR_BLACK_30 = "eon-black-30";
export const COLOR_BLACK_35 = "eon-black-35";
export const COLOR_BLACK_40 = "eon-black-40";
export const COLOR_BLACK_45 = "eon-black-45";
export const COLOR_BLACK_50 = "eon-black-50";
export const COLOR_BLACK_55 = "eon-black-55";
export const COLOR_BLACK_60 = "eon-black-60";
export const COLOR_BLACK_65 = "eon-black-65";
export const COLOR_BLACK_70 = "eon-black-70";
export const COLOR_BLACK_75 = "eon-black-75";
export const COLOR_BLACK_80 = "eon-black-80";
export const COLOR_BLACK_85 = "eon-black-85";
export const COLOR_BLACK_90 = "eon-black-90";
export const COLOR_BLACK_95 = "eon-black-95";
export const COLOR_BLACK_OPACITY_5 = "eon-black-opacity-5";
export const COLOR_BLACK_OPACITY_10 = "eon-black-opacity-10";
export const COLOR_BLACK_OPACITY_15 = "eon-black-opacity-15";
export const COLOR_BLACK_OPACITY_20 = "eon-black-opacity-20";
export const COLOR_BLACK_OPACITY_25 = "eon-black-opacity-25";
export const COLOR_BLACK_OPACITY_30 = "eon-black-opacity-30";
export const COLOR_BLACK_OPACITY_35 = "eon-black-opacity-35";
export const COLOR_BLACK_OPACITY_40 = "eon-black-opacity-40";
export const COLOR_BLACK_OPACITY_45 = "eon-black-opacity-45";
export const COLOR_BLACK_OPACITY_50 = "eon-black-opacity-50";
export const COLOR_BLACK_OPACITY_55 = "eon-black-opacity-55";
export const COLOR_BLACK_OPACITY_60 = "eon-black-opacity-60";
export const COLOR_BLACK_OPACITY_65 = "eon-black-opacity-65";
export const COLOR_BLACK_OPACITY_70 = "eon-black-opacity-70";
export const COLOR_BLACK_OPACITY_75 = "eon-black-opacity-75";
export const COLOR_BLACK_OPACITY_80 = "eon-black-opacity-80";
export const COLOR_BLACK_OPACITY_85 = "eon-black-opacity-85";
export const COLOR_BLACK_OPACITY_90 = "eon-black-opacity-90";
export const COLOR_BLACK_OPACITY_95 = "eon-black-opacity-95";
export const COLOR_GREY100_SHADE_1 = "eon-grey100-shade-1";
export const COLOR_GREY100_SHADE_2 = "eon-grey100-shade-2";
export const COLOR_GREY100_TINT_1 = "eon-grey100-tint-1";
export const COLOR_GREY100_TINT_2 = "eon-grey100-tint-2";
export const COLOR_GREY100_5 = "eon-grey100-5";
export const COLOR_GREY100_10 = "eon-grey100-10";
export const COLOR_GREY100_15 = "eon-grey100-15";
export const COLOR_GREY100_20 = "eon-grey100-20";
export const COLOR_GREY100_25 = "eon-grey100-25";
export const COLOR_GREY100_30 = "eon-grey100-30";
export const COLOR_GREY100_35 = "eon-grey100-35";
export const COLOR_GREY100_40 = "eon-grey100-40";
export const COLOR_GREY100_45 = "eon-grey100-45";
export const COLOR_GREY100_50 = "eon-grey100-50";
export const COLOR_GREY100_55 = "eon-grey100-55";
export const COLOR_GREY100_60 = "eon-grey100-60";
export const COLOR_GREY100_65 = "eon-grey100-65";
export const COLOR_GREY100_70 = "eon-grey100-70";
export const COLOR_GREY100_75 = "eon-grey100-75";
export const COLOR_GREY100_80 = "eon-grey100-80";
export const COLOR_GREY100_85 = "eon-grey100-85";
export const COLOR_GREY100_90 = "eon-grey100-90";
export const COLOR_GREY100_95 = "eon-grey100-95";
export const COLOR_GREY100_OPACITY_5 = "eon-grey100-opacity-5";
export const COLOR_GREY100_OPACITY_10 = "eon-grey100-opacity-10";
export const COLOR_GREY100_OPACITY_15 = "eon-grey100-opacity-15";
export const COLOR_GREY100_OPACITY_20 = "eon-grey100-opacity-20";
export const COLOR_GREY100_OPACITY_25 = "eon-grey100-opacity-25";
export const COLOR_GREY100_OPACITY_30 = "eon-grey100-opacity-30";
export const COLOR_GREY100_OPACITY_35 = "eon-grey100-opacity-35";
export const COLOR_GREY100_OPACITY_40 = "eon-grey100-opacity-40";
export const COLOR_GREY100_OPACITY_45 = "eon-grey100-opacity-45";
export const COLOR_GREY100_OPACITY_50 = "eon-grey100-opacity-50";
export const COLOR_GREY100_OPACITY_55 = "eon-grey100-opacity-55";
export const COLOR_GREY100_OPACITY_60 = "eon-grey100-opacity-60";
export const COLOR_GREY100_OPACITY_65 = "eon-grey100-opacity-65";
export const COLOR_GREY100_OPACITY_70 = "eon-grey100-opacity-70";
export const COLOR_GREY100_OPACITY_75 = "eon-grey100-opacity-75";
export const COLOR_GREY100_OPACITY_80 = "eon-grey100-opacity-80";
export const COLOR_GREY100_OPACITY_85 = "eon-grey100-opacity-85";
export const COLOR_GREY100_OPACITY_90 = "eon-grey100-opacity-90";
export const COLOR_GREY100_OPACITY_95 = "eon-grey100-opacity-95";
export const COLOR_GREY900_SHADE_1 = "eon-grey900-shade-1";
export const COLOR_GREY900_SHADE_2 = "eon-grey900-shade-2";
export const COLOR_GREY900_TINT_1 = "eon-grey900-tint-1";
export const COLOR_GREY900_TINT_2 = "eon-grey900-tint-2";
export const COLOR_GREY900_5 = "eon-grey900-5";
export const COLOR_GREY900_10 = "eon-grey900-10";
export const COLOR_GREY900_15 = "eon-grey900-15";
export const COLOR_GREY900_20 = "eon-grey900-20";
export const COLOR_GREY900_25 = "eon-grey900-25";
export const COLOR_GREY900_30 = "eon-grey900-30";
export const COLOR_GREY900_35 = "eon-grey900-35";
export const COLOR_GREY900_40 = "eon-grey900-40";
export const COLOR_GREY900_45 = "eon-grey900-45";
export const COLOR_GREY900_50 = "eon-grey900-50";
export const COLOR_GREY900_55 = "eon-grey900-55";
export const COLOR_GREY900_60 = "eon-grey900-60";
export const COLOR_GREY900_65 = "eon-grey900-65";
export const COLOR_GREY900_70 = "eon-grey900-70";
export const COLOR_GREY900_75 = "eon-grey900-75";
export const COLOR_GREY900_80 = "eon-grey900-80";
export const COLOR_GREY900_85 = "eon-grey900-85";
export const COLOR_GREY900_90 = "eon-grey900-90";
export const COLOR_GREY900_95 = "eon-grey900-95";
export const COLOR_GREY900_OPACITY_5 = "eon-grey900-opacity-5";
export const COLOR_GREY900_OPACITY_10 = "eon-grey900-opacity-10";
export const COLOR_GREY900_OPACITY_15 = "eon-grey900-opacity-15";
export const COLOR_GREY900_OPACITY_20 = "eon-grey900-opacity-20";
export const COLOR_GREY900_OPACITY_25 = "eon-grey900-opacity-25";
export const COLOR_GREY900_OPACITY_30 = "eon-grey900-opacity-30";
export const COLOR_GREY900_OPACITY_35 = "eon-grey900-opacity-35";
export const COLOR_GREY900_OPACITY_40 = "eon-grey900-opacity-40";
export const COLOR_GREY900_OPACITY_45 = "eon-grey900-opacity-45";
export const COLOR_GREY900_OPACITY_50 = "eon-grey900-opacity-50";
export const COLOR_GREY900_OPACITY_55 = "eon-grey900-opacity-55";
export const COLOR_GREY900_OPACITY_60 = "eon-grey900-opacity-60";
export const COLOR_GREY900_OPACITY_65 = "eon-grey900-opacity-65";
export const COLOR_GREY900_OPACITY_70 = "eon-grey900-opacity-70";
export const COLOR_GREY900_OPACITY_75 = "eon-grey900-opacity-75";
export const COLOR_GREY900_OPACITY_80 = "eon-grey900-opacity-80";
export const COLOR_GREY900_OPACITY_85 = "eon-grey900-opacity-85";
export const COLOR_GREY900_OPACITY_90 = "eon-grey900-opacity-90";
export const COLOR_GREY900_OPACITY_95 = "eon-grey900-opacity-95";
export const COLOR_NEUTRAL100_SHADE_1 = "eon-neutral100-shade-1";
export const COLOR_NEUTRAL100_SHADE_2 = "eon-neutral100-shade-2";
export const COLOR_NEUTRAL100_TINT_1 = "eon-neutral100-tint-1";
export const COLOR_NEUTRAL100_TINT_2 = "eon-neutral100-tint-2";
export const COLOR_NEUTRAL100_5 = "eon-neutral100-5";
export const COLOR_NEUTRAL100_10 = "eon-neutral100-10";
export const COLOR_NEUTRAL100_15 = "eon-neutral100-15";
export const COLOR_NEUTRAL100_20 = "eon-neutral100-20";
export const COLOR_NEUTRAL100_25 = "eon-neutral100-25";
export const COLOR_NEUTRAL100_30 = "eon-neutral100-30";
export const COLOR_NEUTRAL100_35 = "eon-neutral100-35";
export const COLOR_NEUTRAL100_40 = "eon-neutral100-40";
export const COLOR_NEUTRAL100_45 = "eon-neutral100-45";
export const COLOR_NEUTRAL100_50 = "eon-neutral100-50";
export const COLOR_NEUTRAL100_55 = "eon-neutral100-55";
export const COLOR_NEUTRAL100_60 = "eon-neutral100-60";
export const COLOR_NEUTRAL100_65 = "eon-neutral100-65";
export const COLOR_NEUTRAL100_70 = "eon-neutral100-70";
export const COLOR_NEUTRAL100_75 = "eon-neutral100-75";
export const COLOR_NEUTRAL100_80 = "eon-neutral100-80";
export const COLOR_NEUTRAL100_85 = "eon-neutral100-85";
export const COLOR_NEUTRAL100_90 = "eon-neutral100-90";
export const COLOR_NEUTRAL100_95 = "eon-neutral100-95";
export const COLOR_NEUTRAL100_OPACITY_5 = "eon-neutral100-opacity-5";
export const COLOR_NEUTRAL100_OPACITY_10 = "eon-neutral100-opacity-10";
export const COLOR_NEUTRAL100_OPACITY_15 = "eon-neutral100-opacity-15";
export const COLOR_NEUTRAL100_OPACITY_20 = "eon-neutral100-opacity-20";
export const COLOR_NEUTRAL100_OPACITY_25 = "eon-neutral100-opacity-25";
export const COLOR_NEUTRAL100_OPACITY_30 = "eon-neutral100-opacity-30";
export const COLOR_NEUTRAL100_OPACITY_35 = "eon-neutral100-opacity-35";
export const COLOR_NEUTRAL100_OPACITY_40 = "eon-neutral100-opacity-40";
export const COLOR_NEUTRAL100_OPACITY_45 = "eon-neutral100-opacity-45";
export const COLOR_NEUTRAL100_OPACITY_50 = "eon-neutral100-opacity-50";
export const COLOR_NEUTRAL100_OPACITY_55 = "eon-neutral100-opacity-55";
export const COLOR_NEUTRAL100_OPACITY_60 = "eon-neutral100-opacity-60";
export const COLOR_NEUTRAL100_OPACITY_65 = "eon-neutral100-opacity-65";
export const COLOR_NEUTRAL100_OPACITY_70 = "eon-neutral100-opacity-70";
export const COLOR_NEUTRAL100_OPACITY_75 = "eon-neutral100-opacity-75";
export const COLOR_NEUTRAL100_OPACITY_80 = "eon-neutral100-opacity-80";
export const COLOR_NEUTRAL100_OPACITY_85 = "eon-neutral100-opacity-85";
export const COLOR_NEUTRAL100_OPACITY_90 = "eon-neutral100-opacity-90";
export const COLOR_NEUTRAL100_OPACITY_95 = "eon-neutral100-opacity-95";
export const COLOR_NEUTRAL300_SHADE_1 = "eon-neutral300-shade-1";
export const COLOR_NEUTRAL300_SHADE_2 = "eon-neutral300-shade-2";
export const COLOR_NEUTRAL300_TINT_1 = "eon-neutral300-tint-1";
export const COLOR_NEUTRAL300_TINT_2 = "eon-neutral300-tint-2";
export const COLOR_NEUTRAL300_5 = "eon-neutral300-5";
export const COLOR_NEUTRAL300_10 = "eon-neutral300-10";
export const COLOR_NEUTRAL300_15 = "eon-neutral300-15";
export const COLOR_NEUTRAL300_20 = "eon-neutral300-20";
export const COLOR_NEUTRAL300_25 = "eon-neutral300-25";
export const COLOR_NEUTRAL300_30 = "eon-neutral300-30";
export const COLOR_NEUTRAL300_35 = "eon-neutral300-35";
export const COLOR_NEUTRAL300_40 = "eon-neutral300-40";
export const COLOR_NEUTRAL300_45 = "eon-neutral300-45";
export const COLOR_NEUTRAL300_50 = "eon-neutral300-50";
export const COLOR_NEUTRAL300_55 = "eon-neutral300-55";
export const COLOR_NEUTRAL300_60 = "eon-neutral300-60";
export const COLOR_NEUTRAL300_65 = "eon-neutral300-65";
export const COLOR_NEUTRAL300_70 = "eon-neutral300-70";
export const COLOR_NEUTRAL300_75 = "eon-neutral300-75";
export const COLOR_NEUTRAL300_80 = "eon-neutral300-80";
export const COLOR_NEUTRAL300_85 = "eon-neutral300-85";
export const COLOR_NEUTRAL300_90 = "eon-neutral300-90";
export const COLOR_NEUTRAL300_95 = "eon-neutral300-95";
export const COLOR_NEUTRAL300_OPACITY_5 = "eon-neutral300-opacity-5";
export const COLOR_NEUTRAL300_OPACITY_10 = "eon-neutral300-opacity-10";
export const COLOR_NEUTRAL300_OPACITY_15 = "eon-neutral300-opacity-15";
export const COLOR_NEUTRAL300_OPACITY_20 = "eon-neutral300-opacity-20";
export const COLOR_NEUTRAL300_OPACITY_25 = "eon-neutral300-opacity-25";
export const COLOR_NEUTRAL300_OPACITY_30 = "eon-neutral300-opacity-30";
export const COLOR_NEUTRAL300_OPACITY_35 = "eon-neutral300-opacity-35";
export const COLOR_NEUTRAL300_OPACITY_40 = "eon-neutral300-opacity-40";
export const COLOR_NEUTRAL300_OPACITY_45 = "eon-neutral300-opacity-45";
export const COLOR_NEUTRAL300_OPACITY_50 = "eon-neutral300-opacity-50";
export const COLOR_NEUTRAL300_OPACITY_55 = "eon-neutral300-opacity-55";
export const COLOR_NEUTRAL300_OPACITY_60 = "eon-neutral300-opacity-60";
export const COLOR_NEUTRAL300_OPACITY_65 = "eon-neutral300-opacity-65";
export const COLOR_NEUTRAL300_OPACITY_70 = "eon-neutral300-opacity-70";
export const COLOR_NEUTRAL300_OPACITY_75 = "eon-neutral300-opacity-75";
export const COLOR_NEUTRAL300_OPACITY_80 = "eon-neutral300-opacity-80";
export const COLOR_NEUTRAL300_OPACITY_85 = "eon-neutral300-opacity-85";
export const COLOR_NEUTRAL300_OPACITY_90 = "eon-neutral300-opacity-90";
export const COLOR_NEUTRAL300_OPACITY_95 = "eon-neutral300-opacity-95";
export const COLOR_NEUTRAL800_SHADE_1 = "eon-neutral800-shade-1";
export const COLOR_NEUTRAL800_SHADE_2 = "eon-neutral800-shade-2";
export const COLOR_NEUTRAL800_TINT_1 = "eon-neutral800-tint-1";
export const COLOR_NEUTRAL800_TINT_2 = "eon-neutral800-tint-2";
export const COLOR_NEUTRAL800_5 = "eon-neutral800-5";
export const COLOR_NEUTRAL800_10 = "eon-neutral800-10";
export const COLOR_NEUTRAL800_15 = "eon-neutral800-15";
export const COLOR_NEUTRAL800_20 = "eon-neutral800-20";
export const COLOR_NEUTRAL800_25 = "eon-neutral800-25";
export const COLOR_NEUTRAL800_30 = "eon-neutral800-30";
export const COLOR_NEUTRAL800_35 = "eon-neutral800-35";
export const COLOR_NEUTRAL800_40 = "eon-neutral800-40";
export const COLOR_NEUTRAL800_45 = "eon-neutral800-45";
export const COLOR_NEUTRAL800_50 = "eon-neutral800-50";
export const COLOR_NEUTRAL800_55 = "eon-neutral800-55";
export const COLOR_NEUTRAL800_60 = "eon-neutral800-60";
export const COLOR_NEUTRAL800_65 = "eon-neutral800-65";
export const COLOR_NEUTRAL800_70 = "eon-neutral800-70";
export const COLOR_NEUTRAL800_75 = "eon-neutral800-75";
export const COLOR_NEUTRAL800_80 = "eon-neutral800-80";
export const COLOR_NEUTRAL800_85 = "eon-neutral800-85";
export const COLOR_NEUTRAL800_90 = "eon-neutral800-90";
export const COLOR_NEUTRAL800_95 = "eon-neutral800-95";
export const COLOR_NEUTRAL800_OPACITY_5 = "eon-neutral800-opacity-5";
export const COLOR_NEUTRAL800_OPACITY_10 = "eon-neutral800-opacity-10";
export const COLOR_NEUTRAL800_OPACITY_15 = "eon-neutral800-opacity-15";
export const COLOR_NEUTRAL800_OPACITY_20 = "eon-neutral800-opacity-20";
export const COLOR_NEUTRAL800_OPACITY_25 = "eon-neutral800-opacity-25";
export const COLOR_NEUTRAL800_OPACITY_30 = "eon-neutral800-opacity-30";
export const COLOR_NEUTRAL800_OPACITY_35 = "eon-neutral800-opacity-35";
export const COLOR_NEUTRAL800_OPACITY_40 = "eon-neutral800-opacity-40";
export const COLOR_NEUTRAL800_OPACITY_45 = "eon-neutral800-opacity-45";
export const COLOR_NEUTRAL800_OPACITY_50 = "eon-neutral800-opacity-50";
export const COLOR_NEUTRAL800_OPACITY_55 = "eon-neutral800-opacity-55";
export const COLOR_NEUTRAL800_OPACITY_60 = "eon-neutral800-opacity-60";
export const COLOR_NEUTRAL800_OPACITY_65 = "eon-neutral800-opacity-65";
export const COLOR_NEUTRAL800_OPACITY_70 = "eon-neutral800-opacity-70";
export const COLOR_NEUTRAL800_OPACITY_75 = "eon-neutral800-opacity-75";
export const COLOR_NEUTRAL800_OPACITY_80 = "eon-neutral800-opacity-80";
export const COLOR_NEUTRAL800_OPACITY_85 = "eon-neutral800-opacity-85";
export const COLOR_NEUTRAL800_OPACITY_90 = "eon-neutral800-opacity-90";
export const COLOR_NEUTRAL800_OPACITY_95 = "eon-neutral800-opacity-95";
export const COLOR_RED100_SHADE_1 = "eon-red100-shade-1";
export const COLOR_RED100_SHADE_2 = "eon-red100-shade-2";
export const COLOR_RED100_TINT_1 = "eon-red100-tint-1";
export const COLOR_RED100_TINT_2 = "eon-red100-tint-2";
export const COLOR_RED100_5 = "eon-red100-5";
export const COLOR_RED100_10 = "eon-red100-10";
export const COLOR_RED100_15 = "eon-red100-15";
export const COLOR_RED100_20 = "eon-red100-20";
export const COLOR_RED100_25 = "eon-red100-25";
export const COLOR_RED100_30 = "eon-red100-30";
export const COLOR_RED100_35 = "eon-red100-35";
export const COLOR_RED100_40 = "eon-red100-40";
export const COLOR_RED100_45 = "eon-red100-45";
export const COLOR_RED100_50 = "eon-red100-50";
export const COLOR_RED100_55 = "eon-red100-55";
export const COLOR_RED100_60 = "eon-red100-60";
export const COLOR_RED100_65 = "eon-red100-65";
export const COLOR_RED100_70 = "eon-red100-70";
export const COLOR_RED100_75 = "eon-red100-75";
export const COLOR_RED100_80 = "eon-red100-80";
export const COLOR_RED100_85 = "eon-red100-85";
export const COLOR_RED100_90 = "eon-red100-90";
export const COLOR_RED100_95 = "eon-red100-95";
export const COLOR_RED100_OPACITY_5 = "eon-red100-opacity-5";
export const COLOR_RED100_OPACITY_10 = "eon-red100-opacity-10";
export const COLOR_RED100_OPACITY_15 = "eon-red100-opacity-15";
export const COLOR_RED100_OPACITY_20 = "eon-red100-opacity-20";
export const COLOR_RED100_OPACITY_25 = "eon-red100-opacity-25";
export const COLOR_RED100_OPACITY_30 = "eon-red100-opacity-30";
export const COLOR_RED100_OPACITY_35 = "eon-red100-opacity-35";
export const COLOR_RED100_OPACITY_40 = "eon-red100-opacity-40";
export const COLOR_RED100_OPACITY_45 = "eon-red100-opacity-45";
export const COLOR_RED100_OPACITY_50 = "eon-red100-opacity-50";
export const COLOR_RED100_OPACITY_55 = "eon-red100-opacity-55";
export const COLOR_RED100_OPACITY_60 = "eon-red100-opacity-60";
export const COLOR_RED100_OPACITY_65 = "eon-red100-opacity-65";
export const COLOR_RED100_OPACITY_70 = "eon-red100-opacity-70";
export const COLOR_RED100_OPACITY_75 = "eon-red100-opacity-75";
export const COLOR_RED100_OPACITY_80 = "eon-red100-opacity-80";
export const COLOR_RED100_OPACITY_85 = "eon-red100-opacity-85";
export const COLOR_RED100_OPACITY_90 = "eon-red100-opacity-90";
export const COLOR_RED100_OPACITY_95 = "eon-red100-opacity-95";
export const COLOR_RED300_SHADE_1 = "eon-red300-shade-1";
export const COLOR_RED300_SHADE_2 = "eon-red300-shade-2";
export const COLOR_RED300_TINT_1 = "eon-red300-tint-1";
export const COLOR_RED300_TINT_2 = "eon-red300-tint-2";
export const COLOR_RED300_5 = "eon-red300-5";
export const COLOR_RED300_10 = "eon-red300-10";
export const COLOR_RED300_15 = "eon-red300-15";
export const COLOR_RED300_20 = "eon-red300-20";
export const COLOR_RED300_25 = "eon-red300-25";
export const COLOR_RED300_30 = "eon-red300-30";
export const COLOR_RED300_35 = "eon-red300-35";
export const COLOR_RED300_40 = "eon-red300-40";
export const COLOR_RED300_45 = "eon-red300-45";
export const COLOR_RED300_50 = "eon-red300-50";
export const COLOR_RED300_55 = "eon-red300-55";
export const COLOR_RED300_60 = "eon-red300-60";
export const COLOR_RED300_65 = "eon-red300-65";
export const COLOR_RED300_70 = "eon-red300-70";
export const COLOR_RED300_75 = "eon-red300-75";
export const COLOR_RED300_80 = "eon-red300-80";
export const COLOR_RED300_85 = "eon-red300-85";
export const COLOR_RED300_90 = "eon-red300-90";
export const COLOR_RED300_95 = "eon-red300-95";
export const COLOR_RED300_OPACITY_5 = "eon-red300-opacity-5";
export const COLOR_RED300_OPACITY_10 = "eon-red300-opacity-10";
export const COLOR_RED300_OPACITY_15 = "eon-red300-opacity-15";
export const COLOR_RED300_OPACITY_20 = "eon-red300-opacity-20";
export const COLOR_RED300_OPACITY_25 = "eon-red300-opacity-25";
export const COLOR_RED300_OPACITY_30 = "eon-red300-opacity-30";
export const COLOR_RED300_OPACITY_35 = "eon-red300-opacity-35";
export const COLOR_RED300_OPACITY_40 = "eon-red300-opacity-40";
export const COLOR_RED300_OPACITY_45 = "eon-red300-opacity-45";
export const COLOR_RED300_OPACITY_50 = "eon-red300-opacity-50";
export const COLOR_RED300_OPACITY_55 = "eon-red300-opacity-55";
export const COLOR_RED300_OPACITY_60 = "eon-red300-opacity-60";
export const COLOR_RED300_OPACITY_65 = "eon-red300-opacity-65";
export const COLOR_RED300_OPACITY_70 = "eon-red300-opacity-70";
export const COLOR_RED300_OPACITY_75 = "eon-red300-opacity-75";
export const COLOR_RED300_OPACITY_80 = "eon-red300-opacity-80";
export const COLOR_RED300_OPACITY_85 = "eon-red300-opacity-85";
export const COLOR_RED300_OPACITY_90 = "eon-red300-opacity-90";
export const COLOR_RED300_OPACITY_95 = "eon-red300-opacity-95";
export const COLOR_RED500_SHADE_1 = "eon-red500-shade-1";
export const COLOR_RED500_SHADE_2 = "eon-red500-shade-2";
export const COLOR_RED500_TINT_1 = "eon-red500-tint-1";
export const COLOR_RED500_TINT_2 = "eon-red500-tint-2";
export const COLOR_RED500_5 = "eon-red500-5";
export const COLOR_RED500_10 = "eon-red500-10";
export const COLOR_RED500_15 = "eon-red500-15";
export const COLOR_RED500_20 = "eon-red500-20";
export const COLOR_RED500_25 = "eon-red500-25";
export const COLOR_RED500_30 = "eon-red500-30";
export const COLOR_RED500_35 = "eon-red500-35";
export const COLOR_RED500_40 = "eon-red500-40";
export const COLOR_RED500_45 = "eon-red500-45";
export const COLOR_RED500_50 = "eon-red500-50";
export const COLOR_RED500_55 = "eon-red500-55";
export const COLOR_RED500_60 = "eon-red500-60";
export const COLOR_RED500_65 = "eon-red500-65";
export const COLOR_RED500_70 = "eon-red500-70";
export const COLOR_RED500_75 = "eon-red500-75";
export const COLOR_RED500_80 = "eon-red500-80";
export const COLOR_RED500_85 = "eon-red500-85";
export const COLOR_RED500_90 = "eon-red500-90";
export const COLOR_RED500_95 = "eon-red500-95";
export const COLOR_RED500_OPACITY_5 = "eon-red500-opacity-5";
export const COLOR_RED500_OPACITY_10 = "eon-red500-opacity-10";
export const COLOR_RED500_OPACITY_15 = "eon-red500-opacity-15";
export const COLOR_RED500_OPACITY_20 = "eon-red500-opacity-20";
export const COLOR_RED500_OPACITY_25 = "eon-red500-opacity-25";
export const COLOR_RED500_OPACITY_30 = "eon-red500-opacity-30";
export const COLOR_RED500_OPACITY_35 = "eon-red500-opacity-35";
export const COLOR_RED500_OPACITY_40 = "eon-red500-opacity-40";
export const COLOR_RED500_OPACITY_45 = "eon-red500-opacity-45";
export const COLOR_RED500_OPACITY_50 = "eon-red500-opacity-50";
export const COLOR_RED500_OPACITY_55 = "eon-red500-opacity-55";
export const COLOR_RED500_OPACITY_60 = "eon-red500-opacity-60";
export const COLOR_RED500_OPACITY_65 = "eon-red500-opacity-65";
export const COLOR_RED500_OPACITY_70 = "eon-red500-opacity-70";
export const COLOR_RED500_OPACITY_75 = "eon-red500-opacity-75";
export const COLOR_RED500_OPACITY_80 = "eon-red500-opacity-80";
export const COLOR_RED500_OPACITY_85 = "eon-red500-opacity-85";
export const COLOR_RED500_OPACITY_90 = "eon-red500-opacity-90";
export const COLOR_RED500_OPACITY_95 = "eon-red500-opacity-95";
export const COLOR_RED800_SHADE_1 = "eon-red800-shade-1";
export const COLOR_RED800_SHADE_2 = "eon-red800-shade-2";
export const COLOR_RED800_TINT_1 = "eon-red800-tint-1";
export const COLOR_RED800_TINT_2 = "eon-red800-tint-2";
export const COLOR_RED800_5 = "eon-red800-5";
export const COLOR_RED800_10 = "eon-red800-10";
export const COLOR_RED800_15 = "eon-red800-15";
export const COLOR_RED800_20 = "eon-red800-20";
export const COLOR_RED800_25 = "eon-red800-25";
export const COLOR_RED800_30 = "eon-red800-30";
export const COLOR_RED800_35 = "eon-red800-35";
export const COLOR_RED800_40 = "eon-red800-40";
export const COLOR_RED800_45 = "eon-red800-45";
export const COLOR_RED800_50 = "eon-red800-50";
export const COLOR_RED800_55 = "eon-red800-55";
export const COLOR_RED800_60 = "eon-red800-60";
export const COLOR_RED800_65 = "eon-red800-65";
export const COLOR_RED800_70 = "eon-red800-70";
export const COLOR_RED800_75 = "eon-red800-75";
export const COLOR_RED800_80 = "eon-red800-80";
export const COLOR_RED800_85 = "eon-red800-85";
export const COLOR_RED800_90 = "eon-red800-90";
export const COLOR_RED800_95 = "eon-red800-95";
export const COLOR_RED800_OPACITY_5 = "eon-red800-opacity-5";
export const COLOR_RED800_OPACITY_10 = "eon-red800-opacity-10";
export const COLOR_RED800_OPACITY_15 = "eon-red800-opacity-15";
export const COLOR_RED800_OPACITY_20 = "eon-red800-opacity-20";
export const COLOR_RED800_OPACITY_25 = "eon-red800-opacity-25";
export const COLOR_RED800_OPACITY_30 = "eon-red800-opacity-30";
export const COLOR_RED800_OPACITY_35 = "eon-red800-opacity-35";
export const COLOR_RED800_OPACITY_40 = "eon-red800-opacity-40";
export const COLOR_RED800_OPACITY_45 = "eon-red800-opacity-45";
export const COLOR_RED800_OPACITY_50 = "eon-red800-opacity-50";
export const COLOR_RED800_OPACITY_55 = "eon-red800-opacity-55";
export const COLOR_RED800_OPACITY_60 = "eon-red800-opacity-60";
export const COLOR_RED800_OPACITY_65 = "eon-red800-opacity-65";
export const COLOR_RED800_OPACITY_70 = "eon-red800-opacity-70";
export const COLOR_RED800_OPACITY_75 = "eon-red800-opacity-75";
export const COLOR_RED800_OPACITY_80 = "eon-red800-opacity-80";
export const COLOR_RED800_OPACITY_85 = "eon-red800-opacity-85";
export const COLOR_RED800_OPACITY_90 = "eon-red800-opacity-90";
export const COLOR_RED800_OPACITY_95 = "eon-red800-opacity-95";
export const COLOR_YELLOW100_SHADE_1 = "eon-yellow100-shade-1";
export const COLOR_YELLOW100_SHADE_2 = "eon-yellow100-shade-2";
export const COLOR_YELLOW100_TINT_1 = "eon-yellow100-tint-1";
export const COLOR_YELLOW100_TINT_2 = "eon-yellow100-tint-2";
export const COLOR_YELLOW100_5 = "eon-yellow100-5";
export const COLOR_YELLOW100_10 = "eon-yellow100-10";
export const COLOR_YELLOW100_15 = "eon-yellow100-15";
export const COLOR_YELLOW100_20 = "eon-yellow100-20";
export const COLOR_YELLOW100_25 = "eon-yellow100-25";
export const COLOR_YELLOW100_30 = "eon-yellow100-30";
export const COLOR_YELLOW100_35 = "eon-yellow100-35";
export const COLOR_YELLOW100_40 = "eon-yellow100-40";
export const COLOR_YELLOW100_45 = "eon-yellow100-45";
export const COLOR_YELLOW100_50 = "eon-yellow100-50";
export const COLOR_YELLOW100_55 = "eon-yellow100-55";
export const COLOR_YELLOW100_60 = "eon-yellow100-60";
export const COLOR_YELLOW100_65 = "eon-yellow100-65";
export const COLOR_YELLOW100_70 = "eon-yellow100-70";
export const COLOR_YELLOW100_75 = "eon-yellow100-75";
export const COLOR_YELLOW100_80 = "eon-yellow100-80";
export const COLOR_YELLOW100_85 = "eon-yellow100-85";
export const COLOR_YELLOW100_90 = "eon-yellow100-90";
export const COLOR_YELLOW100_95 = "eon-yellow100-95";
export const COLOR_YELLOW100_OPACITY_5 = "eon-yellow100-opacity-5";
export const COLOR_YELLOW100_OPACITY_10 = "eon-yellow100-opacity-10";
export const COLOR_YELLOW100_OPACITY_15 = "eon-yellow100-opacity-15";
export const COLOR_YELLOW100_OPACITY_20 = "eon-yellow100-opacity-20";
export const COLOR_YELLOW100_OPACITY_25 = "eon-yellow100-opacity-25";
export const COLOR_YELLOW100_OPACITY_30 = "eon-yellow100-opacity-30";
export const COLOR_YELLOW100_OPACITY_35 = "eon-yellow100-opacity-35";
export const COLOR_YELLOW100_OPACITY_40 = "eon-yellow100-opacity-40";
export const COLOR_YELLOW100_OPACITY_45 = "eon-yellow100-opacity-45";
export const COLOR_YELLOW100_OPACITY_50 = "eon-yellow100-opacity-50";
export const COLOR_YELLOW100_OPACITY_55 = "eon-yellow100-opacity-55";
export const COLOR_YELLOW100_OPACITY_60 = "eon-yellow100-opacity-60";
export const COLOR_YELLOW100_OPACITY_65 = "eon-yellow100-opacity-65";
export const COLOR_YELLOW100_OPACITY_70 = "eon-yellow100-opacity-70";
export const COLOR_YELLOW100_OPACITY_75 = "eon-yellow100-opacity-75";
export const COLOR_YELLOW100_OPACITY_80 = "eon-yellow100-opacity-80";
export const COLOR_YELLOW100_OPACITY_85 = "eon-yellow100-opacity-85";
export const COLOR_YELLOW100_OPACITY_90 = "eon-yellow100-opacity-90";
export const COLOR_YELLOW100_OPACITY_95 = "eon-yellow100-opacity-95";
export const COLOR_YELLOW300_SHADE_1 = "eon-yellow300-shade-1";
export const COLOR_YELLOW300_SHADE_2 = "eon-yellow300-shade-2";
export const COLOR_YELLOW300_TINT_1 = "eon-yellow300-tint-1";
export const COLOR_YELLOW300_TINT_2 = "eon-yellow300-tint-2";
export const COLOR_YELLOW300_5 = "eon-yellow300-5";
export const COLOR_YELLOW300_10 = "eon-yellow300-10";
export const COLOR_YELLOW300_15 = "eon-yellow300-15";
export const COLOR_YELLOW300_20 = "eon-yellow300-20";
export const COLOR_YELLOW300_25 = "eon-yellow300-25";
export const COLOR_YELLOW300_30 = "eon-yellow300-30";
export const COLOR_YELLOW300_35 = "eon-yellow300-35";
export const COLOR_YELLOW300_40 = "eon-yellow300-40";
export const COLOR_YELLOW300_45 = "eon-yellow300-45";
export const COLOR_YELLOW300_50 = "eon-yellow300-50";
export const COLOR_YELLOW300_55 = "eon-yellow300-55";
export const COLOR_YELLOW300_60 = "eon-yellow300-60";
export const COLOR_YELLOW300_65 = "eon-yellow300-65";
export const COLOR_YELLOW300_70 = "eon-yellow300-70";
export const COLOR_YELLOW300_75 = "eon-yellow300-75";
export const COLOR_YELLOW300_80 = "eon-yellow300-80";
export const COLOR_YELLOW300_85 = "eon-yellow300-85";
export const COLOR_YELLOW300_90 = "eon-yellow300-90";
export const COLOR_YELLOW300_95 = "eon-yellow300-95";
export const COLOR_YELLOW300_OPACITY_5 = "eon-yellow300-opacity-5";
export const COLOR_YELLOW300_OPACITY_10 = "eon-yellow300-opacity-10";
export const COLOR_YELLOW300_OPACITY_15 = "eon-yellow300-opacity-15";
export const COLOR_YELLOW300_OPACITY_20 = "eon-yellow300-opacity-20";
export const COLOR_YELLOW300_OPACITY_25 = "eon-yellow300-opacity-25";
export const COLOR_YELLOW300_OPACITY_30 = "eon-yellow300-opacity-30";
export const COLOR_YELLOW300_OPACITY_35 = "eon-yellow300-opacity-35";
export const COLOR_YELLOW300_OPACITY_40 = "eon-yellow300-opacity-40";
export const COLOR_YELLOW300_OPACITY_45 = "eon-yellow300-opacity-45";
export const COLOR_YELLOW300_OPACITY_50 = "eon-yellow300-opacity-50";
export const COLOR_YELLOW300_OPACITY_55 = "eon-yellow300-opacity-55";
export const COLOR_YELLOW300_OPACITY_60 = "eon-yellow300-opacity-60";
export const COLOR_YELLOW300_OPACITY_65 = "eon-yellow300-opacity-65";
export const COLOR_YELLOW300_OPACITY_70 = "eon-yellow300-opacity-70";
export const COLOR_YELLOW300_OPACITY_75 = "eon-yellow300-opacity-75";
export const COLOR_YELLOW300_OPACITY_80 = "eon-yellow300-opacity-80";
export const COLOR_YELLOW300_OPACITY_85 = "eon-yellow300-opacity-85";
export const COLOR_YELLOW300_OPACITY_90 = "eon-yellow300-opacity-90";
export const COLOR_YELLOW300_OPACITY_95 = "eon-yellow300-opacity-95";
export const COLOR_YELLOW500_SHADE_1 = "eon-yellow500-shade-1";
export const COLOR_YELLOW500_SHADE_2 = "eon-yellow500-shade-2";
export const COLOR_YELLOW500_TINT_1 = "eon-yellow500-tint-1";
export const COLOR_YELLOW500_TINT_2 = "eon-yellow500-tint-2";
export const COLOR_YELLOW500_5 = "eon-yellow500-5";
export const COLOR_YELLOW500_10 = "eon-yellow500-10";
export const COLOR_YELLOW500_15 = "eon-yellow500-15";
export const COLOR_YELLOW500_20 = "eon-yellow500-20";
export const COLOR_YELLOW500_25 = "eon-yellow500-25";
export const COLOR_YELLOW500_30 = "eon-yellow500-30";
export const COLOR_YELLOW500_35 = "eon-yellow500-35";
export const COLOR_YELLOW500_40 = "eon-yellow500-40";
export const COLOR_YELLOW500_45 = "eon-yellow500-45";
export const COLOR_YELLOW500_50 = "eon-yellow500-50";
export const COLOR_YELLOW500_55 = "eon-yellow500-55";
export const COLOR_YELLOW500_60 = "eon-yellow500-60";
export const COLOR_YELLOW500_65 = "eon-yellow500-65";
export const COLOR_YELLOW500_70 = "eon-yellow500-70";
export const COLOR_YELLOW500_75 = "eon-yellow500-75";
export const COLOR_YELLOW500_80 = "eon-yellow500-80";
export const COLOR_YELLOW500_85 = "eon-yellow500-85";
export const COLOR_YELLOW500_90 = "eon-yellow500-90";
export const COLOR_YELLOW500_95 = "eon-yellow500-95";
export const COLOR_YELLOW500_OPACITY_5 = "eon-yellow500-opacity-5";
export const COLOR_YELLOW500_OPACITY_10 = "eon-yellow500-opacity-10";
export const COLOR_YELLOW500_OPACITY_15 = "eon-yellow500-opacity-15";
export const COLOR_YELLOW500_OPACITY_20 = "eon-yellow500-opacity-20";
export const COLOR_YELLOW500_OPACITY_25 = "eon-yellow500-opacity-25";
export const COLOR_YELLOW500_OPACITY_30 = "eon-yellow500-opacity-30";
export const COLOR_YELLOW500_OPACITY_35 = "eon-yellow500-opacity-35";
export const COLOR_YELLOW500_OPACITY_40 = "eon-yellow500-opacity-40";
export const COLOR_YELLOW500_OPACITY_45 = "eon-yellow500-opacity-45";
export const COLOR_YELLOW500_OPACITY_50 = "eon-yellow500-opacity-50";
export const COLOR_YELLOW500_OPACITY_55 = "eon-yellow500-opacity-55";
export const COLOR_YELLOW500_OPACITY_60 = "eon-yellow500-opacity-60";
export const COLOR_YELLOW500_OPACITY_65 = "eon-yellow500-opacity-65";
export const COLOR_YELLOW500_OPACITY_70 = "eon-yellow500-opacity-70";
export const COLOR_YELLOW500_OPACITY_75 = "eon-yellow500-opacity-75";
export const COLOR_YELLOW500_OPACITY_80 = "eon-yellow500-opacity-80";
export const COLOR_YELLOW500_OPACITY_85 = "eon-yellow500-opacity-85";
export const COLOR_YELLOW500_OPACITY_90 = "eon-yellow500-opacity-90";
export const COLOR_YELLOW500_OPACITY_95 = "eon-yellow500-opacity-95";
export const COLOR_TURQUOISE100_SHADE_1 = "eon-turquoise100-shade-1";
export const COLOR_TURQUOISE100_SHADE_2 = "eon-turquoise100-shade-2";
export const COLOR_TURQUOISE100_TINT_1 = "eon-turquoise100-tint-1";
export const COLOR_TURQUOISE100_TINT_2 = "eon-turquoise100-tint-2";
export const COLOR_TURQUOISE100_5 = "eon-turquoise100-5";
export const COLOR_TURQUOISE100_10 = "eon-turquoise100-10";
export const COLOR_TURQUOISE100_15 = "eon-turquoise100-15";
export const COLOR_TURQUOISE100_20 = "eon-turquoise100-20";
export const COLOR_TURQUOISE100_25 = "eon-turquoise100-25";
export const COLOR_TURQUOISE100_30 = "eon-turquoise100-30";
export const COLOR_TURQUOISE100_35 = "eon-turquoise100-35";
export const COLOR_TURQUOISE100_40 = "eon-turquoise100-40";
export const COLOR_TURQUOISE100_45 = "eon-turquoise100-45";
export const COLOR_TURQUOISE100_50 = "eon-turquoise100-50";
export const COLOR_TURQUOISE100_55 = "eon-turquoise100-55";
export const COLOR_TURQUOISE100_60 = "eon-turquoise100-60";
export const COLOR_TURQUOISE100_65 = "eon-turquoise100-65";
export const COLOR_TURQUOISE100_70 = "eon-turquoise100-70";
export const COLOR_TURQUOISE100_75 = "eon-turquoise100-75";
export const COLOR_TURQUOISE100_80 = "eon-turquoise100-80";
export const COLOR_TURQUOISE100_85 = "eon-turquoise100-85";
export const COLOR_TURQUOISE100_90 = "eon-turquoise100-90";
export const COLOR_TURQUOISE100_95 = "eon-turquoise100-95";
export const COLOR_TURQUOISE100_OPACITY_5 = "eon-turquoise100-opacity-5";
export const COLOR_TURQUOISE100_OPACITY_10 = "eon-turquoise100-opacity-10";
export const COLOR_TURQUOISE100_OPACITY_15 = "eon-turquoise100-opacity-15";
export const COLOR_TURQUOISE100_OPACITY_20 = "eon-turquoise100-opacity-20";
export const COLOR_TURQUOISE100_OPACITY_25 = "eon-turquoise100-opacity-25";
export const COLOR_TURQUOISE100_OPACITY_30 = "eon-turquoise100-opacity-30";
export const COLOR_TURQUOISE100_OPACITY_35 = "eon-turquoise100-opacity-35";
export const COLOR_TURQUOISE100_OPACITY_40 = "eon-turquoise100-opacity-40";
export const COLOR_TURQUOISE100_OPACITY_45 = "eon-turquoise100-opacity-45";
export const COLOR_TURQUOISE100_OPACITY_50 = "eon-turquoise100-opacity-50";
export const COLOR_TURQUOISE100_OPACITY_55 = "eon-turquoise100-opacity-55";
export const COLOR_TURQUOISE100_OPACITY_60 = "eon-turquoise100-opacity-60";
export const COLOR_TURQUOISE100_OPACITY_65 = "eon-turquoise100-opacity-65";
export const COLOR_TURQUOISE100_OPACITY_70 = "eon-turquoise100-opacity-70";
export const COLOR_TURQUOISE100_OPACITY_75 = "eon-turquoise100-opacity-75";
export const COLOR_TURQUOISE100_OPACITY_80 = "eon-turquoise100-opacity-80";
export const COLOR_TURQUOISE100_OPACITY_85 = "eon-turquoise100-opacity-85";
export const COLOR_TURQUOISE100_OPACITY_90 = "eon-turquoise100-opacity-90";
export const COLOR_TURQUOISE100_OPACITY_95 = "eon-turquoise100-opacity-95";
export const COLOR_TURQUOISE300_SHADE_1 = "eon-turquoise300-shade-1";
export const COLOR_TURQUOISE300_SHADE_2 = "eon-turquoise300-shade-2";
export const COLOR_TURQUOISE300_TINT_1 = "eon-turquoise300-tint-1";
export const COLOR_TURQUOISE300_TINT_2 = "eon-turquoise300-tint-2";
export const COLOR_TURQUOISE300_5 = "eon-turquoise300-5";
export const COLOR_TURQUOISE300_10 = "eon-turquoise300-10";
export const COLOR_TURQUOISE300_15 = "eon-turquoise300-15";
export const COLOR_TURQUOISE300_20 = "eon-turquoise300-20";
export const COLOR_TURQUOISE300_25 = "eon-turquoise300-25";
export const COLOR_TURQUOISE300_30 = "eon-turquoise300-30";
export const COLOR_TURQUOISE300_35 = "eon-turquoise300-35";
export const COLOR_TURQUOISE300_40 = "eon-turquoise300-40";
export const COLOR_TURQUOISE300_45 = "eon-turquoise300-45";
export const COLOR_TURQUOISE300_50 = "eon-turquoise300-50";
export const COLOR_TURQUOISE300_55 = "eon-turquoise300-55";
export const COLOR_TURQUOISE300_60 = "eon-turquoise300-60";
export const COLOR_TURQUOISE300_65 = "eon-turquoise300-65";
export const COLOR_TURQUOISE300_70 = "eon-turquoise300-70";
export const COLOR_TURQUOISE300_75 = "eon-turquoise300-75";
export const COLOR_TURQUOISE300_80 = "eon-turquoise300-80";
export const COLOR_TURQUOISE300_85 = "eon-turquoise300-85";
export const COLOR_TURQUOISE300_90 = "eon-turquoise300-90";
export const COLOR_TURQUOISE300_95 = "eon-turquoise300-95";
export const COLOR_TURQUOISE300_OPACITY_5 = "eon-turquoise300-opacity-5";
export const COLOR_TURQUOISE300_OPACITY_10 = "eon-turquoise300-opacity-10";
export const COLOR_TURQUOISE300_OPACITY_15 = "eon-turquoise300-opacity-15";
export const COLOR_TURQUOISE300_OPACITY_20 = "eon-turquoise300-opacity-20";
export const COLOR_TURQUOISE300_OPACITY_25 = "eon-turquoise300-opacity-25";
export const COLOR_TURQUOISE300_OPACITY_30 = "eon-turquoise300-opacity-30";
export const COLOR_TURQUOISE300_OPACITY_35 = "eon-turquoise300-opacity-35";
export const COLOR_TURQUOISE300_OPACITY_40 = "eon-turquoise300-opacity-40";
export const COLOR_TURQUOISE300_OPACITY_45 = "eon-turquoise300-opacity-45";
export const COLOR_TURQUOISE300_OPACITY_50 = "eon-turquoise300-opacity-50";
export const COLOR_TURQUOISE300_OPACITY_55 = "eon-turquoise300-opacity-55";
export const COLOR_TURQUOISE300_OPACITY_60 = "eon-turquoise300-opacity-60";
export const COLOR_TURQUOISE300_OPACITY_65 = "eon-turquoise300-opacity-65";
export const COLOR_TURQUOISE300_OPACITY_70 = "eon-turquoise300-opacity-70";
export const COLOR_TURQUOISE300_OPACITY_75 = "eon-turquoise300-opacity-75";
export const COLOR_TURQUOISE300_OPACITY_80 = "eon-turquoise300-opacity-80";
export const COLOR_TURQUOISE300_OPACITY_85 = "eon-turquoise300-opacity-85";
export const COLOR_TURQUOISE300_OPACITY_90 = "eon-turquoise300-opacity-90";
export const COLOR_TURQUOISE300_OPACITY_95 = "eon-turquoise300-opacity-95";
export const COLOR_TURQUOISE500_SHADE_1 = "eon-turquoise500-shade-1";
export const COLOR_TURQUOISE500_SHADE_2 = "eon-turquoise500-shade-2";
export const COLOR_TURQUOISE500_TINT_1 = "eon-turquoise500-tint-1";
export const COLOR_TURQUOISE500_TINT_2 = "eon-turquoise500-tint-2";
export const COLOR_TURQUOISE500_5 = "eon-turquoise500-5";
export const COLOR_TURQUOISE500_10 = "eon-turquoise500-10";
export const COLOR_TURQUOISE500_15 = "eon-turquoise500-15";
export const COLOR_TURQUOISE500_20 = "eon-turquoise500-20";
export const COLOR_TURQUOISE500_25 = "eon-turquoise500-25";
export const COLOR_TURQUOISE500_30 = "eon-turquoise500-30";
export const COLOR_TURQUOISE500_35 = "eon-turquoise500-35";
export const COLOR_TURQUOISE500_40 = "eon-turquoise500-40";
export const COLOR_TURQUOISE500_45 = "eon-turquoise500-45";
export const COLOR_TURQUOISE500_50 = "eon-turquoise500-50";
export const COLOR_TURQUOISE500_55 = "eon-turquoise500-55";
export const COLOR_TURQUOISE500_60 = "eon-turquoise500-60";
export const COLOR_TURQUOISE500_65 = "eon-turquoise500-65";
export const COLOR_TURQUOISE500_70 = "eon-turquoise500-70";
export const COLOR_TURQUOISE500_75 = "eon-turquoise500-75";
export const COLOR_TURQUOISE500_80 = "eon-turquoise500-80";
export const COLOR_TURQUOISE500_85 = "eon-turquoise500-85";
export const COLOR_TURQUOISE500_90 = "eon-turquoise500-90";
export const COLOR_TURQUOISE500_95 = "eon-turquoise500-95";
export const COLOR_TURQUOISE500_OPACITY_5 = "eon-turquoise500-opacity-5";
export const COLOR_TURQUOISE500_OPACITY_10 = "eon-turquoise500-opacity-10";
export const COLOR_TURQUOISE500_OPACITY_15 = "eon-turquoise500-opacity-15";
export const COLOR_TURQUOISE500_OPACITY_20 = "eon-turquoise500-opacity-20";
export const COLOR_TURQUOISE500_OPACITY_25 = "eon-turquoise500-opacity-25";
export const COLOR_TURQUOISE500_OPACITY_30 = "eon-turquoise500-opacity-30";
export const COLOR_TURQUOISE500_OPACITY_35 = "eon-turquoise500-opacity-35";
export const COLOR_TURQUOISE500_OPACITY_40 = "eon-turquoise500-opacity-40";
export const COLOR_TURQUOISE500_OPACITY_45 = "eon-turquoise500-opacity-45";
export const COLOR_TURQUOISE500_OPACITY_50 = "eon-turquoise500-opacity-50";
export const COLOR_TURQUOISE500_OPACITY_55 = "eon-turquoise500-opacity-55";
export const COLOR_TURQUOISE500_OPACITY_60 = "eon-turquoise500-opacity-60";
export const COLOR_TURQUOISE500_OPACITY_65 = "eon-turquoise500-opacity-65";
export const COLOR_TURQUOISE500_OPACITY_70 = "eon-turquoise500-opacity-70";
export const COLOR_TURQUOISE500_OPACITY_75 = "eon-turquoise500-opacity-75";
export const COLOR_TURQUOISE500_OPACITY_80 = "eon-turquoise500-opacity-80";
export const COLOR_TURQUOISE500_OPACITY_85 = "eon-turquoise500-opacity-85";
export const COLOR_TURQUOISE500_OPACITY_90 = "eon-turquoise500-opacity-90";
export const COLOR_TURQUOISE500_OPACITY_95 = "eon-turquoise500-opacity-95";

export const EON_COLORS = [
  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_GREY100,
  COLOR_GREY900,
  COLOR_NEUTRAL100,
  COLOR_NEUTRAL300,
  COLOR_NEUTRAL800,
  COLOR_RED100,
  COLOR_RED300,
  COLOR_RED500,
  COLOR_RED800,
  COLOR_YELLOW100,
  COLOR_YELLOW300,
  COLOR_YELLOW500,
  COLOR_TURQUOISE100,
  COLOR_TURQUOISE300,
  COLOR_TURQUOISE500,
  COLOR_BRIGHT_SHADE_1,
  COLOR_BRIGHT_SHADE_2,
  COLOR_BRIGHT_TINT_1,
  COLOR_BRIGHT_TINT_2,
  COLOR_BRIGHT_5,
  COLOR_BRIGHT_10,
  COLOR_BRIGHT_15,
  COLOR_BRIGHT_20,
  COLOR_BRIGHT_25,
  COLOR_BRIGHT_30,
  COLOR_BRIGHT_35,
  COLOR_BRIGHT_40,
  COLOR_BRIGHT_45,
  COLOR_BRIGHT_50,
  COLOR_BRIGHT_55,
  COLOR_BRIGHT_60,
  COLOR_BRIGHT_65,
  COLOR_BRIGHT_70,
  COLOR_BRIGHT_75,
  COLOR_BRIGHT_80,
  COLOR_BRIGHT_85,
  COLOR_BRIGHT_90,
  COLOR_BRIGHT_95,
  COLOR_BRIGHT_OPACITY_5,
  COLOR_BRIGHT_OPACITY_10,
  COLOR_BRIGHT_OPACITY_15,
  COLOR_BRIGHT_OPACITY_20,
  COLOR_BRIGHT_OPACITY_25,
  COLOR_BRIGHT_OPACITY_30,
  COLOR_BRIGHT_OPACITY_35,
  COLOR_BRIGHT_OPACITY_40,
  COLOR_BRIGHT_OPACITY_45,
  COLOR_BRIGHT_OPACITY_50,
  COLOR_BRIGHT_OPACITY_55,
  COLOR_BRIGHT_OPACITY_60,
  COLOR_BRIGHT_OPACITY_65,
  COLOR_BRIGHT_OPACITY_70,
  COLOR_BRIGHT_OPACITY_75,
  COLOR_BRIGHT_OPACITY_80,
  COLOR_BRIGHT_OPACITY_85,
  COLOR_BRIGHT_OPACITY_90,
  COLOR_BRIGHT_OPACITY_95,
  COLOR_DARK_SHADE_1,
  COLOR_DARK_SHADE_2,
  COLOR_DARK_TINT_1,
  COLOR_DARK_TINT_2,
  COLOR_DARK_5,
  COLOR_DARK_10,
  COLOR_DARK_15,
  COLOR_DARK_20,
  COLOR_DARK_25,
  COLOR_DARK_30,
  COLOR_DARK_35,
  COLOR_DARK_40,
  COLOR_DARK_45,
  COLOR_DARK_50,
  COLOR_DARK_55,
  COLOR_DARK_60,
  COLOR_DARK_65,
  COLOR_DARK_70,
  COLOR_DARK_75,
  COLOR_DARK_80,
  COLOR_DARK_85,
  COLOR_DARK_90,
  COLOR_DARK_95,
  COLOR_DARK_OPACITY_5,
  COLOR_DARK_OPACITY_10,
  COLOR_DARK_OPACITY_15,
  COLOR_DARK_OPACITY_20,
  COLOR_DARK_OPACITY_25,
  COLOR_DARK_OPACITY_30,
  COLOR_DARK_OPACITY_35,
  COLOR_DARK_OPACITY_40,
  COLOR_DARK_OPACITY_45,
  COLOR_DARK_OPACITY_50,
  COLOR_DARK_OPACITY_55,
  COLOR_DARK_OPACITY_60,
  COLOR_DARK_OPACITY_65,
  COLOR_DARK_OPACITY_70,
  COLOR_DARK_OPACITY_75,
  COLOR_DARK_OPACITY_80,
  COLOR_DARK_OPACITY_85,
  COLOR_DARK_OPACITY_90,
  COLOR_DARK_OPACITY_95,
  COLOR_WHITE_SHADE_1,
  COLOR_WHITE_SHADE_2,
  COLOR_WHITE_TINT_1,
  COLOR_WHITE_TINT_2,
  COLOR_WHITE_5,
  COLOR_WHITE_10,
  COLOR_WHITE_15,
  COLOR_WHITE_20,
  COLOR_WHITE_25,
  COLOR_WHITE_30,
  COLOR_WHITE_35,
  COLOR_WHITE_40,
  COLOR_WHITE_45,
  COLOR_WHITE_50,
  COLOR_WHITE_55,
  COLOR_WHITE_60,
  COLOR_WHITE_65,
  COLOR_WHITE_70,
  COLOR_WHITE_75,
  COLOR_WHITE_80,
  COLOR_WHITE_85,
  COLOR_WHITE_90,
  COLOR_WHITE_95,
  COLOR_WHITE_OPACITY_5,
  COLOR_WHITE_OPACITY_10,
  COLOR_WHITE_OPACITY_15,
  COLOR_WHITE_OPACITY_20,
  COLOR_WHITE_OPACITY_25,
  COLOR_WHITE_OPACITY_30,
  COLOR_WHITE_OPACITY_35,
  COLOR_WHITE_OPACITY_40,
  COLOR_WHITE_OPACITY_45,
  COLOR_WHITE_OPACITY_50,
  COLOR_WHITE_OPACITY_55,
  COLOR_WHITE_OPACITY_60,
  COLOR_WHITE_OPACITY_65,
  COLOR_WHITE_OPACITY_70,
  COLOR_WHITE_OPACITY_75,
  COLOR_WHITE_OPACITY_80,
  COLOR_WHITE_OPACITY_85,
  COLOR_WHITE_OPACITY_90,
  COLOR_WHITE_OPACITY_95,
  COLOR_BLACK_SHADE_1,
  COLOR_BLACK_SHADE_2,
  COLOR_BLACK_TINT_1,
  COLOR_BLACK_TINT_2,
  COLOR_BLACK_5,
  COLOR_BLACK_10,
  COLOR_BLACK_15,
  COLOR_BLACK_20,
  COLOR_BLACK_25,
  COLOR_BLACK_30,
  COLOR_BLACK_35,
  COLOR_BLACK_40,
  COLOR_BLACK_45,
  COLOR_BLACK_50,
  COLOR_BLACK_55,
  COLOR_BLACK_60,
  COLOR_BLACK_65,
  COLOR_BLACK_70,
  COLOR_BLACK_75,
  COLOR_BLACK_80,
  COLOR_BLACK_85,
  COLOR_BLACK_90,
  COLOR_BLACK_95,
  COLOR_BLACK_OPACITY_5,
  COLOR_BLACK_OPACITY_10,
  COLOR_BLACK_OPACITY_15,
  COLOR_BLACK_OPACITY_20,
  COLOR_BLACK_OPACITY_25,
  COLOR_BLACK_OPACITY_30,
  COLOR_BLACK_OPACITY_35,
  COLOR_BLACK_OPACITY_40,
  COLOR_BLACK_OPACITY_45,
  COLOR_BLACK_OPACITY_50,
  COLOR_BLACK_OPACITY_55,
  COLOR_BLACK_OPACITY_60,
  COLOR_BLACK_OPACITY_65,
  COLOR_BLACK_OPACITY_70,
  COLOR_BLACK_OPACITY_75,
  COLOR_BLACK_OPACITY_80,
  COLOR_BLACK_OPACITY_85,
  COLOR_BLACK_OPACITY_90,
  COLOR_BLACK_OPACITY_95,
  COLOR_GREY100_SHADE_1,
  COLOR_GREY100_SHADE_2,
  COLOR_GREY100_TINT_1,
  COLOR_GREY100_TINT_2,
  COLOR_GREY100_5,
  COLOR_GREY100_10,
  COLOR_GREY100_15,
  COLOR_GREY100_20,
  COLOR_GREY100_25,
  COLOR_GREY100_30,
  COLOR_GREY100_35,
  COLOR_GREY100_40,
  COLOR_GREY100_45,
  COLOR_GREY100_50,
  COLOR_GREY100_55,
  COLOR_GREY100_60,
  COLOR_GREY100_65,
  COLOR_GREY100_70,
  COLOR_GREY100_75,
  COLOR_GREY100_80,
  COLOR_GREY100_85,
  COLOR_GREY100_90,
  COLOR_GREY100_95,
  COLOR_GREY100_OPACITY_5,
  COLOR_GREY100_OPACITY_10,
  COLOR_GREY100_OPACITY_15,
  COLOR_GREY100_OPACITY_20,
  COLOR_GREY100_OPACITY_25,
  COLOR_GREY100_OPACITY_30,
  COLOR_GREY100_OPACITY_35,
  COLOR_GREY100_OPACITY_40,
  COLOR_GREY100_OPACITY_45,
  COLOR_GREY100_OPACITY_50,
  COLOR_GREY100_OPACITY_55,
  COLOR_GREY100_OPACITY_60,
  COLOR_GREY100_OPACITY_65,
  COLOR_GREY100_OPACITY_70,
  COLOR_GREY100_OPACITY_75,
  COLOR_GREY100_OPACITY_80,
  COLOR_GREY100_OPACITY_85,
  COLOR_GREY100_OPACITY_90,
  COLOR_GREY100_OPACITY_95,
  COLOR_GREY900_SHADE_1,
  COLOR_GREY900_SHADE_2,
  COLOR_GREY900_TINT_1,
  COLOR_GREY900_TINT_2,
  COLOR_GREY900_5,
  COLOR_GREY900_10,
  COLOR_GREY900_15,
  COLOR_GREY900_20,
  COLOR_GREY900_25,
  COLOR_GREY900_30,
  COLOR_GREY900_35,
  COLOR_GREY900_40,
  COLOR_GREY900_45,
  COLOR_GREY900_50,
  COLOR_GREY900_55,
  COLOR_GREY900_60,
  COLOR_GREY900_65,
  COLOR_GREY900_70,
  COLOR_GREY900_75,
  COLOR_GREY900_80,
  COLOR_GREY900_85,
  COLOR_GREY900_90,
  COLOR_GREY900_95,
  COLOR_GREY900_OPACITY_5,
  COLOR_GREY900_OPACITY_10,
  COLOR_GREY900_OPACITY_15,
  COLOR_GREY900_OPACITY_20,
  COLOR_GREY900_OPACITY_25,
  COLOR_GREY900_OPACITY_30,
  COLOR_GREY900_OPACITY_35,
  COLOR_GREY900_OPACITY_40,
  COLOR_GREY900_OPACITY_45,
  COLOR_GREY900_OPACITY_50,
  COLOR_GREY900_OPACITY_55,
  COLOR_GREY900_OPACITY_60,
  COLOR_GREY900_OPACITY_65,
  COLOR_GREY900_OPACITY_70,
  COLOR_GREY900_OPACITY_75,
  COLOR_GREY900_OPACITY_80,
  COLOR_GREY900_OPACITY_85,
  COLOR_GREY900_OPACITY_90,
  COLOR_GREY900_OPACITY_95,
  COLOR_NEUTRAL100_SHADE_1,
  COLOR_NEUTRAL100_SHADE_2,
  COLOR_NEUTRAL100_TINT_1,
  COLOR_NEUTRAL100_TINT_2,
  COLOR_NEUTRAL100_5,
  COLOR_NEUTRAL100_10,
  COLOR_NEUTRAL100_15,
  COLOR_NEUTRAL100_20,
  COLOR_NEUTRAL100_25,
  COLOR_NEUTRAL100_30,
  COLOR_NEUTRAL100_35,
  COLOR_NEUTRAL100_40,
  COLOR_NEUTRAL100_45,
  COLOR_NEUTRAL100_50,
  COLOR_NEUTRAL100_55,
  COLOR_NEUTRAL100_60,
  COLOR_NEUTRAL100_65,
  COLOR_NEUTRAL100_70,
  COLOR_NEUTRAL100_75,
  COLOR_NEUTRAL100_80,
  COLOR_NEUTRAL100_85,
  COLOR_NEUTRAL100_90,
  COLOR_NEUTRAL100_95,
  COLOR_NEUTRAL100_OPACITY_5,
  COLOR_NEUTRAL100_OPACITY_10,
  COLOR_NEUTRAL100_OPACITY_15,
  COLOR_NEUTRAL100_OPACITY_20,
  COLOR_NEUTRAL100_OPACITY_25,
  COLOR_NEUTRAL100_OPACITY_30,
  COLOR_NEUTRAL100_OPACITY_35,
  COLOR_NEUTRAL100_OPACITY_40,
  COLOR_NEUTRAL100_OPACITY_45,
  COLOR_NEUTRAL100_OPACITY_50,
  COLOR_NEUTRAL100_OPACITY_55,
  COLOR_NEUTRAL100_OPACITY_60,
  COLOR_NEUTRAL100_OPACITY_65,
  COLOR_NEUTRAL100_OPACITY_70,
  COLOR_NEUTRAL100_OPACITY_75,
  COLOR_NEUTRAL100_OPACITY_80,
  COLOR_NEUTRAL100_OPACITY_85,
  COLOR_NEUTRAL100_OPACITY_90,
  COLOR_NEUTRAL100_OPACITY_95,
  COLOR_NEUTRAL300_SHADE_1,
  COLOR_NEUTRAL300_SHADE_2,
  COLOR_NEUTRAL300_TINT_1,
  COLOR_NEUTRAL300_TINT_2,
  COLOR_NEUTRAL300_5,
  COLOR_NEUTRAL300_10,
  COLOR_NEUTRAL300_15,
  COLOR_NEUTRAL300_20,
  COLOR_NEUTRAL300_25,
  COLOR_NEUTRAL300_30,
  COLOR_NEUTRAL300_35,
  COLOR_NEUTRAL300_40,
  COLOR_NEUTRAL300_45,
  COLOR_NEUTRAL300_50,
  COLOR_NEUTRAL300_55,
  COLOR_NEUTRAL300_60,
  COLOR_NEUTRAL300_65,
  COLOR_NEUTRAL300_70,
  COLOR_NEUTRAL300_75,
  COLOR_NEUTRAL300_80,
  COLOR_NEUTRAL300_85,
  COLOR_NEUTRAL300_90,
  COLOR_NEUTRAL300_95,
  COLOR_NEUTRAL300_OPACITY_5,
  COLOR_NEUTRAL300_OPACITY_10,
  COLOR_NEUTRAL300_OPACITY_15,
  COLOR_NEUTRAL300_OPACITY_20,
  COLOR_NEUTRAL300_OPACITY_25,
  COLOR_NEUTRAL300_OPACITY_30,
  COLOR_NEUTRAL300_OPACITY_35,
  COLOR_NEUTRAL300_OPACITY_40,
  COLOR_NEUTRAL300_OPACITY_45,
  COLOR_NEUTRAL300_OPACITY_50,
  COLOR_NEUTRAL300_OPACITY_55,
  COLOR_NEUTRAL300_OPACITY_60,
  COLOR_NEUTRAL300_OPACITY_65,
  COLOR_NEUTRAL300_OPACITY_70,
  COLOR_NEUTRAL300_OPACITY_75,
  COLOR_NEUTRAL300_OPACITY_80,
  COLOR_NEUTRAL300_OPACITY_85,
  COLOR_NEUTRAL300_OPACITY_90,
  COLOR_NEUTRAL300_OPACITY_95,
  COLOR_NEUTRAL800_SHADE_1,
  COLOR_NEUTRAL800_SHADE_2,
  COLOR_NEUTRAL800_TINT_1,
  COLOR_NEUTRAL800_TINT_2,
  COLOR_NEUTRAL800_5,
  COLOR_NEUTRAL800_10,
  COLOR_NEUTRAL800_15,
  COLOR_NEUTRAL800_20,
  COLOR_NEUTRAL800_25,
  COLOR_NEUTRAL800_30,
  COLOR_NEUTRAL800_35,
  COLOR_NEUTRAL800_40,
  COLOR_NEUTRAL800_45,
  COLOR_NEUTRAL800_50,
  COLOR_NEUTRAL800_55,
  COLOR_NEUTRAL800_60,
  COLOR_NEUTRAL800_65,
  COLOR_NEUTRAL800_70,
  COLOR_NEUTRAL800_75,
  COLOR_NEUTRAL800_80,
  COLOR_NEUTRAL800_85,
  COLOR_NEUTRAL800_90,
  COLOR_NEUTRAL800_95,
  COLOR_NEUTRAL800_OPACITY_5,
  COLOR_NEUTRAL800_OPACITY_10,
  COLOR_NEUTRAL800_OPACITY_15,
  COLOR_NEUTRAL800_OPACITY_20,
  COLOR_NEUTRAL800_OPACITY_25,
  COLOR_NEUTRAL800_OPACITY_30,
  COLOR_NEUTRAL800_OPACITY_35,
  COLOR_NEUTRAL800_OPACITY_40,
  COLOR_NEUTRAL800_OPACITY_45,
  COLOR_NEUTRAL800_OPACITY_50,
  COLOR_NEUTRAL800_OPACITY_55,
  COLOR_NEUTRAL800_OPACITY_60,
  COLOR_NEUTRAL800_OPACITY_65,
  COLOR_NEUTRAL800_OPACITY_70,
  COLOR_NEUTRAL800_OPACITY_75,
  COLOR_NEUTRAL800_OPACITY_80,
  COLOR_NEUTRAL800_OPACITY_85,
  COLOR_NEUTRAL800_OPACITY_90,
  COLOR_NEUTRAL800_OPACITY_95,
  COLOR_RED100_SHADE_1,
  COLOR_RED100_SHADE_2,
  COLOR_RED100_TINT_1,
  COLOR_RED100_TINT_2,
  COLOR_RED100_5,
  COLOR_RED100_10,
  COLOR_RED100_15,
  COLOR_RED100_20,
  COLOR_RED100_25,
  COLOR_RED100_30,
  COLOR_RED100_35,
  COLOR_RED100_40,
  COLOR_RED100_45,
  COLOR_RED100_50,
  COLOR_RED100_55,
  COLOR_RED100_60,
  COLOR_RED100_65,
  COLOR_RED100_70,
  COLOR_RED100_75,
  COLOR_RED100_80,
  COLOR_RED100_85,
  COLOR_RED100_90,
  COLOR_RED100_95,
  COLOR_RED100_OPACITY_5,
  COLOR_RED100_OPACITY_10,
  COLOR_RED100_OPACITY_15,
  COLOR_RED100_OPACITY_20,
  COLOR_RED100_OPACITY_25,
  COLOR_RED100_OPACITY_30,
  COLOR_RED100_OPACITY_35,
  COLOR_RED100_OPACITY_40,
  COLOR_RED100_OPACITY_45,
  COLOR_RED100_OPACITY_50,
  COLOR_RED100_OPACITY_55,
  COLOR_RED100_OPACITY_60,
  COLOR_RED100_OPACITY_65,
  COLOR_RED100_OPACITY_70,
  COLOR_RED100_OPACITY_75,
  COLOR_RED100_OPACITY_80,
  COLOR_RED100_OPACITY_85,
  COLOR_RED100_OPACITY_90,
  COLOR_RED100_OPACITY_95,
  COLOR_RED300_SHADE_1,
  COLOR_RED300_SHADE_2,
  COLOR_RED300_TINT_1,
  COLOR_RED300_TINT_2,
  COLOR_RED300_5,
  COLOR_RED300_10,
  COLOR_RED300_15,
  COLOR_RED300_20,
  COLOR_RED300_25,
  COLOR_RED300_30,
  COLOR_RED300_35,
  COLOR_RED300_40,
  COLOR_RED300_45,
  COLOR_RED300_50,
  COLOR_RED300_55,
  COLOR_RED300_60,
  COLOR_RED300_65,
  COLOR_RED300_70,
  COLOR_RED300_75,
  COLOR_RED300_80,
  COLOR_RED300_85,
  COLOR_RED300_90,
  COLOR_RED300_95,
  COLOR_RED300_OPACITY_5,
  COLOR_RED300_OPACITY_10,
  COLOR_RED300_OPACITY_15,
  COLOR_RED300_OPACITY_20,
  COLOR_RED300_OPACITY_25,
  COLOR_RED300_OPACITY_30,
  COLOR_RED300_OPACITY_35,
  COLOR_RED300_OPACITY_40,
  COLOR_RED300_OPACITY_45,
  COLOR_RED300_OPACITY_50,
  COLOR_RED300_OPACITY_55,
  COLOR_RED300_OPACITY_60,
  COLOR_RED300_OPACITY_65,
  COLOR_RED300_OPACITY_70,
  COLOR_RED300_OPACITY_75,
  COLOR_RED300_OPACITY_80,
  COLOR_RED300_OPACITY_85,
  COLOR_RED300_OPACITY_90,
  COLOR_RED300_OPACITY_95,
  COLOR_RED500_SHADE_1,
  COLOR_RED500_SHADE_2,
  COLOR_RED500_TINT_1,
  COLOR_RED500_TINT_2,
  COLOR_RED500_5,
  COLOR_RED500_10,
  COLOR_RED500_15,
  COLOR_RED500_20,
  COLOR_RED500_25,
  COLOR_RED500_30,
  COLOR_RED500_35,
  COLOR_RED500_40,
  COLOR_RED500_45,
  COLOR_RED500_50,
  COLOR_RED500_55,
  COLOR_RED500_60,
  COLOR_RED500_65,
  COLOR_RED500_70,
  COLOR_RED500_75,
  COLOR_RED500_80,
  COLOR_RED500_85,
  COLOR_RED500_90,
  COLOR_RED500_95,
  COLOR_RED500_OPACITY_5,
  COLOR_RED500_OPACITY_10,
  COLOR_RED500_OPACITY_15,
  COLOR_RED500_OPACITY_20,
  COLOR_RED500_OPACITY_25,
  COLOR_RED500_OPACITY_30,
  COLOR_RED500_OPACITY_35,
  COLOR_RED500_OPACITY_40,
  COLOR_RED500_OPACITY_45,
  COLOR_RED500_OPACITY_50,
  COLOR_RED500_OPACITY_55,
  COLOR_RED500_OPACITY_60,
  COLOR_RED500_OPACITY_65,
  COLOR_RED500_OPACITY_70,
  COLOR_RED500_OPACITY_75,
  COLOR_RED500_OPACITY_80,
  COLOR_RED500_OPACITY_85,
  COLOR_RED500_OPACITY_90,
  COLOR_RED500_OPACITY_95,
  COLOR_RED800_SHADE_1,
  COLOR_RED800_SHADE_2,
  COLOR_RED800_TINT_1,
  COLOR_RED800_TINT_2,
  COLOR_RED800_5,
  COLOR_RED800_10,
  COLOR_RED800_15,
  COLOR_RED800_20,
  COLOR_RED800_25,
  COLOR_RED800_30,
  COLOR_RED800_35,
  COLOR_RED800_40,
  COLOR_RED800_45,
  COLOR_RED800_50,
  COLOR_RED800_55,
  COLOR_RED800_60,
  COLOR_RED800_65,
  COLOR_RED800_70,
  COLOR_RED800_75,
  COLOR_RED800_80,
  COLOR_RED800_85,
  COLOR_RED800_90,
  COLOR_RED800_95,
  COLOR_RED800_OPACITY_5,
  COLOR_RED800_OPACITY_10,
  COLOR_RED800_OPACITY_15,
  COLOR_RED800_OPACITY_20,
  COLOR_RED800_OPACITY_25,
  COLOR_RED800_OPACITY_30,
  COLOR_RED800_OPACITY_35,
  COLOR_RED800_OPACITY_40,
  COLOR_RED800_OPACITY_45,
  COLOR_RED800_OPACITY_50,
  COLOR_RED800_OPACITY_55,
  COLOR_RED800_OPACITY_60,
  COLOR_RED800_OPACITY_65,
  COLOR_RED800_OPACITY_70,
  COLOR_RED800_OPACITY_75,
  COLOR_RED800_OPACITY_80,
  COLOR_RED800_OPACITY_85,
  COLOR_RED800_OPACITY_90,
  COLOR_RED800_OPACITY_95,
  COLOR_YELLOW100_SHADE_1,
  COLOR_YELLOW100_SHADE_2,
  COLOR_YELLOW100_TINT_1,
  COLOR_YELLOW100_TINT_2,
  COLOR_YELLOW100_5,
  COLOR_YELLOW100_10,
  COLOR_YELLOW100_15,
  COLOR_YELLOW100_20,
  COLOR_YELLOW100_25,
  COLOR_YELLOW100_30,
  COLOR_YELLOW100_35,
  COLOR_YELLOW100_40,
  COLOR_YELLOW100_45,
  COLOR_YELLOW100_50,
  COLOR_YELLOW100_55,
  COLOR_YELLOW100_60,
  COLOR_YELLOW100_65,
  COLOR_YELLOW100_70,
  COLOR_YELLOW100_75,
  COLOR_YELLOW100_80,
  COLOR_YELLOW100_85,
  COLOR_YELLOW100_90,
  COLOR_YELLOW100_95,
  COLOR_YELLOW100_OPACITY_5,
  COLOR_YELLOW100_OPACITY_10,
  COLOR_YELLOW100_OPACITY_15,
  COLOR_YELLOW100_OPACITY_20,
  COLOR_YELLOW100_OPACITY_25,
  COLOR_YELLOW100_OPACITY_30,
  COLOR_YELLOW100_OPACITY_35,
  COLOR_YELLOW100_OPACITY_40,
  COLOR_YELLOW100_OPACITY_45,
  COLOR_YELLOW100_OPACITY_50,
  COLOR_YELLOW100_OPACITY_55,
  COLOR_YELLOW100_OPACITY_60,
  COLOR_YELLOW100_OPACITY_65,
  COLOR_YELLOW100_OPACITY_70,
  COLOR_YELLOW100_OPACITY_75,
  COLOR_YELLOW100_OPACITY_80,
  COLOR_YELLOW100_OPACITY_85,
  COLOR_YELLOW100_OPACITY_90,
  COLOR_YELLOW100_OPACITY_95,
  COLOR_YELLOW300_SHADE_1,
  COLOR_YELLOW300_SHADE_2,
  COLOR_YELLOW300_TINT_1,
  COLOR_YELLOW300_TINT_2,
  COLOR_YELLOW300_5,
  COLOR_YELLOW300_10,
  COLOR_YELLOW300_15,
  COLOR_YELLOW300_20,
  COLOR_YELLOW300_25,
  COLOR_YELLOW300_30,
  COLOR_YELLOW300_35,
  COLOR_YELLOW300_40,
  COLOR_YELLOW300_45,
  COLOR_YELLOW300_50,
  COLOR_YELLOW300_55,
  COLOR_YELLOW300_60,
  COLOR_YELLOW300_65,
  COLOR_YELLOW300_70,
  COLOR_YELLOW300_75,
  COLOR_YELLOW300_80,
  COLOR_YELLOW300_85,
  COLOR_YELLOW300_90,
  COLOR_YELLOW300_95,
  COLOR_YELLOW300_OPACITY_5,
  COLOR_YELLOW300_OPACITY_10,
  COLOR_YELLOW300_OPACITY_15,
  COLOR_YELLOW300_OPACITY_20,
  COLOR_YELLOW300_OPACITY_25,
  COLOR_YELLOW300_OPACITY_30,
  COLOR_YELLOW300_OPACITY_35,
  COLOR_YELLOW300_OPACITY_40,
  COLOR_YELLOW300_OPACITY_45,
  COLOR_YELLOW300_OPACITY_50,
  COLOR_YELLOW300_OPACITY_55,
  COLOR_YELLOW300_OPACITY_60,
  COLOR_YELLOW300_OPACITY_65,
  COLOR_YELLOW300_OPACITY_70,
  COLOR_YELLOW300_OPACITY_75,
  COLOR_YELLOW300_OPACITY_80,
  COLOR_YELLOW300_OPACITY_85,
  COLOR_YELLOW300_OPACITY_90,
  COLOR_YELLOW300_OPACITY_95,
  COLOR_YELLOW500_SHADE_1,
  COLOR_YELLOW500_SHADE_2,
  COLOR_YELLOW500_TINT_1,
  COLOR_YELLOW500_TINT_2,
  COLOR_YELLOW500_5,
  COLOR_YELLOW500_10,
  COLOR_YELLOW500_15,
  COLOR_YELLOW500_20,
  COLOR_YELLOW500_25,
  COLOR_YELLOW500_30,
  COLOR_YELLOW500_35,
  COLOR_YELLOW500_40,
  COLOR_YELLOW500_45,
  COLOR_YELLOW500_50,
  COLOR_YELLOW500_55,
  COLOR_YELLOW500_60,
  COLOR_YELLOW500_65,
  COLOR_YELLOW500_70,
  COLOR_YELLOW500_75,
  COLOR_YELLOW500_80,
  COLOR_YELLOW500_85,
  COLOR_YELLOW500_90,
  COLOR_YELLOW500_95,
  COLOR_YELLOW500_OPACITY_5,
  COLOR_YELLOW500_OPACITY_10,
  COLOR_YELLOW500_OPACITY_15,
  COLOR_YELLOW500_OPACITY_20,
  COLOR_YELLOW500_OPACITY_25,
  COLOR_YELLOW500_OPACITY_30,
  COLOR_YELLOW500_OPACITY_35,
  COLOR_YELLOW500_OPACITY_40,
  COLOR_YELLOW500_OPACITY_45,
  COLOR_YELLOW500_OPACITY_50,
  COLOR_YELLOW500_OPACITY_55,
  COLOR_YELLOW500_OPACITY_60,
  COLOR_YELLOW500_OPACITY_65,
  COLOR_YELLOW500_OPACITY_70,
  COLOR_YELLOW500_OPACITY_75,
  COLOR_YELLOW500_OPACITY_80,
  COLOR_YELLOW500_OPACITY_85,
  COLOR_YELLOW500_OPACITY_90,
  COLOR_YELLOW500_OPACITY_95,
  COLOR_TURQUOISE100_SHADE_1,
  COLOR_TURQUOISE100_SHADE_2,
  COLOR_TURQUOISE100_TINT_1,
  COLOR_TURQUOISE100_TINT_2,
  COLOR_TURQUOISE100_5,
  COLOR_TURQUOISE100_10,
  COLOR_TURQUOISE100_15,
  COLOR_TURQUOISE100_20,
  COLOR_TURQUOISE100_25,
  COLOR_TURQUOISE100_30,
  COLOR_TURQUOISE100_35,
  COLOR_TURQUOISE100_40,
  COLOR_TURQUOISE100_45,
  COLOR_TURQUOISE100_50,
  COLOR_TURQUOISE100_55,
  COLOR_TURQUOISE100_60,
  COLOR_TURQUOISE100_65,
  COLOR_TURQUOISE100_70,
  COLOR_TURQUOISE100_75,
  COLOR_TURQUOISE100_80,
  COLOR_TURQUOISE100_85,
  COLOR_TURQUOISE100_90,
  COLOR_TURQUOISE100_95,
  COLOR_TURQUOISE100_OPACITY_5,
  COLOR_TURQUOISE100_OPACITY_10,
  COLOR_TURQUOISE100_OPACITY_15,
  COLOR_TURQUOISE100_OPACITY_20,
  COLOR_TURQUOISE100_OPACITY_25,
  COLOR_TURQUOISE100_OPACITY_30,
  COLOR_TURQUOISE100_OPACITY_35,
  COLOR_TURQUOISE100_OPACITY_40,
  COLOR_TURQUOISE100_OPACITY_45,
  COLOR_TURQUOISE100_OPACITY_50,
  COLOR_TURQUOISE100_OPACITY_55,
  COLOR_TURQUOISE100_OPACITY_60,
  COLOR_TURQUOISE100_OPACITY_65,
  COLOR_TURQUOISE100_OPACITY_70,
  COLOR_TURQUOISE100_OPACITY_75,
  COLOR_TURQUOISE100_OPACITY_80,
  COLOR_TURQUOISE100_OPACITY_85,
  COLOR_TURQUOISE100_OPACITY_90,
  COLOR_TURQUOISE100_OPACITY_95,
  COLOR_TURQUOISE300_SHADE_1,
  COLOR_TURQUOISE300_SHADE_2,
  COLOR_TURQUOISE300_TINT_1,
  COLOR_TURQUOISE300_TINT_2,
  COLOR_TURQUOISE300_5,
  COLOR_TURQUOISE300_10,
  COLOR_TURQUOISE300_15,
  COLOR_TURQUOISE300_20,
  COLOR_TURQUOISE300_25,
  COLOR_TURQUOISE300_30,
  COLOR_TURQUOISE300_35,
  COLOR_TURQUOISE300_40,
  COLOR_TURQUOISE300_45,
  COLOR_TURQUOISE300_50,
  COLOR_TURQUOISE300_55,
  COLOR_TURQUOISE300_60,
  COLOR_TURQUOISE300_65,
  COLOR_TURQUOISE300_70,
  COLOR_TURQUOISE300_75,
  COLOR_TURQUOISE300_80,
  COLOR_TURQUOISE300_85,
  COLOR_TURQUOISE300_90,
  COLOR_TURQUOISE300_95,
  COLOR_TURQUOISE300_OPACITY_5,
  COLOR_TURQUOISE300_OPACITY_10,
  COLOR_TURQUOISE300_OPACITY_15,
  COLOR_TURQUOISE300_OPACITY_20,
  COLOR_TURQUOISE300_OPACITY_25,
  COLOR_TURQUOISE300_OPACITY_30,
  COLOR_TURQUOISE300_OPACITY_35,
  COLOR_TURQUOISE300_OPACITY_40,
  COLOR_TURQUOISE300_OPACITY_45,
  COLOR_TURQUOISE300_OPACITY_50,
  COLOR_TURQUOISE300_OPACITY_55,
  COLOR_TURQUOISE300_OPACITY_60,
  COLOR_TURQUOISE300_OPACITY_65,
  COLOR_TURQUOISE300_OPACITY_70,
  COLOR_TURQUOISE300_OPACITY_75,
  COLOR_TURQUOISE300_OPACITY_80,
  COLOR_TURQUOISE300_OPACITY_85,
  COLOR_TURQUOISE300_OPACITY_90,
  COLOR_TURQUOISE300_OPACITY_95,
  COLOR_TURQUOISE500_SHADE_1,
  COLOR_TURQUOISE500_SHADE_2,
  COLOR_TURQUOISE500_TINT_1,
  COLOR_TURQUOISE500_TINT_2,
  COLOR_TURQUOISE500_5,
  COLOR_TURQUOISE500_10,
  COLOR_TURQUOISE500_15,
  COLOR_TURQUOISE500_20,
  COLOR_TURQUOISE500_25,
  COLOR_TURQUOISE500_30,
  COLOR_TURQUOISE500_35,
  COLOR_TURQUOISE500_40,
  COLOR_TURQUOISE500_45,
  COLOR_TURQUOISE500_50,
  COLOR_TURQUOISE500_55,
  COLOR_TURQUOISE500_60,
  COLOR_TURQUOISE500_65,
  COLOR_TURQUOISE500_70,
  COLOR_TURQUOISE500_75,
  COLOR_TURQUOISE500_80,
  COLOR_TURQUOISE500_85,
  COLOR_TURQUOISE500_90,
  COLOR_TURQUOISE500_95,
  COLOR_TURQUOISE500_OPACITY_5,
  COLOR_TURQUOISE500_OPACITY_10,
  COLOR_TURQUOISE500_OPACITY_15,
  COLOR_TURQUOISE500_OPACITY_20,
  COLOR_TURQUOISE500_OPACITY_25,
  COLOR_TURQUOISE500_OPACITY_30,
  COLOR_TURQUOISE500_OPACITY_35,
  COLOR_TURQUOISE500_OPACITY_40,
  COLOR_TURQUOISE500_OPACITY_45,
  COLOR_TURQUOISE500_OPACITY_50,
  COLOR_TURQUOISE500_OPACITY_55,
  COLOR_TURQUOISE500_OPACITY_60,
  COLOR_TURQUOISE500_OPACITY_65,
  COLOR_TURQUOISE500_OPACITY_70,
  COLOR_TURQUOISE500_OPACITY_75,
  COLOR_TURQUOISE500_OPACITY_80,
  COLOR_TURQUOISE500_OPACITY_85,
  COLOR_TURQUOISE500_OPACITY_90,
  COLOR_TURQUOISE500_OPACITY_95,
  COLOR_VIOLET_DARK,
  COLOR_RED200,
  COLOR_RED200_OPACITY_25,
  COLOR_RED400,
  COLOR_RED400_OPACITY_25,
  COLOR_RED600,
  COLOR_RED700,
  COLOR_RED700_OPACITY_20,
  COLOR_RED900,
  COLOR_YELLOW200,
  COLOR_YELLOW400,
  COLOR_YELLOW600,
  COLOR_YELLOW700,
  COLOR_YELLOW800,
  COLOR_YELLOW900,
  COLOR_TURQUOISE200,
  COLOR_TURQUOISE400,
  COLOR_TURQUOISE600,
  COLOR_TURQUOISE700,
  COLOR_TURQUOISE800,
  COLOR_TURQUOISE900,
  COLOR_NEUTRAL200,
  COLOR_NEUTRAL400,
  COLOR_NEUTRAL500,
  COLOR_NEUTRAL600,
  COLOR_NEUTRAL600_OPACITY_25,
  COLOR_NEUTRAL700,
  COLOR_NEUTRAL700_OPACITY_25,
  COLOR_NEUTRAL800_RGB,
  COLOR_NEUTRAL900,
  COLOR_GREY800_OPACITY_50,
  COLOR_GREY900_OPACITY_8,
  COLOR_BLUE100,
  COLOR_BLUE200,
  COLOR_BLUE300,
  COLOR_BLUE400,
  COLOR_BLUE500,
  COLOR_BLUE600,
  COLOR_BLUE700,
  COLOR_BLUE800,
  COLOR_BLUE900,
  COLOR_PURPLE100,
  COLOR_PURPLE200,
  COLOR_PURPLE300,
  COLOR_PURPLE400,
  COLOR_PURPLE500,
  COLOR_PURPLE600,
  COLOR_PURPLE700,
  COLOR_PURPLE800,
  COLOR_PURPLE900,
  COLOR_RED500GRADIENT,

  COLOR_TRANSPARENT,
  COLOR_WHITE,
  COLOR_SYSTEM_SUCCESS_LIGHT,
  COLOR_SYSTEM_SUCCESS,
  COLOR_SYSTEM_SUCCESS_DARK,
  COLOR_SYSTEM_WARNING_LIGHT,
  COLOR_SYSTEM_WARNING,
  COLOR_SYSTEM_WARNING_DARK,
  COLOR_SYSTEM_ERROR_LIGHT,
  COLOR_SYSTEM_ERROR,
  COLOR_SYSTEM_ERROR_DARK,
  COLOR_SYSTEM_HIGHLIGHT_LIGHT,
  COLOR_SYSTEM_HIGHLIGHT,
  COLOR_SYSTEM_HIGHLIGHT_DARK,
  COLOR_GREY100,
  COLOR_GREY200,
  COLOR_GREY300,
  COLOR_GREY400,
  COLOR_GREY500,
  COLOR_GREY600,
  COLOR_GREY700,
  COLOR_GREY800,
  COLOR_GREY900
] as const;

export const THEME_COLORS = [
  "bright",
  "dark",
  "white",
  "black",
  "grey100",
  "grey900",
  "neutral100",
  "neutral300",
  "neutral800",
  "red100",
  "red300",
  "red500",
  "red800",
  "yellow100",
  "yellow300",
  "yellow500",
  "turquoise100",
  "turquoise300",
  "turquoise500"
];

export const DEFAULT_PAGE_BACKGROUND_COLOR = "eon-white" as const;

export const ACCORDION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "neutral300"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "grey100"
  },
  {
    schemeName: "red500",
    scheme: {
      outlineColor: COLOR_WHITE,
      backgroundColor: COLOR_RED600,
      activeAccordionBackgroundColor: COLOR_RED600,
      accordionHoverColor: COLOR_RED700,
      innerBackground: COLOR_RED500,
      hoverShadow: "none",
      shadowPadding: "0px"
    }
  }
];
export const ANSWER_CARD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "red500",
    scheme: {
      borderHoverColor: COLOR_WHITE,
      borderFocusColor: COLOR_WHITE,
      borderSelectedColor: COLOR_WHITE,
      borderSelectedHoverColor: COLOR_WHITE,
      separatorColor: COLOR_WHITE_OPACITY_40,
      checkmarkBackground: COLOR_WHITE,
      checkmarkHoverBackground: COLOR_WHITE,
      checkmarkIconColor: COLOR_RED500
    }
  },
  {
    schemeName: "white"
  }
];
export const BADGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      hoverColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      hoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "white",
    scheme: {
      hoverColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      hoverColor: COLOR_RED500
    }
  }
];
export const BASIC_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red500",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      valueTextColor: COLOR_NEUTRAL100,
      contentColor: COLOR_NEUTRAL100,
      contentBackgroundColor: COLOR_RED500,
      linkHoverColor: COLOR_NEUTRAL300,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_GREY900
    }
  }
];
export const BREADCRUMB_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      iconColor: COLOR_NEUTRAL600
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      iconColor: COLOR_RED300
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      contentColor: COLOR_GREY900,
      contentHoverColor: COLOR_GREY900,
      iconColor: COLOR_GREY700
    }
  },
  {
    schemeName: "white",
    scheme: {
      contentColor: COLOR_WHITE,
      contentHoverColor: COLOR_WHITE,
      iconColor: COLOR_WHITE_OPACITY_80,
      focusBorderColor: COLOR_WHITE
    }
  }
];
export const BOTTOM_DRAWER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500"
  }
];
export const BULLET_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800"
  },
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "grey900"
  },
  {
    schemeName: "white"
  }
];
export const BUSINESSCARD_AUTHOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      textHoverColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      textHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      textHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "white",
    scheme: {
      textHoverColor: COLOR_WHITE
    }
  }
];
export const BUSINESSCARD_CONTACT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red500",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      backgroundColor: COLOR_RED500,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_NEUTRAL300,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_GREY900
    }
  }
];
export const BOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red500",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      backgroundColor: COLOR_RED500,
      borderColor: COLOR_RED500,
      color: COLOR_RED500_FONT,
      activeBackgroundColor: COLOR_RED500_TINT_1,
      activeBorderColor: COLOR_RED500_SHADE_2,
      linkHoverColor: COLOR_NEUTRAL300,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  }
];
export const BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      primaryBackgroundHoverColor: COLOR_RED700,
      primaryBackgroundFocusColor: COLOR_RED500,
      primaryBackgroundDisabledColor: COLOR_GREY500,
      primaryTextAndIconDisabledColor: COLOR_NEUTRAL100,
      primaryFocusOutlineColor: COLOR_SYSTEM_HIGHLIGHT,
      secondaryBackgroundHoverColor: COLOR_RED700,
      secondaryBackgroundFocusColor: COLOR_RED500,
      secondaryBackgroundDisabledColor: COLOR_TRANSPARENT,
      secondaryTextAndIconDisabledColor: COLOR_GREY500,
      secondaryBorderHoverColor: COLOR_RED700,
      secondaryBorderFocusColor: COLOR_RED500,
      secondaryBorderDisabledColor: COLOR_GREY500,
      secondaryFocusOutlineColor: COLOR_SYSTEM_HIGHLIGHT,
      functionalBackgroundColor: COLOR_GREY600,
      functionalBackgroundHoverColor: COLOR_GREY800,
      functionalBackgroundFocusColor: COLOR_GREY600,
      functionalBackgroundDisabledColor: COLOR_GREY600,
      functionalBorderColor: COLOR_GREY600,
      functionalBorderHoverColor: COLOR_GREY800,
      functionalBorderFocusColor: COLOR_GREY600,
      functionalBorderDisabledColor: COLOR_GREY600,
      functionalTextAndIconColor: COLOR_WHITE,
      functionalTextAndIconHoverColor: COLOR_WHITE,
      functionalTextAndIconFocusColor: COLOR_WHITE,
      functionalTextAndIconDisabledColor: COLOR_WHITE,
      functionalFocusOutlineColor: COLOR_SYSTEM_HIGHLIGHT,
      discreetBorderHoverColor: COLOR_GREY600,
      discreetBorderFocusColor: COLOR_SYSTEM_HIGHLIGHT,
      discreetTextAndIconColor: COLOR_GREY900,
      discreetTextAndIconHoverColor: COLOR_GREY900,
      discreetTextAndIconFocusColor: COLOR_GREY900,
      discreetTextAndIconDisabledColor: COLOR_GREY900
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      primaryBackgroundHoverColor: COLOR_NEUTRAL100_OPACITY_80,
      primaryBackgroundFocusColor: COLOR_NEUTRAL100,
      primaryBackgroundDisabledColor: COLOR_NEUTRAL100,
      primaryTextAndIconColor: COLOR_RED500,
      primaryTextAndIconHoverColor: COLOR_RED600,
      primaryTextAndIconFocusColor: COLOR_RED700,
      primaryTextAndIconDisabledColor: COLOR_RED500,
      primaryFocusOutlineColor: COLOR_NEUTRAL100,
      secondaryBackgroundHoverColor: COLOR_NEUTRAL100_OPACITY_80,
      secondaryBackgroundFocusColor: COLOR_NEUTRAL100,
      secondaryBackgroundDisabledColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_NEUTRAL100,
      secondaryTextAndIconHoverColor: COLOR_RED500,
      secondaryTextAndIconFocusColor: COLOR_RED700,
      secondaryTextAndIconDisabledColor: COLOR_NEUTRAL100_OPACITY_80,
      secondaryBorderHoverColor: COLOR_TRANSPARENT,
      secondaryBorderFocusColor: COLOR_NEUTRAL100,
      secondaryBorderDisabledColor: COLOR_NEUTRAL100,
      secondaryFocusOutlineColor: COLOR_NEUTRAL100,
      functionalBackgroundColor: COLOR_NEUTRAL100_OPACITY_80,
      functionalBackgroundHoverColor: COLOR_NEUTRAL100,
      functionalBackgroundFocusColor: COLOR_NEUTRAL100_OPACITY_80,
      functionalBackgroundDisabledColor: COLOR_NEUTRAL100,
      functionalBorderColor: COLOR_TRANSPARENT,
      functionalBorderHoverColor: COLOR_NEUTRAL100,
      functionalBorderFocusColor: COLOR_TRANSPARENT,
      functionalBorderDisabledColor: COLOR_NEUTRAL100,
      functionalTextAndIconColor: COLOR_RED500,
      functionalTextAndIconHoverColor: COLOR_RED500,
      functionalTextAndIconFocusColor: COLOR_RED500,
      functionalTextAndIconDisabledColor: COLOR_RED500,
      functionalFocusOutlineColor: COLOR_NEUTRAL100,
      discreetBorderHoverColor: COLOR_SYSTEM_ERROR_LIGHT,
      discreetBorderFocusColor: COLOR_NEUTRAL100,
      discreetTextAndIconColor: COLOR_NEUTRAL100,
      discreetTextAndIconHoverColor: COLOR_NEUTRAL100,
      discreetTextAndIconFocusColor: COLOR_NEUTRAL100,
      discreetTextAndIconDisabledColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "white",
    scheme: {
      primaryBackgroundHoverColor: COLOR_WHITE_OPACITY_80,
      primaryBackgroundFocusColor: COLOR_WHITE,
      primaryBackgroundDisabledColor: COLOR_WHITE,
      primaryTextAndIconColor: COLOR_RED500,
      primaryTextAndIconHoverColor: COLOR_RED600,
      primaryTextAndIconFocusColor: COLOR_RED700,
      primaryTextAndIconDisabledColor: COLOR_RED500,
      primaryFocusOutlineColor: COLOR_WHITE,
      secondaryBackgroundHoverColor: COLOR_WHITE_OPACITY_80,
      secondaryBackgroundFocusColor: COLOR_WHITE,
      secondaryBackgroundDisabledColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_NEUTRAL100,
      secondaryTextAndIconHoverColor: COLOR_RED500,
      secondaryTextAndIconFocusColor: COLOR_RED500,
      secondaryTextAndIconDisabledColor: COLOR_WHITE_OPACITY_80,
      secondaryBorderHoverColor: COLOR_TRANSPARENT,
      secondaryBorderFocusColor: COLOR_WHITE,
      secondaryBorderDisabledColor: COLOR_WHITE,
      secondaryFocusOutlineColor: COLOR_WHITE,
      functionalBackgroundColor: COLOR_WHITE_OPACITY_80,
      functionalBackgroundHoverColor: COLOR_WHITE,
      functionalBackgroundFocusColor: COLOR_WHITE_OPACITY_80,
      functionalBackgroundDisabledColor: COLOR_WHITE,
      functionalBorderColor: COLOR_TRANSPARENT,
      functionalBorderHoverColor: COLOR_WHITE,
      functionalBorderFocusColor: COLOR_TRANSPARENT,
      functionalBorderDisabledColor: COLOR_WHITE,
      functionalTextAndIconColor: COLOR_RED500,
      functionalTextAndIconHoverColor: COLOR_RED500,
      functionalTextAndIconFocusColor: COLOR_RED500,
      functionalTextAndIconDisabledColor: COLOR_RED500,
      functionalFocusOutlineColor: COLOR_WHITE,
      discreetBackgroundColor: COLOR_TRANSPARENT,
      discreetBackgroundHoverColor: COLOR_TRANSPARENT,
      discreetBackgroundFocusColor: COLOR_TRANSPARENT,
      discreetBackgroundDisabledColor: COLOR_TRANSPARENT,
      discreetBorderHoverColor: COLOR_SYSTEM_ERROR_LIGHT,
      discreetBorderFocusColor: COLOR_WHITE,
      discreetTextAndIconColor: COLOR_WHITE,
      discreetTextAndIconHoverColor: COLOR_WHITE,
      discreetTextAndIconFocusColor: COLOR_WHITE,
      discreetTextAndIconDisabledColor: COLOR_WHITE
    }
  },
  {
    schemeName: "discreet",
    scheme: {
      primaryBackgroundColor: COLOR_NEUTRAL100,
      primaryBackgroundHoverColor: COLOR_NEUTRAL400,
      primaryBackgroundFocusColor: COLOR_NEUTRAL400,
      primaryBackgroundDisabledColor: COLOR_NEUTRAL100_OPACITY_60,
      primaryTextAndIconColor: COLOR_NEUTRAL600,
      primaryTextAndIconHoverColor: COLOR_NEUTRAL700,
      primaryTextAndIconFocusColor: COLOR_NEUTRAL700,
      primaryTextAndIconDisabledColor: COLOR_NEUTRAL800_OPACITY_30,
      primaryFocusOutlineColor: COLOR_NEUTRAL400,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_NEUTRAL400,
      secondaryBackgroundFocusColor: COLOR_NEUTRAL400,
      secondaryBackgroundDisabledColor: COLOR_NEUTRAL100_OPACITY_60,
      secondaryTextAndIconColor: COLOR_NEUTRAL100,
      secondaryTextAndIconHoverColor: COLOR_NEUTRAL700,
      secondaryTextAndIconFocusColor: COLOR_NEUTRAL500,
      secondaryTextAndIconDisabledColor: COLOR_NEUTRAL100_OPACITY_40,
      secondaryBorderColor: COLOR_NEUTRAL100,
      secondaryBorderHoverColor: COLOR_NEUTRAL400,
      secondaryBorderFocusColor: COLOR_NEUTRAL400,
      secondaryBorderDisabledColor: COLOR_NEUTRAL100_OPACITY_40,
      secondaryFocusOutlineColor: COLOR_NEUTRAL400,
      functionalBackgroundColor: COLOR_NEUTRAL400,
      functionalBackgroundHoverColor: COLOR_NEUTRAL500,
      functionalBackgroundFocusColor: COLOR_NEUTRAL600,
      functionalBackgroundDisabledColor: COLOR_NEUTRAL400,
      functionalBorderColor: COLOR_NEUTRAL400,
      functionalBorderHoverColor: COLOR_NEUTRAL500,
      functionalBorderFocusColor: COLOR_NEUTRAL600,
      functionalBorderDisabledColor: COLOR_NEUTRAL400,
      functionalTextAndIconColor: COLOR_NEUTRAL800,
      functionalTextAndIconHoverColor: COLOR_NEUTRAL800,
      functionalTextAndIconFocusColor: COLOR_NEUTRAL800,
      functionalTextAndIconDisabledColor: COLOR_NEUTRAL500,
      functionalFocusOutlineColor: COLOR_NEUTRAL600
    }
  },
  {
    schemeName: "discreetDark",
    scheme: {
      primaryBackgroundColor: COLOR_NEUTRAL100,
      primaryBackgroundHoverColor: COLOR_NEUTRAL800,
      primaryBackgroundFocusColor: COLOR_NEUTRAL800,
      primaryBackgroundDisabledColor: COLOR_NEUTRAL100_OPACITY_60,
      primaryTextAndIconColor: COLOR_NEUTRAL700,
      primaryTextAndIconHoverColor: COLOR_NEUTRAL100,
      primaryTextAndIconFocusColor: COLOR_NEUTRAL100,
      primaryTextAndIconDisabledColor: COLOR_NEUTRAL800_OPACITY_30,
      primaryFocusOutlineColor: COLOR_NEUTRAL800,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_NEUTRAL800,
      secondaryBackgroundFocusColor: COLOR_NEUTRAL800,
      secondaryBackgroundDisabledColor: COLOR_NEUTRAL100_OPACITY_60,
      secondaryTextAndIconColor: COLOR_NEUTRAL100,
      secondaryTextAndIconHoverColor: COLOR_NEUTRAL100,
      secondaryTextAndIconFocusColor: COLOR_NEUTRAL100,
      secondaryTextAndIconDisabledColor: COLOR_NEUTRAL100_OPACITY_40,
      secondaryBorderColor: COLOR_NEUTRAL100,
      secondaryBorderHoverColor: COLOR_NEUTRAL800,
      secondaryBorderFocusColor: COLOR_NEUTRAL800,
      secondaryBorderDisabledColor: COLOR_NEUTRAL100_OPACITY_40,
      secondaryFocusOutlineColor: COLOR_NEUTRAL800,
      functionalBackgroundColor: COLOR_NEUTRAL400,
      functionalBackgroundHoverColor: COLOR_NEUTRAL500,
      functionalBackgroundFocusColor: COLOR_NEUTRAL600,
      functionalBackgroundDisabledColor: COLOR_NEUTRAL400,
      functionalBorderColor: COLOR_NEUTRAL400,
      functionalBorderHoverColor: COLOR_NEUTRAL500,
      functionalBorderFocusColor: COLOR_NEUTRAL600,
      functionalBorderDisabledColor: COLOR_NEUTRAL400,
      functionalTextAndIconColor: COLOR_NEUTRAL800,
      functionalTextAndIconHoverColor: COLOR_NEUTRAL800,
      functionalTextAndIconFocusColor: COLOR_NEUTRAL800,
      functionalTextAndIconDisabledColor: COLOR_NEUTRAL500,
      functionalFocusOutlineColor: COLOR_NEUTRAL600
    }
  },
  {
    schemeName: "darkgreyCarrier",
    scheme: {
      primaryBackgroundColor: COLOR_NEUTRAL800_OPACITY_70,
      primaryBackgroundHoverColor: COLOR_RED700,
      primaryBackgroundFocusColor: COLOR_RED900,
      primaryBackgroundDisabledColor: COLOR_NEUTRAL500,
      primaryTextAndIconColor: COLOR_NEUTRAL100,
      primaryTextAndIconHoverColor: COLOR_NEUTRAL100,
      primaryTextAndIconFocusColor: COLOR_NEUTRAL100,
      primaryTextAndIconDisabledColor: COLOR_NEUTRAL100,
      primaryFocusOutlineColor: COLOR_RED900,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_RED700,
      secondaryBackgroundFocusColor: COLOR_RED900,
      secondaryBackgroundDisabledColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_NEUTRAL100,
      secondaryTextAndIconHoverColor: COLOR_NEUTRAL100,
      secondaryTextAndIconFocusColor: COLOR_NEUTRAL100,
      secondaryTextAndIconDisabledColor: COLOR_NEUTRAL500,
      secondaryBorderColor: COLOR_NEUTRAL600,
      secondaryBorderHoverColor: COLOR_RED700,
      secondaryBorderFocusColor: COLOR_RED900,
      secondaryBorderDisabledColor: COLOR_NEUTRAL500,
      secondaryFocusOutlineColor: COLOR_RED900,
      functionalBackgroundColor: COLOR_NEUTRAL400,
      functionalBackgroundHoverColor: COLOR_NEUTRAL500,
      functionalBackgroundFocusColor: COLOR_NEUTRAL600,
      functionalBackgroundDisabledColor: COLOR_NEUTRAL400,
      functionalBorderColor: COLOR_NEUTRAL400,
      functionalBorderHoverColor: COLOR_NEUTRAL500,
      functionalBorderFocusColor: COLOR_NEUTRAL600,
      functionalBorderDisabledColor: COLOR_NEUTRAL400,
      functionalTextAndIconColor: COLOR_NEUTRAL800,
      functionalTextAndIconHoverColor: COLOR_NEUTRAL800,
      functionalTextAndIconFocusColor: COLOR_NEUTRAL800,
      functionalTextAndIconDisabledColor: COLOR_NEUTRAL500,
      functionalFocusOutlineColor: COLOR_NEUTRAL600
    }
  },
  {
    schemeName: "neutral100Carrier",
    scheme: {
      primaryBackgroundColor: COLOR_NEUTRAL100,
      primaryBackgroundHoverColor: COLOR_NEUTRAL500,
      primaryBackgroundFocusColor: COLOR_NEUTRAL500,
      primaryBackgroundDisabledColor: COLOR_NEUTRAL100_OPACITY_40,
      primaryTextAndIconColor: COLOR_NEUTRAL800,
      primaryTextAndIconHoverColor: COLOR_NEUTRAL900,
      primaryTextAndIconFocusColor: COLOR_NEUTRAL900,
      primaryTextAndIconDisabledColor: COLOR_NEUTRAL100_OPACITY_60,
      primaryFocusOutlineColor: COLOR_NEUTRAL400,
      secondaryBackgroundHoverColor: COLOR_NEUTRAL300,
      secondaryBackgroundFocusColor: COLOR_NEUTRAL400,
      secondaryBackgroundDisabledColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_NEUTRAL100,
      secondaryTextAndIconHoverColor: COLOR_NEUTRAL900,
      secondaryTextAndIconFocusColor: COLOR_NEUTRAL900,
      secondaryTextAndIconDisabledColor: COLOR_NEUTRAL100_OPACITY_40,
      secondaryBorderHoverColor: COLOR_NEUTRAL900,
      secondaryBorderFocusColor: COLOR_NEUTRAL900,
      secondaryBorderDisabledColor: COLOR_NEUTRAL100_OPACITY_40,
      secondaryFocusOutlineColor: COLOR_NEUTRAL400,
      functionalBackgroundColor: COLOR_NEUTRAL400,
      functionalBackgroundHoverColor: COLOR_NEUTRAL500,
      functionalBackgroundFocusColor: COLOR_NEUTRAL600,
      functionalBackgroundDisabledColor: COLOR_NEUTRAL400,
      functionalBorderColor: COLOR_NEUTRAL400,
      functionalBorderHoverColor: COLOR_NEUTRAL500,
      functionalBorderFocusColor: COLOR_NEUTRAL600,
      functionalBorderDisabledColor: COLOR_NEUTRAL400,
      functionalTextAndIconColor: COLOR_NEUTRAL800,
      functionalTextAndIconHoverColor: COLOR_NEUTRAL800,
      functionalTextAndIconFocusColor: COLOR_NEUTRAL800,
      functionalTextAndIconDisabledColor: COLOR_NEUTRAL500,
      functionalFocusOutlineColor: COLOR_NEUTRAL600
    }
  }
];
export const CAPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "grey100",
    scheme: {
      contentColor: COLOR_GREY900,
      copyrightColor: COLOR_GREY700,
      backgroundColor: COLOR_GREY100
    }
  },
  {
    schemeName: "white",
    scheme: {
      contentColor: COLOR_GREY900,
      copyrightColor: COLOR_GREY700,
      backgroundColor: COLOR_WHITE
    }
  }
];
export const CARD_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      contentColor: COLOR_RED500_FONT,
      backgroundColor: COLOR_RED500,
      linkColor: COLOR_RED500_FONT,
      headlineColor: COLOR_RED500_FONT,
      alternativeHeadlineColor1: COLOR_RED500_FONT,
      alternativeHeadlineColor2: COLOR_RED500_FONT,
      headlineColorOffset: COLOR_RED500_FONT,
      categoryColor: COLOR_RED500_FONT,
      linkHoverColor: COLOR_NEUTRAL300,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red500",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_GREY900
    }
  }
];
export const CAROUSEL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      indicatorColor: COLOR_GREY600,
      indicatorHoverColor: COLOR_GREY900,
      indicatorActColor: COLOR_RED500,
      indicatorActHoverColor: COLOR_RED700,
      controlColorBright: COLOR_NEUTRAL100_OPACITY_80,
      controlHoverColorBright: COLOR_WHITE,
      controlIconColorBright: COLOR_RED500,
      controlColorDark: COLOR_RED500,
      controlIconColorDark: COLOR_NEUTRAL100,
      outsideControlColor: COLOR_RED500,
      outsideControlIconColor: COLOR_NEUTRAL100,
      outsideControlHoverColor: COLOR_RED700,
      focusColor: COLOR_SYSTEM_HIGHLIGHT,
      controlHoverColor: COLOR_RED700
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      indicatorColor: COLOR_NEUTRAL100_OPACITY_80,
      indicatorHoverColor: COLOR_WHITE,
      indicatorActColor: COLOR_WHITE,
      indicatorActHoverColor: COLOR_NEUTRAL100_OPACITY_80,
      outsideControlHoverColor: COLOR_WHITE,
      controlColorBright: COLOR_NEUTRAL100_OPACITY_80,
      controlHoverColorBright: COLOR_WHITE,
      controlIconColorBright: COLOR_RED500,
      controlColorDark: COLOR_NEUTRAL100_OPACITY_80,
      controlIconColorDark: COLOR_RED500,
      focusColor: COLOR_WHITE,
      controlHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      indicatorColor: COLOR_NEUTRAL100_OPACITY_80,
      indicatorHoverColor: COLOR_WHITE,
      indicatorActColor: COLOR_WHITE,
      indicatorActHoverColor: COLOR_NEUTRAL100_OPACITY_80,
      outsideControlHoverColor: COLOR_WHITE,
      controlColorBright: COLOR_NEUTRAL100_OPACITY_80,
      controlHoverColorBright: COLOR_WHITE,
      controlIconColorBright: COLOR_RED500,
      controlColorDark: COLOR_NEUTRAL100_OPACITY_80,
      controlIconColorDark: COLOR_RED500,
      focusColor: COLOR_WHITE,
      controlHoverColor: COLOR_WHITE
    }
  }
];
export const CHECKBOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      errorColor: COLOR_WHITE,
      focusColor: COLOR_WHITE,
      labelColorDisabled: COLOR_WHITE,
      borderColorDisabled: COLOR_WHITE,
      borderColorSelected: COLOR_TRANSPARENT,
      borderColorSelectedHover: COLOR_TRANSPARENT,
      borderColorSelectedDisabled: COLOR_TRANSPARENT,
      backgroundColorDisabled: COLOR_TRANSPARENT,
      backgroundColorSelected: COLOR_WHITE,
      backgroundColorSelectedHover: COLOR_WHITE,
      backgroundColorSelectedDisabled: COLOR_WHITE,
      iconColorHover: COLOR_WHITE,
      iconColorSelected: COLOR_RED500,
      iconColorSelectedHover: COLOR_RED500,
      iconColorSelectedDisabled: COLOR_RED500
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      labelColorDisabled: COLOR_GREY900,
      borderColor: COLOR_GREY800,
      borderColorHover: COLOR_GREY800,
      borderColorDisabled: COLOR_GREY900,
      borderColorSelected: COLOR_TRANSPARENT,
      borderColorSelectedHover: COLOR_TRANSPARENT,
      borderColorSelectedDisabled: COLOR_TRANSPARENT,
      backgroundColorDisabled: COLOR_TRANSPARENT,
      backgroundColorSelected: COLOR_SYSTEM_HIGHLIGHT,
      backgroundColorSelectedHover: COLOR_SYSTEM_HIGHLIGHT_DARK,
      backgroundColorSelectedDisabled: COLOR_GREY600,
      iconColorHover: COLOR_GREY900,
      iconColorSelected: COLOR_WHITE,
      iconColorSelectedHover: COLOR_WHITE,
      iconColorSelectedDisabled: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      errorColor: COLOR_WHITE,
      focusColor: COLOR_WHITE,
      labelColorDisabled: COLOR_WHITE,
      borderColorDisabled: COLOR_WHITE,
      borderColorSelected: COLOR_TRANSPARENT,
      borderColorSelectedHover: COLOR_TRANSPARENT,
      borderColorSelectedDisabled: COLOR_TRANSPARENT,
      backgroundColorDisabled: COLOR_TRANSPARENT,
      backgroundColorSelected: COLOR_WHITE,
      backgroundColorSelectedHover: COLOR_WHITE,
      backgroundColorSelectedDisabled: COLOR_WHITE,
      iconColorHover: COLOR_WHITE,
      iconColorSelected: COLOR_RED500,
      iconColorSelectedHover: COLOR_RED500,
      iconColorSelectedDisabled: COLOR_RED500
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      labelColorDisabled: COLOR_GREY900,
      borderColor: COLOR_GREY800,
      borderColorHover: COLOR_GREY800,
      borderColorDisabled: COLOR_GREY900,
      borderColorSelected: COLOR_TRANSPARENT,
      borderColorSelectedHover: COLOR_TRANSPARENT,
      borderColorSelectedDisabled: COLOR_TRANSPARENT,
      backgroundColorDisabled: COLOR_TRANSPARENT,
      backgroundColorSelected: COLOR_SYSTEM_HIGHLIGHT,
      backgroundColorSelectedHover: COLOR_SYSTEM_HIGHLIGHT_DARK,
      backgroundColorSelectedDisabled: COLOR_GREY600,
      iconColorHover: COLOR_GREY900,
      iconColorSelected: COLOR_WHITE,
      iconColorSelectedHover: COLOR_WHITE,
      iconColorSelectedDisabled: COLOR_WHITE
    }
  }
];
export const CHIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "systemHighlight",
    scheme: {
      backgroundColor: COLOR_SYSTEM_HIGHLIGHT,
      iconBackgroundColor: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_WHITE,
      iconTextColor: COLOR_WHITE,
      backgroundHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      textHoverColor: COLOR_GREY900,
      iconTextHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      iconTextColor: COLOR_RED500,
      backgroundHoverColor: COLOR_WHITE,
      textHoverColor: COLOR_WHITE,
      iconTextHoverColor: COLOR_RED700,
      borderColor: COLOR_WHITE
    }
  }
];
export const CLICKABLE_IMAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      backgroundColor: COLOR_RED500,
      backgroundHoverColor: COLOR_RED700,
      backgroundFocusColor: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_NEUTRAL100,
      textHoverColor: COLOR_NEUTRAL100,
      textFocusColor: COLOR_WHITE,
      borderLineColor: COLOR_BRIGHT_OPACITY_60,
      borderLineHoverColor: COLOR_WHITE,
      borderLineFocusColor: COLOR_WHITE,
      labelBackgroundColor: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorActive: COLOR_BRIGHT,
      labelBackgroundColorBright: COLOR_DARK_OPACITY_60,
      labelBackgroundColorBrightActive: COLOR_DARK,
      labelColor: COLOR_BLACK,
      labelColorBright: COLOR_WHITE,
      tooltipScheme: "grey900",
      modalScheme: "white"
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      backgroundColor: COLOR_GREY900,
      backgroundHoverColor: COLOR_GREY900,
      backgroundFocusColor: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_WHITE,
      textHoverColor: COLOR_WHITE,
      textFocusColor: COLOR_WHITE,
      borderLineColor: COLOR_BRIGHT_OPACITY_60,
      borderLineHoverColor: COLOR_WHITE,
      borderLineFocusColor: COLOR_WHITE,
      labelBackgroundColor: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorActive: COLOR_BRIGHT,
      labelBackgroundColorBright: COLOR_DARK_OPACITY_60,
      labelBackgroundColorBrightActive: COLOR_DARK,
      labelColor: COLOR_GREY900,
      labelColorBright: COLOR_WHITE,
      tooltipScheme: "grey900",
      modalScheme: "white"
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      backgroundColor: COLOR_NEUTRAL100,
      backgroundHoverColor: COLOR_NEUTRAL300,
      backgroundFocusColor: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_NEUTRAL800,
      textHoverColor: COLOR_NEUTRAL800,
      textFocusColor: COLOR_WHITE,
      borderLineColor: COLOR_DARK_OPACITY_60,
      borderLineHoverColor: COLOR_GREY900,
      borderLineFocusColor: COLOR_WHITE,
      labelBackgroundColor: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorActive: COLOR_BRIGHT,
      labelBackgroundColorBright: COLOR_DARK_OPACITY_60,
      labelBackgroundColorBrightActive: COLOR_DARK,
      labelColor: COLOR_BLACK,
      labelColorBright: COLOR_WHITE,
      tooltipScheme: "grey900",
      modalScheme: "white"
    }
  },
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_NEUTRAL100,
      backgroundHoverColor: COLOR_NEUTRAL300,
      backgroundFocusColor: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_NEUTRAL800,
      textHoverColor: COLOR_NEUTRAL800,
      textFocusColor: COLOR_WHITE,
      borderLineColor: COLOR_DARK_OPACITY_60,
      borderLineHoverColor: COLOR_GREY900,
      borderLineFocusColor: COLOR_WHITE,
      labelBackgroundColor: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorActive: COLOR_BRIGHT,
      labelBackgroundColorBright: COLOR_DARK_OPACITY_60,
      labelBackgroundColorBrightActive: COLOR_DARK,
      labelColor: COLOR_BLACK,
      labelColorBright: COLOR_WHITE,
      tooltipScheme: "grey900",
      modalScheme: "white"
    }
  }
];
export const COMPASS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      directionBackgroundColor: COLOR_NEUTRAL100,
      directionBackgroundSelectedColor: COLOR_RED500,
      directionBackgroundSelectedHoverColor: COLOR_RED700,
      iconColor: COLOR_NEUTRAL800,
      iconHoverColor: COLOR_RED500,
      iconSelectedColor: COLOR_NEUTRAL100,
      errorMessageColor: COLOR_RED800
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      directionBackgroundColor: COLOR_NEUTRAL300,
      directionBackgroundSelectedColor: COLOR_RED500,
      directionBackgroundSelectedHoverColor: COLOR_RED700,
      iconColor: COLOR_NEUTRAL800,
      iconHoverColor: COLOR_RED500,
      iconSelectedColor: COLOR_NEUTRAL100,
      errorMessageColor: COLOR_RED800
    }
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "grey100"
  }
];
export const CONTACT_BAR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      itemHoverColor: COLOR_SYSTEM_HIGHLIGHT,
      hoverColor: COLOR_WHITE,
      buttonActiveColor: COLOR_NEUTRAL800,
      contactLayerActiveColor: COLOR_RED500
    }
  },
  {
    schemeName: "white",
    scheme: {
      itemHoverColor: COLOR_SYSTEM_HIGHLIGHT,
      hoverColor: COLOR_WHITE,
      buttonActiveColor: COLOR_NEUTRAL800,
      contactLayerActiveColor: COLOR_RED500
    }
  }
];
export const CONTACT_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  }
];
export const CONTACT_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  }
];
export const CONTENT_AGGREGATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red100",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red500",
    scheme: {
      headlineColor: COLOR_WHITE
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      headlineColor: COLOR_NEUTRAL800
    }
  }
];
export const CONTENT_AGGREGATOR_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_RED500,
      tagpillTextColor: COLOR_NEUTRAL700,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_NEUTRAL200
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_RED500,
      tagpillTextColor: COLOR_NEUTRAL700,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_NEUTRAL200
    }
  },
  {
    schemeName: "white",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_RED500,
      tagpillTextColor: COLOR_NEUTRAL700,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_NEUTRAL200
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_RED500,
      tagpillTextColor: COLOR_GREY800,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_NEUTRAL200
    }
  },
  {
    schemeName: "red100",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_NEUTRAL800,
      tagpillTextColor: COLOR_NEUTRAL700,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_RED200
    }
  },
  {
    schemeName: "red300",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_NEUTRAL800,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_RED200
    }
  },
  {
    schemeName: "red500",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_NEUTRAL800,
      tagpillTextColor: COLOR_GREY100,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_RED200
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_NEUTRAL800,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_YELLOW200
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_NEUTRAL800,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_YELLOW200
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_NEUTRAL800,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_TURQUOISE200
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      hoverColor: COLOR_RED900,
      linkHoverColor: COLOR_NEUTRAL800,
      dateColorOnImage: COLOR_NEUTRAL100,
      backgroundColorShade: COLOR_TURQUOISE200
    }
  }
];
export const CONTEXT_MENU_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      spacing: "7px"
    }
  }
];
export const CONTEXT_MENU_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      itemBackgroundColor: COLOR_NEUTRAL100,
      itemIconActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      itemIconHoverColor: COLOR_WHITE,
      itemLabelColor: COLOR_NEUTRAL800,
      itemLabelColorOnHover: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      itemBackgroundColor: COLOR_NEUTRAL100,
      itemIconActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      itemIconHoverColor: COLOR_WHITE,
      itemLabelColor: COLOR_NEUTRAL800,
      itemLabelColorOnHover: COLOR_WHITE
    }
  }
];
export const DATE_EVENT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      dateColor: COLOR_NEUTRAL100,
      dateLeftBorder: COLOR_NEUTRAL100_OPACITY_50
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      dateColor: COLOR_NEUTRAL800,
      dateLeftBorder: COLOR_NEUTRAL800_OPACITY_50
    }
  },
  {
    schemeName: "white",
    scheme: {
      dateColor: COLOR_NEUTRAL100,
      dateLeftBorder: COLOR_NEUTRAL100_OPACITY_50
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      dateColor: COLOR_NEUTRAL800,
      dateLeftBorder: COLOR_NEUTRAL800_OPACITY_50
    }
  }
];
export const DATE_PICKER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      fontColor: COLOR_NEUTRAL800,
      popupBackgroundColor: COLOR_NEUTRAL100,
      popupBorderColor: COLOR_TURQUOISE500,
      popupFocusBorderColor: COLOR_SYSTEM_HIGHLIGHT,
      separatorColor: COLOR_NEUTRAL500,
      dayBorderHoverColor: COLOR_TURQUOISE500,
      dayBorderSelectedColor: COLOR_RED500,
      dayBackgroundTodayColor: COLOR_NEUTRAL400,
      dayFontDisabledColor: COLOR_NEUTRAL500,
      dayFontOtherMonthColor: COLOR_NEUTRAL400,
      monthYearButtonBorderColor: COLOR_NEUTRAL400,
      scrollbarBackgroundColor: COLOR_NEUTRAL300,
      scrollbarThumbColor: COLOR_NEUTRAL600,
      monthYearToggleBorderColor: COLOR_NEUTRAL400,
      monthYearToggleBorderHoverColor: COLOR_TURQUOISE500,
      monthYearToggleBorderActiveColor: COLOR_TURQUOISE500,
      monthYearToggleBackgroundActiveColor: COLOR_TURQUOISE100,
      internalInputScheme: "neutral100"
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      fontColor: COLOR_NEUTRAL800,
      popupBackgroundColor: COLOR_NEUTRAL100,
      popupBorderColor: COLOR_TURQUOISE500,
      popupFocusBorderColor: COLOR_SYSTEM_HIGHLIGHT,
      separatorColor: COLOR_NEUTRAL500,
      dayBorderHoverColor: COLOR_TURQUOISE500,
      dayBorderSelectedColor: COLOR_RED500,
      dayBackgroundTodayColor: COLOR_NEUTRAL400,
      dayFontDisabledColor: COLOR_NEUTRAL500,
      dayFontOtherMonthColor: COLOR_NEUTRAL400,
      monthYearButtonBorderColor: COLOR_NEUTRAL400,
      scrollbarBackgroundColor: COLOR_NEUTRAL300,
      scrollbarThumbColor: COLOR_NEUTRAL600,
      monthYearToggleBorderColor: COLOR_NEUTRAL400,
      monthYearToggleBorderHoverColor: COLOR_TURQUOISE500,
      monthYearToggleBorderActiveColor: COLOR_TURQUOISE500,
      monthYearToggleBackgroundActiveColor: COLOR_TURQUOISE100,
      internalInputScheme: "neutral300"
    }
  },
  {
    schemeName: "white",
    scheme: {
      fontColor: COLOR_GREY900,
      popupBackgroundColor: COLOR_WHITE,
      popupBorderColor: COLOR_GREY800,
      popupFocusBorderColor: COLOR_SYSTEM_HIGHLIGHT,
      separatorColor: COLOR_NEUTRAL500,
      dayBorderHoverColor: COLOR_GREY900,
      dayBorderSelectedColor: COLOR_GREY900,
      dayBackgroundColor: COLOR_GREY100,
      dayBackgroundTodayColor: COLOR_GREY800,
      dayFontDisabledColor: COLOR_NEUTRAL500,
      dayFontOtherMonthColor: COLOR_NEUTRAL400,
      monthYearButtonBorderColor: COLOR_NEUTRAL400,
      scrollbarBackgroundColor: COLOR_NEUTRAL300,
      scrollbarThumbColor: COLOR_NEUTRAL600,
      monthYearToggleBorderColor: COLOR_GREY700,
      monthYearToggleBorderHoverColor: COLOR_GREY900,
      monthYearToggleBorderActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      monthYearToggleBackgroundActiveColor: COLOR_TRANSPARENT,
      internalInputScheme: "white"
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      fontColor: COLOR_GREY900,
      popupBackgroundColor: COLOR_WHITE,
      popupBorderColor: COLOR_GREY800,
      popupFocusBorderColor: COLOR_SYSTEM_HIGHLIGHT,
      separatorColor: COLOR_NEUTRAL500,
      dayBorderHoverColor: COLOR_GREY900,
      dayBorderSelectedColor: COLOR_GREY900,
      dayBackgroundColor: COLOR_GREY100,
      dayBackgroundTodayColor: COLOR_GREY800,
      dayFontDisabledColor: COLOR_NEUTRAL500,
      dayFontOtherMonthColor: COLOR_NEUTRAL400,
      monthYearButtonBorderColor: COLOR_NEUTRAL400,
      scrollbarBackgroundColor: COLOR_NEUTRAL300,
      scrollbarThumbColor: COLOR_NEUTRAL600,
      monthYearToggleBorderColor: COLOR_GREY700,
      monthYearToggleBorderHoverColor: COLOR_GREY900,
      monthYearToggleBorderActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      monthYearToggleBackgroundActiveColor: COLOR_TRANSPARENT,
      internalInputScheme: "grey100"
    }
  },
  {
    schemeName: "red500",
    scheme: {
      fontColor: COLOR_NEUTRAL800,
      popupBackgroundColor: COLOR_NEUTRAL100,
      popupBorderColor: COLOR_GREY800,
      popupFocusBorderColor: COLOR_SYSTEM_HIGHLIGHT,
      separatorColor: COLOR_NEUTRAL500,
      dayBorderHoverColor: COLOR_GREY900,
      dayBorderSelectedColor: COLOR_GREY900,
      dayBackgroundColor: COLOR_GREY100,
      dayBackgroundTodayColor: COLOR_GREY800,
      dayFontDisabledColor: COLOR_NEUTRAL500,
      dayFontOtherMonthColor: COLOR_NEUTRAL400,
      monthYearButtonBorderColor: COLOR_NEUTRAL400,
      scrollbarBackgroundColor: COLOR_NEUTRAL300,
      scrollbarThumbColor: COLOR_NEUTRAL600,
      monthYearToggleBorderColor: COLOR_GREY700,
      monthYearToggleBorderHoverColor: COLOR_GREY900,
      monthYearToggleBorderActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      monthYearToggleBackgroundActiveColor: COLOR_TRANSPARENT,
      internalInputScheme: "red500"
    }
  }
];
export const DIVIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral300"
  },
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "grey900",
    scheme: {
      color: COLOR_GREY900_OPACITY_20
    }
  },
  {
    schemeName: "white",
    scheme: {
      color: COLOR_WHITE_OPACITY_40
    }
  }
];
export const DROPDOWN_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      background: COLOR_TRANSPARENT,
      backgroundActive: COLOR_TRANSPARENT,
      borderColor: COLOR_GREY700,
      borderHoverColor: COLOR_GREY900,
      borderActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      borderHoverColorActive: COLOR_GREY900,
      labelColor: COLOR_GREY700,
      labelColorActive: COLOR_GREY900,
      errorMessageColor: COLOR_SYSTEM_ERROR,
      successColor: COLOR_SYSTEM_SUCCESS,
      trailingIconColor: COLOR_GREY900,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_GREY800,
      disabledTrailingIconColor: COLOR_GREY900,
      disabledLabelColor: COLOR_GREY900_OPACITY_40,
      disabledOpacity: 0.5,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderBottomColor: COLOR_TRANSPARENT,
      optionsBackgroundColorHover: COLOR_SYSTEM_HIGHLIGHT,
      chipScheme: "red500"
    }
  },
  {
    schemeName: "red500",
    scheme: {
      background: COLOR_RED500,
      backgroundActive: COLOR_WHITE,
      borderColor: COLOR_WHITE,
      borderHoverColor: COLOR_WHITE,
      borderActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      borderHoverColorActive: COLOR_GREY900,
      textColor: COLOR_WHITE_OPACITY_80,
      textColorActive: COLOR_GREY900,
      labelColor: COLOR_WHITE_OPACITY_80,
      labelColorActive: COLOR_WHITE,
      errorMessageColor: COLOR_SYSTEM_ERROR,
      successColor: COLOR_SYSTEM_SUCCESS,
      trailingIconColor: COLOR_WHITE,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_WHITE,
      disabledTrailingIconColor: COLOR_WHITE,
      disabledLabelColor: COLOR_WHITE_OPACITY_40,
      disabledOpacity: 0.5,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderBottomColor: COLOR_TRANSPARENT,
      optionsBackgroundColorHover: COLOR_SYSTEM_HIGHLIGHT,
      chipScheme: "white",
      chipSchemeFocus: "systemHighlight",
      outerBorderColor: COLOR_WHITE,
      optionContainerExtraMargin: "3px"
    }
  }
];
export const DROPDOWN_OPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      borderBottomColor: COLOR_TRANSPARENT,
      backgroundColorHover: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      borderBottomColor: COLOR_TRANSPARENT,
      backgroundColorHover: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "white",
    scheme: {
      borderBottomColor: COLOR_TRANSPARENT,
      backgroundColorHover: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      borderBottomColor: COLOR_TRANSPARENT,
      backgroundColorHover: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "red500",
    scheme: {
      borderBottomColor: COLOR_TRANSPARENT,
      backgroundColorHover: COLOR_SYSTEM_HIGHLIGHT,
      textColor: COLOR_NEUTRAL100
    }
  }
];
export const ERROR_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_RED500,
      leftBorderColor: COLOR_GREY300
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_RED500,
      leftBorderColor: COLOR_GREY300
    }
  },
  {
    schemeName: "error",
    scheme: {
      backgroundColor: COLOR_SYSTEM_ERROR_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_ERROR
    }
  },
  {
    schemeName: "warning",
    scheme: {
      backgroundColor: COLOR_SYSTEM_WARNING_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_WARNING
    }
  },
  {
    schemeName: "success",
    scheme: {
      backgroundColor: COLOR_SYSTEM_SUCCESS_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_SUCCESS
    }
  },
  {
    schemeName: "info",
    scheme: {
      backgroundColor: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED500,
      leftBorderColor: COLOR_GREY300
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED500,
      leftBorderColor: COLOR_GREY300
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      backgroundColor: COLOR_SYSTEM_WARNING_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_WARNING
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      backgroundColor: COLOR_SYSTEM_WARNING_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_WARNING
    }
  },
  {
    schemeName: "red100",
    scheme: {
      backgroundColor: COLOR_SYSTEM_ERROR_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_ERROR
    }
  },
  {
    schemeName: "red300",
    scheme: {
      backgroundColor: COLOR_SYSTEM_ERROR_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_ERROR
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      backgroundColor: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      backgroundColor: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_NEUTRAL800,
      leftBorderColor: COLOR_SYSTEM_HIGHLIGHT
    }
  }
];
export const FILE_UPLOAD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "grey100",
    scheme: {
      dropzoneBackground: COLOR_GREY100,
      dropzoneHoverBackground: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      dropzoneBorderSingle: COLOR_GREY800,
      dropzoneHoverBorder: COLOR_SYSTEM_HIGHLIGHT,
      dropzoneIconColor: COLOR_GREY900,
      dropzoneContentColor: COLOR_GREY900,
      dropzoneLinkColor: COLOR_GREY900,
      dropzoneDragOverBackground: COLOR_SYSTEM_ERROR_LIGHT,
      dropzoneDragOverBorder: COLOR_SYSTEM_ERROR_DARK,
      uploadedStatusColor: COLOR_GREY900,
      errorMessageColor: COLOR_RED500
    }
  },
  {
    schemeName: "white",
    scheme: {
      dropzoneBackground: COLOR_WHITE,
      dropzoneHoverBackground: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      dropzoneBorderSingle: COLOR_GREY800,
      dropzoneHoverBorder: COLOR_SYSTEM_HIGHLIGHT,
      dropzoneIconColor: COLOR_GREY900,
      dropzoneContentColor: COLOR_GREY900,
      dropzoneLinkColor: COLOR_GREY900,
      dropzoneDragOverBackground: COLOR_SYSTEM_ERROR_LIGHT,
      dropzoneDragOverBorder: COLOR_SYSTEM_ERROR_DARK,
      uploadedStatusColor: COLOR_GREY900,
      errorMessageColor: COLOR_RED500
    }
  },
  {
    schemeName: "red500",
    scheme: {
      dropzoneBackground: COLOR_RED500,
      dropzoneHoverBackground: COLOR_RED600,
      dropzoneBorderSingle: COLOR_WHITE,
      dropzoneHoverBorder: COLOR_WHITE,
      dropzoneIconColor: COLOR_WHITE,
      dropzoneContentColor: COLOR_WHITE,
      dropzoneLinkColor: COLOR_WHITE,
      dropzoneDragOverBackground: COLOR_SYSTEM_ERROR_LIGHT,
      dropzoneDragOverBorder: COLOR_SYSTEM_ERROR_DARK,
      uploadedStatusColor: COLOR_GREY900,
      errorMessageColor: COLOR_RED500,
      uploadCompleteBackground: COLOR_WHITE
    }
  }
];
export const FILE_PREVIEW_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "grey100"
  },
  {
    schemeName: "white"
  }
];
export const FORM_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "standard",
    scheme: {
      fontColor: COLOR_BRIGHT_FONT
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      fontColor: COLOR_WHITE,
      infoColor: COLOR_SYSTEM_HIGHLIGHT,
      successColor: COLOR_NEUTRAL100,
      errorColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "white",
    scheme: {
      fontColor: COLOR_WHITE,
      infoColor: COLOR_SYSTEM_HIGHLIGHT,
      successColor: COLOR_NEUTRAL100,
      errorColor: COLOR_NEUTRAL100
    }
  }
];
export const HEADLINE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "neutral800"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "grey900",
    scheme: {
      h1Color: COLOR_RED500
    }
  },
  {
    schemeName: "red500",
    scheme: {
      color: COLOR_GREY900,
      h1Color: COLOR_RED500
    }
  }
];
export const HEADLINE_BRAND_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "red500"
  },
  {
    schemeName: "grey900"
  }
];
export const HERO_SECTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      onBackgroundImageHeadlineScheme: "grey900"
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      onBackgroundImageHeadlineScheme: "grey900"
    }
  },
  {
    schemeName: "red500",
    scheme: {
      onBackgroundImageHeadlineScheme: "white"
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      backgroundColor: COLOR_RED500,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)",
      onBackgroundImageHeadlineScheme: "white"
    }
  }
];
export const ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      iconFocusColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      iconFocusColor: COLOR_WHITE
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      iconFocusColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "white",
    scheme: {
      iconFocusColor: COLOR_WHITE
    }
  },
  {
    schemeName: "red500",
    scheme: {
      iconFocusColor: COLOR_SYSTEM_HIGHLIGHT
    }
  }
];
export const INFO_ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      iconFocusColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      iconFocusColor: COLOR_WHITE
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      iconFocusColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "white",
    scheme: {
      iconFocusColor: COLOR_WHITE
    }
  },
  {
    schemeName: "red500",
    scheme: {
      iconFocusColor: COLOR_SYSTEM_HIGHLIGHT
    }
  }
];
export const INPUT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      background: COLOR_WHITE,
      backgroundActive: COLOR_WHITE,
      borderColor: COLOR_GREY800,
      borderHoverColor: COLOR_GREY900,
      borderHoverColorActive: COLOR_GREY900,
      labelColor: COLOR_GREY700,
      labelColorActive: COLOR_GREY900,
      trailingIconColor: COLOR_GREY900,
      trailingIconColorActive: COLOR_GREY900,
      successColor: COLOR_SYSTEM_SUCCESS,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_GREY800,
      disabledTrailingIconColor: COLOR_GREY900,
      disabledLabelColor: COLOR_GREY900_OPACITY_40,
      disabledOpacity: 0.5,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderBottomColor: COLOR_TRANSPARENT,
      optionsBackgroundColorHover: COLOR_GREY100
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      background: COLOR_GREY100,
      backgroundActive: COLOR_GREY100,
      borderColor: COLOR_GREY800,
      borderHoverColor: COLOR_GREY900,
      borderHoverColorActive: COLOR_GREY900,
      labelColor: COLOR_GREY700,
      labelColorActive: COLOR_GREY900,
      textColor: COLOR_GREY900,
      textColorActive: COLOR_GREY900,
      trailingIconColor: COLOR_GREY900,
      trailingIconColorActive: COLOR_GREY900,
      successColor: COLOR_SYSTEM_SUCCESS,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_GREY800,
      disabledTrailingIconColor: COLOR_GREY900,
      disabledLabelColor: COLOR_GREY900_OPACITY_40,
      disabledOpacity: 0.5,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderBottomColor: COLOR_TRANSPARENT,
      optionsBackgroundColorHover: COLOR_GREY100
    }
  },
  {
    schemeName: "white",
    scheme: {
      background: COLOR_WHITE,
      backgroundActive: COLOR_WHITE,
      borderColor: COLOR_GREY800,
      borderHoverColor: COLOR_GREY900,
      borderHoverColorActive: COLOR_GREY900,
      labelColor: COLOR_GREY700,
      labelColorActive: COLOR_GREY900,
      trailingIconColor: COLOR_GREY900,
      trailingIconColorActive: COLOR_GREY900,
      successColor: COLOR_SYSTEM_SUCCESS,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_GREY800,
      disabledTrailingIconColor: COLOR_GREY900,
      disabledLabelColor: COLOR_GREY900_OPACITY_40,
      disabledOpacity: 0.5,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderBottomColor: COLOR_TRANSPARENT,
      optionsBackgroundColorHover: COLOR_GREY100
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      background: COLOR_GREY100,
      backgroundActive: COLOR_GREY100,
      borderColor: COLOR_GREY800,
      borderHoverColor: COLOR_GREY900,
      borderHoverColorActive: COLOR_GREY900,
      labelColor: COLOR_GREY700,
      labelColorActive: COLOR_GREY900,
      textColor: COLOR_GREY900,
      textColorActive: COLOR_GREY900,
      trailingIconColor: COLOR_GREY900,
      trailingIconColorActive: COLOR_GREY900,
      successColor: COLOR_SYSTEM_SUCCESS,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_GREY800,
      disabledTrailingIconColor: COLOR_GREY900,
      disabledLabelColor: COLOR_GREY900_OPACITY_40,
      disabledOpacity: 0.5,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderBottomColor: COLOR_TRANSPARENT,
      optionsBackgroundColorHover: COLOR_GREY100
    }
  },
  {
    schemeName: "red500",
    scheme: {
      background: COLOR_RED500,
      backgroundActive: COLOR_WHITE,
      borderColor: COLOR_WHITE,
      borderHoverColor: COLOR_WHITE,
      borderHoverColorActive: COLOR_GREY900,
      textColor: COLOR_WHITE,
      textColorActive: COLOR_GREY900,
      labelColor: COLOR_WHITE_OPACITY_80,
      labelColorActive: COLOR_WHITE,
      successColor: COLOR_SYSTEM_SUCCESS,
      trailingIconColor: COLOR_WHITE,
      trailingIconColorActive: COLOR_GREY900,
      disabledBackgroundColor: COLOR_RED500,
      disabledBorderColor: COLOR_WHITE,
      disabledTrailingIconColor: COLOR_WHITE,
      disabledLabelColor: COLOR_WHITE_OPACITY_40,
      disabledOpacity: 0.5,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderBottomColor: COLOR_TRANSPARENT,
      optionsBackgroundColorHover: COLOR_GREY100,
      outerBorderColor: COLOR_WHITE
    }
  }
];
export const LINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800"
  },
  {
    schemeName: "neutral100",
    scheme: {
      contentHoverColor: COLOR_NEUTRAL100,
      contentFocusColor: COLOR_NEUTRAL100,
      inlineLinkHoverColor: COLOR_NEUTRAL100_OPACITY_80,
      focusColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "grey900"
  },
  {
    schemeName: "white",
    scheme: {
      contentHoverColor: COLOR_WHITE,
      contentFocusColor: COLOR_WHITE,
      inlineLinkHoverColor: COLOR_WHITE_OPACITY_80,
      focusColor: COLOR_WHITE
    }
  }
];
export const LINKLIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      linklistHoverColor: COLOR_GREY900
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      linklistHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      linklistHoverColor: COLOR_GREY900
    }
  },
  {
    schemeName: "white",
    scheme: {
      linklistHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "red500",
    scheme: {
      linklistHoverColor: COLOR_RED500
    }
  }
];
export const MAP_INFO_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      headerBackgroundColor: COLOR_NEUTRAL100,
      contentColor: COLOR_NEUTRAL800,
      contentBackgroundColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      headerBackgroundColor: COLOR_NEUTRAL300,
      contentColor: COLOR_NEUTRAL800,
      contentBackgroundColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "white",
    scheme: {
      headerBackgroundColor: COLOR_WHITE,
      contentColor: COLOR_GREY900,
      contentBackgroundColor: COLOR_WHITE
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      headerBackgroundColor: COLOR_GREY100,
      contentColor: COLOR_GREY900,
      contentBackgroundColor: COLOR_GREY100
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      headerBackgroundColor: COLOR_YELLOW100,
      contentColor: COLOR_NEUTRAL800,
      contentBackgroundColor: COLOR_YELLOW100
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      headerBackgroundColor: COLOR_YELLOW300,
      contentColor: COLOR_NEUTRAL800,
      contentBackgroundColor: COLOR_YELLOW300
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      headerBackgroundColor: COLOR_TURQUOISE100,
      contentColor: COLOR_NEUTRAL800,
      contentBackgroundColor: COLOR_TURQUOISE100
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      headerBackgroundColor: COLOR_TURQUOISE300,
      contentColor: COLOR_NEUTRAL800,
      contentBackgroundColor: COLOR_TURQUOISE300
    }
  },
  {
    schemeName: "red100",
    scheme: {
      headerBackgroundColor: COLOR_RED100,
      contentColor: COLOR_NEUTRAL800,
      contentBackgroundColor: COLOR_RED100
    }
  },
  {
    schemeName: "red300",
    scheme: {
      headerBackgroundColor: COLOR_RED300,
      contentColor: COLOR_NEUTRAL800,
      contentBackgroundColor: COLOR_RED300
    }
  },
  {
    schemeName: "red500",
    scheme: {
      headerBackgroundColor: COLOR_RED500,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_RED500
    }
  }
];
export const MULTI_CONTENT_STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      backgroundColor: COLOR_NEUTRAL100,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_NEUTRAL100,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      backgroundColor: COLOR_NEUTRAL300,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_NEUTRAL300,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "red100",
    scheme: {
      backgroundColor: COLOR_RED100,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_RED100,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "red300",
    scheme: {
      backgroundColor: COLOR_RED300,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_RED300,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      backgroundColor: COLOR_TURQUOISE100,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_TURQUOISE100,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      backgroundColor: COLOR_TURQUOISE300,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_TURQUOISE300,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      backgroundColor: COLOR_YELLOW100,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_YELLOW100,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      backgroundColor: COLOR_YELLOW300,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_YELLOW300,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_WHITE,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      backgroundColor: COLOR_GREY100,
      color: COLOR_NEUTRAL800,
      activeBackgroundColor: COLOR_GREY100,
      loadingBarColor: COLOR_RED500,
      controlColor: COLOR_RED500,
      controlColorHover: COLOR_RED700,
      controlIconColor: COLOR_NEUTRAL100,
      controlIconColorHover: COLOR_NEUTRAL100
    }
  }
];
export const NUMBER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800"
  },
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "grey900"
  },
  {
    schemeName: "white"
  }
];
export const OFFSET_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red500",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      backgroundColor: COLOR_RED500,
      linkHoverColor: COLOR_NEUTRAL300,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_GREY900
    }
  }
];
export const OPTION_PICKER_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      borderColor: COLOR_GREY800,
      borderHoverColor: COLOR_NEUTRAL800,
      borderSelectedColor: COLOR_SYSTEM_HIGHLIGHT,
      borderSelectedHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      textColor: COLOR_NEUTRAL800,
      errorMessageColor: COLOR_RED500
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      borderColor: COLOR_GREY800,
      borderHoverColor: COLOR_GREY900,
      borderSelectedColor: COLOR_SYSTEM_HIGHLIGHT,
      borderSelectedHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      textColor: COLOR_GREY900,
      errorMessageColor: COLOR_RED500
    }
  },
  {
    schemeName: "white",
    scheme: {
      borderColor: COLOR_WHITE,
      borderHoverColor: COLOR_WHITE,
      borderFocusColor: COLOR_WHITE,
      borderSelectedColor: COLOR_WHITE,
      borderSelectedHoverColor: COLOR_WHITE,
      textColor: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE
    }
  }
];
export const PAGINATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral400",
    scheme: {
      paginationActiveBackground: COLOR_NEUTRAL400,
      paginationActiveColor: COLOR_NEUTRAL800,
      paginationHoverBackground: COLOR_RED500,
      paginationHoverColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      paginationActiveBackground: COLOR_NEUTRAL400,
      paginationActiveColor: COLOR_NEUTRAL800,
      paginationHoverBackground: COLOR_RED500,
      paginationHoverColor: COLOR_NEUTRAL100
    }
  }
];
export const PRELOADER_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      trackColor: COLOR_NEUTRAL800_OPACITY_10
    }
  },
  {
    schemeName: "turquoise500",
    scheme: {
      trackColor: COLOR_NEUTRAL800_OPACITY_10
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      trackColor: COLOR_NEUTRAL800_OPACITY_10
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      trackColor: COLOR_NEUTRAL100_OPACITY_10
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      trackColor: COLOR_NEUTRAL800_OPACITY_10
    }
  },
  {
    schemeName: "white",
    scheme: {
      trackColor: COLOR_NEUTRAL100_OPACITY_10
    }
  },
  {
    schemeName: "colorful",
    scheme: {
      spinnerColor: COLOR_RED500,
      trackColor: COLOR_NEUTRAL800_OPACITY_5
    }
  }
];
export const PRELOADER_SQUARES_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      color: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise500",
    scheme: {
      color: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      color: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      color: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      color: COLOR_GREY900
    }
  },
  {
    schemeName: "white",
    scheme: {
      color: COLOR_WHITE
    }
  }
];
export const PROGRESS_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      textColor: COLOR_GREY900,
      iconColor: COLOR_GREY900,
      progressBackgroundColor: COLOR_GREY300,
      iconColorOnHover: COLOR_SYSTEM_ERROR_DARK,
      progressBackgroundColorOnHover: COLOR_GREY300,
      progressSuccessColor: COLOR_SYSTEM_SUCCESS,
      iconSuccessColor: COLOR_SYSTEM_SUCCESS_DARK
    }
  },
  {
    schemeName: "white",
    scheme: {
      textColor: COLOR_WHITE,
      iconColor: COLOR_WHITE,
      progressBackgroundColor: COLOR_WHITE_OPACITY_30,
      iconColorOnHover: COLOR_WHITE,
      progressBackgroundColorOnHover: COLOR_WHITE_OPACITY_30,
      progressSuccessColor: COLOR_WHITE,
      iconSuccessColor: COLOR_WHITE
    }
  }
];
export const PROMO_FLAG_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "purple500",
    scheme: {
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "blue700",
    scheme: {
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      textColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "white",
    scheme: {
      textColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow500",
    scheme: {
      textColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise500",
    scheme: {
      textColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      textColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      textColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      textColor: COLOR_NEUTRAL100
    }
  }
];
export const PAGE_HEADER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "red500",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      contentColor: COLOR_RED500_FONT,
      backgroundColor: COLOR_RED500,
      linkHoverColor: COLOR_NEUTRAL300,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  }
];
export const PICTOGRAM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800"
  },
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "grey900"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "red500"
  }
];
export const RADIO_BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      uncheckedColor: COLOR_GREY800,
      uncheckedHoverColor: COLOR_GREY800,
      checkedColor: COLOR_SYSTEM_HIGHLIGHT,
      checkedHoverColor: COLOR_SYSTEM_HIGHLIGHT,
      errorColor: COLOR_SYSTEM_ERROR,
      labelColor: COLOR_NEUTRAL800,
      disabledLabelColor: COLOR_GREY800,
      focusColor: COLOR_SYSTEM_HIGHLIGHT,
      outlineColor: COLOR_SYSTEM_ERROR_DARK
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      uncheckedColor: COLOR_NEUTRAL100,
      uncheckedHoverColor: COLOR_NEUTRAL100,
      checkedColor: COLOR_NEUTRAL100,
      checkedHoverColor: COLOR_NEUTRAL100,
      errorColor: COLOR_NEUTRAL100,
      labelColor: COLOR_NEUTRAL100,
      disabledLabelColor: COLOR_NEUTRAL100,
      focusColor: COLOR_WHITE,
      outlineColor: COLOR_WHITE
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      uncheckedColor: COLOR_GREY800,
      uncheckedHoverColor: COLOR_GREY800,
      checkedColor: COLOR_SYSTEM_HIGHLIGHT,
      checkedHoverColor: COLOR_SYSTEM_HIGHLIGHT,
      errorColor: COLOR_SYSTEM_ERROR,
      labelColor: COLOR_NEUTRAL800,
      disabledLabelColor: COLOR_GREY800,
      focusColor: COLOR_SYSTEM_HIGHLIGHT,
      outlineColor: COLOR_SYSTEM_ERROR_DARK
    }
  },
  {
    schemeName: "white",
    scheme: {
      uncheckedColor: COLOR_NEUTRAL100,
      uncheckedHoverColor: COLOR_NEUTRAL100,
      checkedColor: COLOR_NEUTRAL100,
      checkedHoverColor: COLOR_NEUTRAL100,
      errorColor: COLOR_NEUTRAL100,
      labelColor: COLOR_NEUTRAL100,
      disabledLabelColor: COLOR_NEUTRAL100,
      focusColor: COLOR_WHITE,
      outlineColor: COLOR_WHITE
    }
  }
];
export const READ_MORE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      rulerColor: COLOR_NEUTRAL800,
      rulerButtonHoverColor: COLOR_RED500,
      rulerArrowColor: COLOR_NEUTRAL100,
      rulerColorHover: COLOR_RED500,
      focusBorderColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "red500",
    scheme: {
      rulerColor: COLOR_RED500,
      rulerButtonHoverColor: COLOR_RED700,
      rulerArrowColor: COLOR_NEUTRAL100,
      rulerColorHover: COLOR_RED700,
      focusBorderColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "white",
    scheme: {
      rulerColor: COLOR_WHITE,
      rulerButtonHoverColor: COLOR_WHITE_OPACITY_80,
      rulerArrowColor: COLOR_RED500,
      textColor: COLOR_WHITE,
      rulerColorHover: COLOR_WHITE,
      focusBorderColor: COLOR_WHITE
    }
  },
  {
    schemeName: "grey600",
    scheme: {
      rulerColor: COLOR_GREY600,
      rulerButtonHoverColor: COLOR_GREY800,
      rulerArrowColor: COLOR_NEUTRAL100,
      textColor: COLOR_GREY900,
      rulerColorHover: COLOR_GREY900,
      focusBorderColor: COLOR_SYSTEM_HIGHLIGHT
    }
  }
];
export const RTE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800"
  },
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "grey900"
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_WHITE,
      linkOutlineColor: COLOR_WHITE,
      linkHoverOpacity: `0.8`
    }
  }
];
export const SECTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "neutral300"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "grey100"
  },
  {
    schemeName: "red500"
  },
  {
    schemeName: "red500gradient",
    scheme: {
      bgColor: COLOR_RED500,
      footerSeparatorColor: COLOR_RED500_SHADE_1,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  },
  {
    schemeName: "transparent"
  }
];
export const SEGMENTED_BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      borderColor: COLOR_GREY600,
      borderHoverColor: COLOR_GREY600,
      borderActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      borderActiveHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      backgroundColor: COLOR_TRANSPARENT,
      backgroundHoverColor: COLOR_GREY900_OPACITY_8,
      backgroundActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      backgroundActiveHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      fontColor: COLOR_GREY900,
      fontHoverColor: COLOR_GREY900,
      fontActiveColor: COLOR_WHITE,
      fontActiveHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      borderColor: COLOR_RED300,
      borderHoverColor: COLOR_RED300,
      borderActiveColor: COLOR_WHITE,
      borderFocusColor: COLOR_WHITE,
      borderActiveHoverColor: COLOR_GREY100,
      borderActiveFocusColor: COLOR_SYSTEM_HIGHLIGHT,
      backgroundColor: COLOR_TRANSPARENT,
      backgroundHoverColor: COLOR_RED600,
      backgroundActiveColor: COLOR_WHITE,
      backgroundActiveHoverColor: COLOR_GREY100,
      fontColor: COLOR_WHITE,
      fontHoverColor: COLOR_WHITE,
      fontActiveColor: COLOR_GREY900,
      fontActiveHoverColor: COLOR_GREY900
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      borderColor: COLOR_GREY600,
      borderHoverColor: COLOR_GREY600,
      borderActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      borderActiveHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      backgroundColor: COLOR_TRANSPARENT,
      backgroundHoverColor: COLOR_GREY900_OPACITY_8,
      backgroundActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      backgroundActiveHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      fontColor: COLOR_GREY900,
      fontHoverColor: COLOR_GREY900,
      fontActiveColor: COLOR_WHITE,
      fontActiveHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      borderColor: COLOR_RED300,
      borderHoverColor: COLOR_RED300,
      borderActiveColor: COLOR_WHITE,
      borderFocusColor: COLOR_WHITE,
      borderActiveHoverColor: COLOR_GREY100,
      borderActiveFocusColor: COLOR_SYSTEM_HIGHLIGHT,
      backgroundColor: COLOR_TRANSPARENT,
      backgroundHoverColor: COLOR_RED600,
      backgroundActiveColor: COLOR_WHITE,
      backgroundActiveHoverColor: COLOR_GREY100,
      fontColor: COLOR_WHITE,
      fontHoverColor: COLOR_WHITE,
      fontActiveColor: COLOR_GREY900,
      fontActiveHoverColor: COLOR_GREY900
    }
  }
];
export const SEARCH_RESULT_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      contentFontColor: COLOR_NEUTRAL800,
      contentBackground: COLOR_TRANSPARENT,
      descriptionBackground: COLOR_TRANSPARENT,
      descriptionBackgroundHoverColor: COLOR_TRANSPARENT,
      dividerColor: COLOR_GREY800,
      focusBorder: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "white",
    scheme: {
      contentFontColor: COLOR_GREY900,
      contentBackground: COLOR_TRANSPARENT,
      descriptionBackground: COLOR_TRANSPARENT,
      descriptionBackgroundHoverColor: COLOR_TRANSPARENT,
      dividerColor: COLOR_GREY800,
      focusBorder: COLOR_SYSTEM_HIGHLIGHT
    }
  }
];
export const SITELINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      linkColor: COLOR_NEUTRAL800,
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      linkColor: COLOR_NEUTRAL800,
      linkHoverColor: COLOR_NEUTRAL800
    }
  }
];
export const SLIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      knobColor: COLOR_NEUTRAL100,
      knobHoverColor: COLOR_NEUTRAL300,
      knobBorderColor: COLOR_RED500,
      knobBorderHoverColor: COLOR_RED700,
      barColor: COLOR_NEUTRAL400,
      barActiveColor: COLOR_RED700,
      pipTextColor: COLOR_NEUTRAL800,
      pipColor: COLOR_NEUTRAL400,
      pipHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      knobColor: COLOR_RED500,
      knobHoverColor: COLOR_NEUTRAL300,
      knobBorderColor: COLOR_NEUTRAL100,
      knobBorderHoverColor: COLOR_NEUTRAL300,
      barColor: COLOR_NEUTRAL100_OPACITY_30,
      barHoverColor: COLOR_NEUTRAL100_OPACITY_30,
      barActiveColor: COLOR_NEUTRAL100,
      barBorderColor: COLOR_NEUTRAL100_OPACITY_80,
      barBorderHoverColor: COLOR_NEUTRAL100,
      pipTextColor: COLOR_NEUTRAL100,
      pipColor: COLOR_RED300,
      pipHoverColor: COLOR_NEUTRAL300,
      errorColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "systemHighlight",
    scheme: {
      knobBorderColor: COLOR_SYSTEM_HIGHLIGHT,
      knobBorderHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      barActiveColor: COLOR_SYSTEM_HIGHLIGHT_DARK
    }
  },
  {
    schemeName: "white",
    scheme: {
      knobColor: COLOR_RED500,
      knobHoverColor: COLOR_RED500,
      knobBorderColor: COLOR_WHITE,
      knobBorderHoverColor: COLOR_WHITE,
      barColor: COLOR_WHITE_OPACITY_30,
      barHoverColor: COLOR_WHITE_OPACITY_30,
      barActiveColor: COLOR_WHITE,
      barBorderColor: COLOR_WHITE_OPACITY_80,
      barBorderHoverColor: COLOR_WHITE,
      pipTextColor: COLOR_WHITE_OPACITY_80,
      pipColor: COLOR_WHITE,
      pipHoverColor: COLOR_WHITE,
      errorColor: COLOR_WHITE,
      focusColor: COLOR_WHITE
    }
  }
];
export const SWITCH_TOGGLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      errorColor: COLOR_NEUTRAL100,
      labelColorDisabled: COLOR_NEUTRAL100_OPACITY_60,
      outlineColor: COLOR_NEUTRAL100,
      borderColorDisabled: COLOR_NEUTRAL100_OPACITY_60,
      borderColorSelected: COLOR_NEUTRAL100,
      borderColorSelectedFocus: COLOR_NEUTRAL100,
      borderColorSelectedDisabled: COLOR_NEUTRAL100_OPACITY_60,
      iconColor: COLOR_NEUTRAL100,
      iconColorHover: COLOR_NEUTRAL100,
      iconColorDisabled: COLOR_NEUTRAL100_OPACITY_60,
      iconColorFocus: COLOR_NEUTRAL100,
      iconColorSelected: COLOR_NEUTRAL100,
      iconColorSelectedHover: COLOR_NEUTRAL100,
      iconColorSelectedDisabled: COLOR_NEUTRAL100_OPACITY_60
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      errorColor: COLOR_SYSTEM_ERROR,
      labelColorDisabled: COLOR_NEUTRAL600,
      outlineColor: COLOR_SYSTEM_HIGHLIGHT,
      borderColorDisabled: COLOR_NEUTRAL600,
      borderColorSelected: COLOR_SYSTEM_HIGHLIGHT,
      borderColorSelectedFocus: COLOR_RED800,
      borderColorSelectedDisabled: COLOR_NEUTRAL600,
      iconColor: COLOR_GREY800,
      iconColorHover: COLOR_GREY800,
      iconColorDisabled: COLOR_NEUTRAL600,
      iconColorFocus: COLOR_NEUTRAL800,
      iconColorSelected: COLOR_SYSTEM_HIGHLIGHT,
      iconColorSelectedHover: COLOR_SYSTEM_HIGHLIGHT_DARK,
      iconColorSelectedDisabled: COLOR_NEUTRAL600
    }
  },
  {
    schemeName: "white",
    scheme: {
      errorColor: COLOR_NEUTRAL100,
      labelColorDisabled: COLOR_NEUTRAL100_OPACITY_60,
      outlineColor: COLOR_NEUTRAL100,
      borderColorDisabled: COLOR_NEUTRAL100_OPACITY_60,
      borderColorSelected: COLOR_NEUTRAL100,
      borderColorSelectedFocus: COLOR_NEUTRAL100,
      borderColorSelectedDisabled: COLOR_NEUTRAL100_OPACITY_60,
      iconColor: COLOR_NEUTRAL100,
      iconColorHover: COLOR_NEUTRAL100,
      iconColorDisabled: COLOR_NEUTRAL100_OPACITY_60,
      iconColorFocus: COLOR_NEUTRAL100,
      iconColorSelected: COLOR_NEUTRAL100,
      iconColorSelectedHover: COLOR_NEUTRAL100,
      iconColorSelectedDisabled: COLOR_NEUTRAL100_OPACITY_60
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      errorColor: COLOR_SYSTEM_ERROR,
      labelColorDisabled: COLOR_NEUTRAL600,
      outlineColor: COLOR_SYSTEM_HIGHLIGHT,
      borderColorDisabled: COLOR_NEUTRAL600,
      borderColorSelected: COLOR_SYSTEM_HIGHLIGHT,
      borderColorSelectedFocus: COLOR_RED800,
      borderColorSelectedDisabled: COLOR_NEUTRAL600,
      iconColor: COLOR_GREY800,
      iconColorHover: COLOR_GREY800,
      iconColorDisabled: COLOR_NEUTRAL600,
      iconColorFocus: COLOR_NEUTRAL800,
      iconColorSelected: COLOR_SYSTEM_HIGHLIGHT,
      iconColorSelectedHover: COLOR_SYSTEM_HIGHLIGHT_DARK,
      iconColorSelectedDisabled: COLOR_NEUTRAL600
    }
  }
];
export const STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      contentBoxSubheadlineColor: COLOR_RED500,
      subheadlineColor: COLOR_NEUTRAL100,
      headlineScheme: "neutral100",
      linkScheme: "neutral100",
      buttonScheme: "neutral100",
      contentBoxHeadlineScheme: "red500",
      contentBoxButtonScheme: "red500",
      contentBoxLinkScheme: "neutral800"
    }
  },
  {
    schemeName: "white",
    scheme: {
      contentBoxSubheadlineColor: COLOR_RED500,
      subheadlineColor: COLOR_NEUTRAL100,
      headlineScheme: "neutral100",
      linkScheme: "neutral100",
      buttonScheme: "neutral100",
      contentBoxHeadlineScheme: "red500",
      contentBoxButtonScheme: "red500",
      contentBoxLinkScheme: "neutral800"
    }
  },
  {
    schemeName: "red500",
    scheme: {
      contentBoxSubheadlineColor: COLOR_NEUTRAL100,
      subheadlineColor: COLOR_RED500,
      headlineScheme: "red500",
      linkScheme: "neutral800",
      buttonScheme: "red500",
      contentBoxHeadlineScheme: "neutral100",
      contentBoxButtonScheme: "neutral100",
      contentBoxLinkScheme: "neutral100"
    }
  }
];
export const STATE_PILL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "active",
    scheme: {
      primaryBackgroundColor: COLOR_SYSTEM_SUCCESS_LIGHT,
      secondaryBackgroundColor: COLOR_SYSTEM_SUCCESS_DARK,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_WHITE
    }
  },
  {
    schemeName: "pending",
    scheme: {
      primaryBackgroundColor: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      secondaryBackgroundColor: COLOR_SYSTEM_HIGHLIGHT,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_WHITE
    }
  },
  {
    schemeName: "error",
    scheme: {
      primaryBackgroundColor: COLOR_SYSTEM_ERROR_LIGHT,
      secondaryBackgroundColor: COLOR_SYSTEM_ERROR_DARK,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_WHITE
    }
  },
  {
    schemeName: "warning",
    scheme: {
      primaryBackgroundColor: COLOR_SYSTEM_WARNING_LIGHT,
      secondaryBackgroundColor: COLOR_SYSTEM_WARNING,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_GREY900
    }
  },
  {
    schemeName: "inactive",
    scheme: {
      primaryBackgroundColor: COLOR_GREY200,
      secondaryBackgroundColor: COLOR_GREY700,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_WHITE
    }
  }
];
export const STEP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      inactiveStepColor: COLOR_NEUTRAL800,
      inactiveIconColor: COLOR_NEUTRAL800,
      inactiveTextColor: COLOR_GREY700,
      activeStepColor: COLOR_NEUTRAL800,
      activeStepShadowColor: COLOR_NEUTRAL800,
      activeIconColor: COLOR_NEUTRAL100,
      activeTextColor: COLOR_NEUTRAL800,
      doneStepColor: COLOR_NEUTRAL800,
      doneIconColor: COLOR_NEUTRAL100,
      doneTextColor: COLOR_NEUTRAL800,
      errorStepColor: COLOR_SYSTEM_ERROR_DARK,
      errorStepShadowColor: COLOR_SYSTEM_ERROR_DARK,
      errorIconColor: COLOR_NEUTRAL100,
      errorTextColor: COLOR_SYSTEM_ERROR_DARK,
      tooltipScheme: "white"
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      inactiveStepColor: COLOR_GREY900,
      inactiveIconColor: COLOR_GREY900,
      inactiveTextColor: COLOR_GREY700,
      activeStepColor: COLOR_GREY900,
      activeStepShadowColor: COLOR_GREY900,
      activeIconColor: COLOR_WHITE,
      activeTextColor: COLOR_GREY900,
      doneStepColor: COLOR_GREY900,
      doneIconColor: COLOR_WHITE,
      doneTextColor: COLOR_GREY900,
      errorStepColor: COLOR_SYSTEM_ERROR_DARK,
      errorStepShadowColor: COLOR_SYSTEM_ERROR_DARK,
      errorIconColor: COLOR_WHITE,
      errorTextColor: COLOR_SYSTEM_ERROR_DARK,
      tooltipScheme: "white"
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      inactiveStepColor: COLOR_NEUTRAL100,
      inactiveIconColor: COLOR_NEUTRAL100,
      inactiveTextColor: COLOR_NEUTRAL100,
      activeStepColor: COLOR_NEUTRAL100,
      activeStepShadowColor: COLOR_NEUTRAL100,
      activeIconColor: COLOR_RED500,
      activeTextColor: COLOR_NEUTRAL100,
      doneStepColor: COLOR_NEUTRAL100,
      doneIconColor: COLOR_RED500,
      doneTextColor: COLOR_NEUTRAL100,
      errorStepColor: COLOR_NEUTRAL100,
      errorStepShadowColor: COLOR_NEUTRAL100,
      errorIconColor: COLOR_RED500,
      errorTextColor: COLOR_NEUTRAL100,
      focusColor: COLOR_NEUTRAL100,
      tooltipScheme: "white"
    }
  },
  {
    schemeName: "white",
    scheme: {
      inactiveStepColor: COLOR_WHITE,
      inactiveIconColor: COLOR_WHITE,
      inactiveTextColor: COLOR_WHITE,
      activeStepColor: COLOR_WHITE,
      activeStepShadowColor: COLOR_WHITE,
      activeIconColor: COLOR_RED500,
      activeTextColor: COLOR_WHITE,
      doneStepColor: COLOR_WHITE,
      doneIconColor: COLOR_RED500,
      doneTextColor: COLOR_WHITE,
      errorStepColor: COLOR_WHITE,
      errorStepShadowColor: COLOR_WHITE,
      errorIconColor: COLOR_RED500,
      errorTextColor: COLOR_WHITE,
      focusColor: COLOR_WHITE,
      tooltipScheme: "white"
    }
  }
];
export const STEPS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800"
  },
  {
    schemeName: "grey900"
  },
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "white"
  }
];
export const TABLE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      paragraphColor: COLOR_GREY900,
      tableBorderColor: COLOR_GREY900,
      tableHighlightColor: COLOR_GREY900,
      tableBackgroundColor: COLOR_TRANSPARENT,
      rowHoverColor: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      tableAlternateBackgroundColor: COLOR_GREY100_OPACITY_50
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      paragraphColor: COLOR_GREY900,
      tableBorderColor: COLOR_GREY900,
      tableHighlightColor: COLOR_GREY900,
      tableBackgroundColor: COLOR_TRANSPARENT,
      rowHoverColor: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      tableAlternateBackgroundColor: COLOR_GREY100_OPACITY_50
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      paragraphColor: COLOR_WHITE,
      tableBorderColor: COLOR_WHITE,
      tableHighlightColor: COLOR_WHITE,
      tableBackgroundColor: COLOR_TRANSPARENT,
      rowHoverColor: COLOR_RED700,
      tableAlternateBackgroundColor: COLOR_TRANSPARENT
    }
  },
  {
    schemeName: "white",
    scheme: {
      paragraphColor: COLOR_WHITE,
      tableBorderColor: COLOR_WHITE,
      tableHighlightColor: COLOR_WHITE,
      tableBackgroundColor: COLOR_TRANSPARENT,
      rowHoverColor: COLOR_RED700,
      tableAlternateBackgroundColor: COLOR_TRANSPARENT
    }
  }
];
export const TABS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800",
    scheme: {
      textColor: COLOR_NEUTRAL800,
      tabBorderColor: COLOR_GREY600,
      tabActiveBorderColor: COLOR_NEUTRAL800,
      tabHoverColor: COLOR_GREY900_OPACITY_8,
      tabFocusColor: COLOR_TRANSPARENT
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      textColor: COLOR_GREY900,
      tabBorderColor: COLOR_GREY600,
      tabActiveBorderColor: COLOR_GREY900,
      tabHoverColor: COLOR_GREY900_OPACITY_8,
      tabFocusColor: COLOR_TRANSPARENT
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      textColor: COLOR_NEUTRAL100,
      tabBorderColor: COLOR_RED300,
      tabActiveBorderColor: COLOR_NEUTRAL100,
      tabHoverColor: COLOR_SYSTEM_ERROR_DARK,
      tabFocusColor: COLOR_TRANSPARENT,
      tabFocusBorderColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "white",
    scheme: {
      textColor: COLOR_WHITE,
      tabBorderColor: COLOR_RED300,
      tabActiveBorderColor: COLOR_WHITE,
      tabHoverColor: COLOR_SYSTEM_ERROR_DARK,
      tabFocusColor: COLOR_TRANSPARENT,
      tabFocusBorderColor: COLOR_WHITE
    }
  }
];
export const TAB_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "grey900",
    scheme: {
      tabSeparatorColor: COLOR_GREY600,
      tabBorderHoverColor: COLOR_GREY600,
      tabBorderFocusColor: COLOR_GREY600,
      tabBackgroundHoverColor: COLOR_GREY900_OPACITY_8
    }
  },
  {
    schemeName: "white",
    scheme: {
      tabSeparatorColor: COLOR_RED300,
      tabBorderHoverColor: COLOR_RED300,
      tabBorderFocusColor: COLOR_RED300,
      tabBackgroundHoverColor: COLOR_RED600,
      focusOutlineColor: COLOR_WHITE
    }
  }
];
export const TAG_PILL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      backgroundHoverColor: COLOR_RED400,
      backgroundActiveHoverColor: COLOR_RED200,
      textAndIconHoverColor: COLOR_NEUTRAL100,
      textAndIconActiveColor: COLOR_RED500,
      textAndIconActiveHoverColor: COLOR_RED700,
      borderColor: COLOR_RED300,
      borderHoverColor: COLOR_RED200,
      focusBorderColor: COLOR_RED200_OPACITY_25,
      selectedBackgroundHoverColor: COLOR_NEUTRAL400,
      selectedFocusBorderColor: COLOR_NEUTRAL100_OPACITY_25
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      backgroundHoverColor: COLOR_NEUTRAL400,
      backgroundActiveHoverColor: COLOR_NEUTRAL600,
      textAndIconHoverColor: COLOR_NEUTRAL800,
      textAndIconActiveColor: COLOR_NEUTRAL100,
      textAndIconActiveHoverColor: COLOR_NEUTRAL100,
      borderColor: COLOR_NEUTRAL500,
      borderHoverColor: COLOR_NEUTRAL600,
      focusBorderColor: COLOR_NEUTRAL600_OPACITY_25,
      selectedBackgroundHoverColor: COLOR_NEUTRAL700,
      selectedFocusBorderColor: COLOR_NEUTRAL700_OPACITY_25
    }
  },
  {
    schemeName: "red500",
    scheme: {
      backgroundHoverColor: COLOR_RED200,
      backgroundActiveHoverColor: COLOR_RED400,
      textAndIconHoverColor: COLOR_RED800,
      textAndIconActiveColor: COLOR_NEUTRAL100,
      textAndIconActiveHoverColor: COLOR_NEUTRAL100,
      borderColor: COLOR_RED300,
      borderHoverColor: COLOR_RED400,
      focusBorderColor: COLOR_RED400_OPACITY_25,
      selectedBackgroundHoverColor: COLOR_RED800,
      selectedFocusBorderColor: COLOR_RED800_OPACITY_25
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      backgroundHoverColor: COLOR_TRANSPARENT,
      backgroundActiveColor: COLOR_SYSTEM_HIGHLIGHT,
      backgroundActiveHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      textAndIconHoverColor: COLOR_GREY900,
      textAndIconActiveColor: COLOR_NEUTRAL100,
      textAndIconActiveHoverColor: COLOR_NEUTRAL100,
      borderColor: COLOR_GREY900,
      borderHoverColor: COLOR_GREY900,
      focusBorderColor: COLOR_SYSTEM_HIGHLIGHT,
      selectedBackgroundHoverColor: COLOR_SYSTEM_HIGHLIGHT_DARK,
      selectedFocusBorderColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "white",
    scheme: {
      backgroundHoverColor: COLOR_TRANSPARENT,
      backgroundActiveColor: COLOR_WHITE,
      backgroundActiveHoverColor: COLOR_WHITE_OPACITY_80,
      textAndIconHoverColor: COLOR_WHITE,
      textAndIconActiveColor: COLOR_RED500,
      textAndIconActiveHoverColor: COLOR_RED500,
      borderColor: COLOR_WHITE,
      borderHoverColor: COLOR_WHITE,
      focusBorderColor: COLOR_WHITE,
      selectedBackgroundHoverColor: COLOR_WHITE_OPACITY_80,
      selectedFocusBorderColor: COLOR_WHITE
    }
  }
];
export const TEXT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral800"
  },
  {
    schemeName: "neutral100"
  },
  {
    schemeName: "grey900"
  },
  {
    schemeName: "white"
  }
];
export const TEXT_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED500
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red500",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL300
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      valueTextColor: COLOR_RED500_FONT,
      contentColor: COLOR_RED500_FONT,
      contentBackgroundColor: COLOR_RED500,
      linkHoverColor: COLOR_NEUTRAL300,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_GREY900
    }
  }
];
export const THIRD_LEVEL_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      tabBorderColor: COLOR_RED400,
      tabActiveBorderColor: COLOR_RED300
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      tabBorderColor: COLOR_NEUTRAL300,
      tabActiveBorderColor: COLOR_NEUTRAL400
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      tabBorderColor: COLOR_NEUTRAL400,
      tabActiveBorderColor: COLOR_NEUTRAL500
    }
  },
  {
    schemeName: "white",
    scheme: {
      tabBorderColor: COLOR_NEUTRAL300,
      tabActiveBorderColor: COLOR_NEUTRAL400
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      tabBorderColor: COLOR_NEUTRAL400,
      tabActiveBorderColor: COLOR_NEUTRAL500
    }
  }
];
export const THIRD_LEVEL_NAVIGATION_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      textColor: COLOR_NEUTRAL100,
      textHoverColor: COLOR_NEUTRAL100,
      tabHoverColor: COLOR_RED700,
      tabHoverBorderColor: COLOR_RED300
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      textColor: COLOR_NEUTRAL800,
      textHoverColor: COLOR_NEUTRAL800,
      tabHoverColor: COLOR_NEUTRAL300,
      tabHoverBorderColor: COLOR_NEUTRAL400
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      textColor: COLOR_NEUTRAL800,
      textHoverColor: COLOR_NEUTRAL800,
      tabHoverColor: COLOR_NEUTRAL400,
      tabHoverBorderColor: COLOR_NEUTRAL500
    }
  },
  {
    schemeName: "white",
    scheme: {
      textColor: COLOR_NEUTRAL800,
      textHoverColor: COLOR_NEUTRAL800,
      tabHoverColor: COLOR_NEUTRAL300,
      tabHoverBorderColor: COLOR_NEUTRAL400
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      textColor: COLOR_NEUTRAL800,
      textHoverColor: COLOR_NEUTRAL800,
      tabHoverColor: COLOR_NEUTRAL400,
      tabHoverBorderColor: COLOR_NEUTRAL500
    }
  }
];
export const TILES_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red100",
    scheme: {
      hoverBackgroundColor: COLOR_RED300,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "red300",
    scheme: {
      hoverBackgroundColor: COLOR_RED100,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      hoverBackgroundColor: COLOR_NEUTRAL400,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      hoverBackgroundColor: COLOR_NEUTRAL400,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow100",
    scheme: {
      hoverBackgroundColor: COLOR_YELLOW300,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "yellow300",
    scheme: {
      hoverBackgroundColor: COLOR_YELLOW100,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise100",
    scheme: {
      hoverBackgroundColor: COLOR_TURQUOISE300,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "turquoise300",
    scheme: {
      hoverBackgroundColor: COLOR_TURQUOISE100,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "white",
    scheme: {
      hoverBackgroundColor: COLOR_GREY100,
      hoverColor: COLOR_NEUTRAL800
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      hoverBackgroundColor: COLOR_GREY200,
      hoverColor: COLOR_GREY900
    }
  },
  {
    schemeName: "red500",
    scheme: {
      hoverBackgroundColor: COLOR_RED600,
      hoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "red500gradient",
    scheme: {
      backgroundColor: COLOR_RED500,
      hoverBackgroundColor: COLOR_RED600,
      hoverColor: COLOR_WHITE,
      gradientColor:
        "linear-gradient(135deg, hsl(5deg 92% 48%) 0%, hsl(5deg 92% 48%) 55%, hsl(337deg 85% 41%) 80%, hsl(309deg 76% 33%) 95%)"
    }
  }
];
export const TOOLTIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "grey900"
  }
];
export const VIDEOPLAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "neutral100",
    scheme: {
      playButtonColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "white",
    scheme: {
      playButtonColor: COLOR_WHITE
    }
  }
];
export const VIOLATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500",
    scheme: {
      textColor: COLOR_WHITE
    }
  },
  {
    schemeName: "yellow500",
    scheme: {
      textColor: COLOR_NEUTRAL900
    }
  },
  {
    schemeName: "turquoise500",
    scheme: {
      textColor: COLOR_NEUTRAL900
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      textColor: COLOR_NEUTRAL900
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      textColor: COLOR_NEUTRAL900
    }
  },
  {
    schemeName: "neutral800",
    scheme: {
      textColor: COLOR_NEUTRAL100
    }
  },
  {
    schemeName: "purple500",
    scheme: {
      textColor: COLOR_WHITE
    }
  },
  {
    schemeName: "blue700",
    scheme: {
      textColor: COLOR_WHITE
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      textColor: COLOR_GREY900
    }
  },
  {
    schemeName: "grey900",
    scheme: {
      textColor: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      textColor: COLOR_GREY900
    }
  }
];

export interface AccordionSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  red500?: T;
}
export interface AnswerCardSchemeConfiguration<T> {
  neutral100?: T;
  red500?: T;
  white?: T;
}
export interface BadgeSchemeConfiguration<T> {
  neutral100?: T;
  neutral800?: T;
  white?: T;
  grey900?: T;
}
export interface BasicTeaserSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  yellow100?: T;
  yellow300?: T;
  red100?: T;
  red300?: T;
  red500?: T;
  red500gradient?: T;
  turquoise100?: T;
  turquoise300?: T;
  white?: T;
  grey100?: T;
}
export interface BreadcrumbSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface BottomDrawerSchemeConfiguration<T> {
  red500?: T;
}
export interface BulletListSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface BusinesscardAuthorSchemeConfiguration<T> {
  neutral100?: T;
  neutral800?: T;
  grey900?: T;
  white?: T;
}
export interface BusinesscardContactSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  yellow100?: T;
  yellow300?: T;
  red100?: T;
  red300?: T;
  red500?: T;
  red500gradient?: T;
  turquoise100?: T;
  turquoise300?: T;
  white?: T;
  grey100?: T;
}
export interface BoxSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  yellow100?: T;
  yellow300?: T;
  red100?: T;
  red300?: T;
  red500?: T;
  red500gradient?: T;
  turquoise100?: T;
  turquoise300?: T;
}
export interface ButtonSchemeConfiguration<T> {
  red500?: T;
  neutral100?: T;
  white?: T;
  discreet?: T;
  discreetDark?: T;
  darkgreyCarrier?: T;
  neutral100Carrier?: T;
}
export interface CaptionSchemeConfiguration<T> {
  grey100?: T;
  white?: T;
}
export interface CardTeaserSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  yellow100?: T;
  yellow300?: T;
  red100?: T;
  red300?: T;
  red500gradient?: T;
  turquoise100?: T;
  turquoise300?: T;
  white?: T;
  red500?: T;
  grey100?: T;
}
export interface CarouselSchemeConfiguration<T> {
  red500?: T;
  neutral100?: T;
  white?: T;
}
export interface CheckboxSchemeConfiguration<T> {
  neutral100?: T;
  neutral800?: T;
  white?: T;
  grey900?: T;
}
export interface ChipSchemeConfiguration<T> {
  systemHighlight?: T;
  white?: T;
}
export interface ClickableImageSchemeConfiguration<T> {
  red500?: T;
  grey900?: T;
  neutral100?: T;
  white?: T;
}
export interface CompassSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
}
export interface ContactBarSchemeConfiguration<T> {
  neutral100?: T;
  white?: T;
}
export interface ContactLayerSchemeConfiguration<T> {
  white?: T;
}
export interface ContactListSchemeConfiguration<T> {
  neutral100?: T;
  neutral800?: T;
  white?: T;
  grey900?: T;
}
export interface ContentAggregatorSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  red100?: T;
  red300?: T;
  red500?: T;
  yellow100?: T;
  yellow300?: T;
  turquoise100?: T;
  turquoise300?: T;
}
export interface ContentAggregatorItemSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  red100?: T;
  red300?: T;
  red500?: T;
  yellow100?: T;
  yellow300?: T;
  turquoise100?: T;
  turquoise300?: T;
}
export interface ContextMenuSchemeConfiguration<T> {
  white?: T;
}
export interface ContextMenuItemSchemeConfiguration<T> {
  neutral100?: T;
  white?: T;
}
export interface DateEventSchemeConfiguration<T> {
  neutral100?: T;
  neutral800?: T;
  white?: T;
  grey900?: T;
}
export interface DatePickerSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  red500?: T;
}
export interface DividerSchemeConfiguration<T> {
  neutral300?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface DropdownSchemeConfiguration<T> {
  white?: T;
  red500?: T;
}
export interface DropdownOptionSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  red500?: T;
}
export interface ErrorMessageSchemeConfiguration<T> {
  white?: T;
  grey100?: T;
  error?: T;
  warning?: T;
  success?: T;
  info?: T;
  neutral100?: T;
  neutral300?: T;
  yellow100?: T;
  yellow300?: T;
  red100?: T;
  red300?: T;
  turquoise100?: T;
  turquoise300?: T;
}
export interface FileUploadSchemeConfiguration<T> {
  grey100?: T;
  white?: T;
  red500?: T;
}
export interface FilePreviewSchemeConfiguration<T> {
  grey100?: T;
  white?: T;
}
export interface FormMessageSchemeConfiguration<T> {
  standard?: T;
  neutral100?: T;
  white?: T;
}
export interface HeadlineSchemeConfiguration<T> {
  neutral100?: T;
  neutral800?: T;
  white?: T;
  grey900?: T;
  red500?: T;
}
export interface HeadlineBrandSchemeConfiguration<T> {
  white?: T;
  red500?: T;
  grey900?: T;
}
export interface HeroSectionSchemeConfiguration<T> {
  white?: T;
  grey100?: T;
  red500?: T;
  red500gradient?: T;
}
export interface IconSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
  red500?: T;
}
export interface InfoIconSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
  red500?: T;
}
export interface InputSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  red500?: T;
}
export interface LinkSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface LinklistSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
  red500?: T;
}
export interface MapInfoLayerSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  yellow100?: T;
  yellow300?: T;
  turquoise100?: T;
  turquoise300?: T;
  red100?: T;
  red300?: T;
  red500?: T;
}
export interface MultiContentStageSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  red100?: T;
  red300?: T;
  turquoise100?: T;
  turquoise300?: T;
  yellow100?: T;
  yellow300?: T;
  white?: T;
  grey100?: T;
}
export interface NumberSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface OffsetTeaserSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  yellow100?: T;
  yellow300?: T;
  red100?: T;
  red300?: T;
  red500?: T;
  red500gradient?: T;
  turquoise100?: T;
  turquoise300?: T;
  white?: T;
  grey100?: T;
}
export interface OptionPickerItemSchemeConfiguration<T> {
  neutral800?: T;
  grey900?: T;
  white?: T;
}
export interface PaginationSchemeConfiguration<T> {
  neutral400?: T;
  grey900?: T;
}
export interface PreloaderCircleSchemeConfiguration<T> {
  red500?: T;
  turquoise500?: T;
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
  colorful?: T;
}
export interface PreloaderSquaresSchemeConfiguration<T> {
  red500?: T;
  turquoise500?: T;
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface ProgressCircleSchemeConfiguration<T> {
  red500?: T;
  white?: T;
}
export interface PromoFlagSchemeConfiguration<T> {
  red500?: T;
  purple500?: T;
  blue700?: T;
  grey100?: T;
  grey900?: T;
  white?: T;
  yellow500?: T;
  turquoise500?: T;
  neutral100?: T;
  neutral300?: T;
  neutral800?: T;
}
export interface PageHeaderSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  yellow100?: T;
  yellow300?: T;
  red100?: T;
  red300?: T;
  white?: T;
  grey100?: T;
  red500?: T;
  red500gradient?: T;
  turquoise100?: T;
  turquoise300?: T;
}
export interface PictogramSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
  red500?: T;
}
export interface RadioButtonSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface ReadMoreSchemeConfiguration<T> {
  neutral800?: T;
  red500?: T;
  white?: T;
  grey600?: T;
}
export interface RteRendererSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface SectionSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
  red500?: T;
  red500gradient?: T;
  transparent?: T;
}
export interface SegmentedButtonSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface SearchResultItemSchemeConfiguration<T> {
  neutral100?: T;
  white?: T;
}
export interface SitelinkSchemeConfiguration<T> {
  neutral800?: T;
  grey900?: T;
}
export interface SliderSchemeConfiguration<T> {
  red500?: T;
  neutral100?: T;
  systemHighlight?: T;
  white?: T;
}
export interface SwitchToggleSchemeConfiguration<T> {
  neutral100?: T;
  neutral800?: T;
  white?: T;
  grey900?: T;
}
export interface StageSchemeConfiguration<T> {
  neutral100?: T;
  white?: T;
  red500?: T;
}
export interface StatePillSchemeConfiguration<T> {
  active?: T;
  pending?: T;
  error?: T;
  warning?: T;
  inactive?: T;
}
export interface StepSchemeConfiguration<T> {
  neutral800?: T;
  grey900?: T;
  neutral100?: T;
  white?: T;
}
export interface StepsSchemeConfiguration<T> {
  neutral800?: T;
  grey900?: T;
  neutral100?: T;
  white?: T;
}
export interface TableRendererSchemeConfiguration<T> {
  neutral800?: T;
  grey900?: T;
  neutral100?: T;
  white?: T;
}
export interface TabsSchemeConfiguration<T> {
  neutral800?: T;
  grey900?: T;
  neutral100?: T;
  white?: T;
}
export interface TabNavigationSchemeConfiguration<T> {
  grey900?: T;
  white?: T;
}
export interface TagPillSchemeConfiguration<T> {
  neutral100?: T;
  neutral800?: T;
  red500?: T;
  grey900?: T;
  white?: T;
}
export interface TextSchemeConfiguration<T> {
  neutral800?: T;
  neutral100?: T;
  grey900?: T;
  white?: T;
}
export interface TextTeaserSchemeConfiguration<T> {
  neutral100?: T;
  neutral300?: T;
  yellow100?: T;
  yellow300?: T;
  red100?: T;
  red300?: T;
  red500?: T;
  red500gradient?: T;
  turquoise100?: T;
  turquoise300?: T;
  white?: T;
  grey100?: T;
}
export interface ThirdLevelNavigationSchemeConfiguration<T> {
  red500?: T;
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
}
export interface ThirdLevelNavigationItemSchemeConfiguration<T> {
  red500?: T;
  neutral100?: T;
  neutral300?: T;
  white?: T;
  grey100?: T;
}
export interface TilesTeaserSchemeConfiguration<T> {
  red100?: T;
  red300?: T;
  neutral100?: T;
  neutral300?: T;
  yellow100?: T;
  yellow300?: T;
  turquoise100?: T;
  turquoise300?: T;
  white?: T;
  grey100?: T;
  red500?: T;
  red500gradient?: T;
}
export interface TooltipSchemeConfiguration<T> {
  grey900?: T;
}
export interface VideoplayerSchemeConfiguration<T> {
  neutral100?: T;
  white?: T;
}
export interface ViolatorSchemeConfiguration<T> {
  red500?: T;
  yellow500?: T;
  turquoise500?: T;
  neutral100?: T;
  neutral300?: T;
  neutral800?: T;
  purple500?: T;
  blue700?: T;
  grey100?: T;
  grey900?: T;
  white?: T;
}
//add Components Color-Variables from colorDefinitions
export const ANCHOR_NAVIGATION_BACKGROUND_COLOR = "eon-anchor-navigation-background-color" as const;
export const ANCHOR_NAVIGATION_BACKGROUND_HOVER_COLOR = "eon-anchor-navigation-background-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_COLOR = "eon-anchor-navigation-icon-color" as const;
export const ANCHOR_NAVIGATION_ICON_HOVER_COLOR = "eon-anchor-navigation-icon-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_HIGHLIGHT_COLOR = "eon-anchor-navigation-icon-highlight-color" as const;
export const ANCHOR_NAVIGATION_ITEM_BACKGROUND_COLOR = "eon-anchor-navigation-item-background-color" as const;
export const ANCHOR_NAVIGATION_ITEM_HOVER_COLOR = "eon-anchor-navigation-item-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_COLOR = "eon-anchor-navigation-link-color" as const;
export const ANCHOR_NAVIGATION_LINK_HOVER_COLOR = "eon-anchor-navigation-link-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_HIGHLIGHT_COLOR = "eon-anchor-navigation-link-highlight-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_HOVER_COLOR = "eon-context-menu-item-background-hover-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_ACTIVE_COLOR = "eon-context-menu-item-background-active-color" as const;
export const DATA_TABLE_HEAD_CELL_COLOR = "eon-data-table-head-cell-color" as const;
export const DATA_TABLE_HEAD_CELL_ICON_COLOR = "eon-data-table-head-cell-icon-color" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND = "eon-data-table-head-cell-background" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_HOVER = "eon-data-table-head-cell-background-hover" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT = "eon-data-table-head-cell-background-act" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT_HOVER = "eon-data-table-head-cell-background-act-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER = "eon-data-table-head-cell-border" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_HOVER = "eon-data-table-head-cell-border-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT = "eon-data-table-head-cell-border-act" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT_HOVER = "eon-data-table-head-cell-border-act-hover" as const;
export const DATA_TABLE_CELL_COLOR = "eon-data-table-cell-color" as const;
export const DATA_TABLE_CELL_ICON_COLOR = "eon-data-table-cell-icon-color" as const;
export const DATA_TABLE_CELL_BACKGROUND = "eon-data-table-cell-background" as const;
export const DATA_TABLE_CELL_BACKGROUND_HOVER = "eon-data-table-cell-background-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED = "eon-data-table-cell-background-selected" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED_HOVER = "eon-data-table-cell-background-selected-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD = "eon-data-table-cell-background-odd" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD_HOVER = "eon-data-table-cell-background-odd-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN = "eon-data-table-cell-background-even" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN_HOVER = "eon-data-table-cell-background-even-hover" as const;
export const DATA_TABLE_CELL_BORDER = "eon-data-table-cell-border" as const;
export const DATA_TABLE_CELL_BORDER_HOVER = "eon-data-table-cell-border-hover" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED = "eon-data-table-cell-border-selected" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED_HOVER = "eon-data-table-cell-border-selected-hover" as const;
export const DATA_TABLE_CELL_BORDER_ODD = "eon-data-table-cell-border-odd" as const;
export const DATA_TABLE_CELL_BORDER_ODD_HOVER = "eon-data-table-cell-border-odd-hover" as const;
export const DATA_TABLE_CELL_BORDER_EVEN = "eon-data-table-cell-border-even" as const;
export const DATA_TABLE_CELL_BORDER_EVEN_HOVER = "eon-data-table-cell-border-even-hover" as const;
export const DATA_TABLE_TOOLBAR_BACKGROUND = "eon-data-table-toolbar-background" as const;
export const DATA_TABLE_TOOLBAR_COLOR = "eon-data-table-toolbar-color" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_BACKGROUND = "eon-data-table-toolbar-selected-background" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_COLOR = "eon-data-table-toolbar-selected-color" as const;
export const DATA_TABLE_FOCUS_BORDER = "eon-data-table-focus-border" as const;
export const FOOTER_BAR_COPYRIGHT_COLOR = "eon-footer-bar-copyright-color" as const;
export const FOOTER_BAR_BACKGROUND_COLOR = "eon-footer-bar-background-color" as const;
export const FOOTER_BAR_LINK_COLOR = "eon-footer-bar-link-color" as const;
export const FOOTER_BAR_LINK_HOVER_COLOR = "eon-footer-bar-link-hover-color" as const;
export const FOOTER_BAR_ICON_COLOR = "eon-footer-bar-icon-color" as const;
export const FOOTER_BAR_ICON_HOVER_COLOR = "eon-footer-bar-icon-hover-color" as const;
export const NAVIGATION_BOX_SHADOW = "eon-navigation-box-shadow" as const;
export const NAVIGATION_META_BG_COLOR = "eon-navigation-meta-bg-color" as const;
export const NAVIGATION_META_BORDER_COLOR = "eon-navigation-meta-border-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR = "eon-navigation-meta-link-font-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_HOVER = "eon-navigation-meta-link-font-color-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_FOCUS = "eon-navigation-meta-link-font-color-focus" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT = "eon-navigation-meta-link-font-color-current" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-font-color-current-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-font-color-current-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR = "eon-navigation-meta-link-bg-color" as const;
export const NAVIGATION_META_LINK_BG_COLOR_HOVER = "eon-navigation-meta-link-bg-color-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_FOCUS = "eon-navigation-meta-link-bg-color-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT = "eon-navigation-meta-link-bg-color-current" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-bg-color-current-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-bg-color-current-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR = "eon-navigation-meta-link-border-color" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_HOVER = "eon-navigation-meta-link-border-color-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_FOCUS = "eon-navigation-meta-link-border-color-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT = "eon-navigation-meta-link-border-color-current" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-border-color-current-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-border-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_BG_COLOR = "eon-navigation-toolbar-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR = "eon-navigation-toolbar-icon-link-font-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-toolbar-icon-link-font-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-font-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-font-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-font-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-font-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-font-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-font-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-font-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR = "eon-navigation-toolbar-icon-link-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-toolbar-icon-link-bg-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-bg-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-bg-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_SUB_BG_COLOR = "eon-navigation-toolbar-sub-bg-color" as const;
export const NAVIGATION_MAIN_BG_COLOR = "eon-navigation-main-bg-color" as const;
export const NAVIGATION_MAIN_BORDER_COLOR = "eon-navigation-main-border-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR = "eon-navigation-main-link-font-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_HOVER = "eon-navigation-main-link-font-color-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-link-font-color-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-link-font-color-current" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-link-font-color-active" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR = "eon-navigation-main-link-bg-color" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_HOVER = "eon-navigation-main-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_FOCUS = "eon-navigation-main-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT = "eon-navigation-main-link-bg-color-current" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-link-bg-color-active" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR = "eon-navigation-main-link-border-color" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-link-border-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-link-border-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-link-border-color-current" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-link-border-color-active" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR = "eon-navigation-main-icon-link-font-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-main-icon-link-font-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-icon-link-font-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-icon-link-font-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-icon-link-font-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR = "eon-navigation-main-icon-link-bg-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-main-icon-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-main-icon-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-main-icon-link-bg-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-icon-link-bg-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR = "eon-navigation-main-icon-link-border-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-icon-link-border-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-icon-link-border-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-icon-link-border-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-icon-link-border-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_SUB_BG_COLOR = "eon-navigation-main-sub-bg-color" as const;
export const NAVIGATION_MAIN_SUB_BOX_SHADOW = "eon-navigation-main-sub-box-shadow" as const;
export const NAVIGATION_FLYOUT_DIVIDER_BG_COLOR = "eon-navigation-flyout-divider-bg-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR = "eon-navigation-flyout-link-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_HOVER = "eon-navigation-flyout-link-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-border-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR = "eon-navigation-flyout-link-large-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_HOVER = "eon-navigation-flyout-link-large-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-large-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-large-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-large-border-color-current" as const;
export const NAVIGATION_MOBILE_BG_COLOR = "eon-navigation-mobile-bg-color" as const;
export const NAVIGATION_MOBILE_LINK_FONT_COLOR = "eon-navigation-mobile-link-font-color" as const;
export const NAVIGATION_MOBILE_LINK_HIGHLIGHT_BORDER_COLOR = "eon-navigation-mobile-link-highlight-border-color" as const;
export const NAVIGATION_MOBILE_LINK_BORDER_COLOR = "eon-navigation-mobile-link-border-color" as const;
export const NAVIGATION_FOCUS_BORDER_COLOR = "eon-navigation-focus-border-color" as const;
export const NAVIGATION_MAIN_BORDER_COLOR_FOCUS_VISIBLE = "eon-navigation-main-border-color-focus-visible" as const;
export const NAVIGATION_LOGO_FOCUS_COLOR = "eon-navigation-logo-focus-color" as const;
export const SECTION_VIDEO_CONTROL_COLOR_LIGHT = "eon-section-video-control-color-light" as const;
export const SECTION_VIDEO_CONTROL_COLOR_DARK = "eon-section-video-control-color-dark" as const;
export const SEARCH_RESULT_ITEM_MARK_COLOR = "eon-search-result-item-mark-color" as const;
export const SEARCH_RESULT_ITEM_VISITED_COLOR = "eon-search-result-item-visited-color" as const;
export const SEARCH_RESULT_ITEM_BACKGROUND_COLOR = "eon-search-result-item-background-color" as const;
export const VIDEOPLAYER_FOCUS_OUTLINE_COLOR = "eon-videoplayer-focus-outline-color" as const;
export const VIDEOPLAYER_ERROR_COLOR = "eon-videoplayer-error-color" as const;
export const VIDEOPLAYER_ERROR_BACKGROUND_COLOR = "eon-videoplayer-error-background-color" as const;
export const VIDEOPLAYER_CONTROLS_BACKGROUND = "eon-videoplayer-controls-background" as const;
export const VIDEOPLAYER_PROGRESS_BACKGROUND = "eon-videoplayer-progress-background" as const;
export const VIDEOPLAYER_PROGRESS_COLOR = "eon-videoplayer-progress-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BACKGROUND = "eon-videoplayer-progress-bar-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_TIME_COLOR = "eon-videoplayer-progress-bar-time-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_VALUE_BACKGROUND = "eon-videoplayer-progress-bar-value-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_ICON_COLOR = "eon-videoplayer-progress-bar-icon-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_COLOR = "eon-videoplayer-progress-bar-button-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_FOCUS = "eon-videoplayer-progress-bar-button-focus" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-button-hover-background" as const;
export const WEBSITE_NAVIGATION_BOX_SHADOW = "eon-website-navigation-box-shadow" as const;
export const WEBSITE_NAVIGATION_META_BG_COLOR = "eon-website-navigation-meta-bg-color" as const;
export const WEBSITE_NAVIGATION_META_BORDER_COLOR = "eon-website-navigation-meta-border-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR = "eon-website-navigation-meta-link-font-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_HOVER = "eon-website-navigation-meta-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-meta-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR = "eon-website-navigation-meta-link-bg-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_HOVER = "eon-website-navigation-meta-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_CURRENT = "eon-website-navigation-meta-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR = "eon-website-navigation-meta-link-border-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_HOVER = "eon-website-navigation-meta-link-border-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-meta-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-border-color-current-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_BG_COLOR = "eon-website-navigation-toolbar-bg-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR = "eon-website-navigation-toolbar-link-font-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_HOVER = "eon-website-navigation-toolbar-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-toolbar-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-toolbar-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_ACTIVE = "eon-website-navigation-toolbar-link-font-color-active" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-website-navigation-toolbar-link-font-color-active-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR = "eon-website-navigation-toolbar-link-bg-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_HOVER = "eon-website-navigation-toolbar-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_CURRENT = "eon-website-navigation-toolbar-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-toolbar-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_ACTIVE = "eon-website-navigation-toolbar-link-bg-color-active" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_ACTIVE_HOVER = "eon-website-navigation-toolbar-link-bg-color-active-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_SUB_BG_COLOR = "eon-website-navigation-toolbar-sub-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_BG_COLOR = "eon-website-navigation-main-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_BORDER_COLOR = "eon-website-navigation-main-border-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR = "eon-website-navigation-main-link-font-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_HOVER = "eon-website-navigation-main-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-main-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE = "eon-website-navigation-main-link-font-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-font-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR = "eon-website-navigation-main-link-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_HOVER = "eon-website-navigation-main-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT = "eon-website-navigation-main-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE = "eon-website-navigation-main-link-bg-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-bg-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR = "eon-website-navigation-main-link-border-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_HOVER = "eon-website-navigation-main-link-border-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-main-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-border-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE = "eon-website-navigation-main-link-border-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-border-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_SUB_BG_COLOR = "eon-website-navigation-main-sub-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_SUB_BOX_SHADOW = "eon-website-navigation-main-sub-box-shadow" as const;
export const WEBSITE_NAVIGATION_FLYOUT_DIVIDER_BG_COLOR = "eon-website-navigation-flyout-divider-bg-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR = "eon-website-navigation-flyout-link-font-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR_HOVER = "eon-website-navigation-flyout-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-flyout-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-flyout-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR = "eon-website-navigation-flyout-link-large-font-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_HOVER = "eon-website-navigation-flyout-link-large-font-color-hover" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_CURRENT = "eon-website-navigation-flyout-link-large-font-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_BORDER_COLOR_CURRENT = "eon-website-navigation-flyout-link-large-border-color-current" as const;
export const WEBSITE_NAVIGATION_MOBILE_BG_COLOR = "eon-website-navigation-mobile-bg-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_FONT_COLOR = "eon-website-navigation-mobile-link-font-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_HIGHLIGHT_BORDER_COLOR = "eon-website-navigation-mobile-link-highlight-border-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_BORDER_COLOR = "eon-website-navigation-mobile-link-border-color" as const;

export const SCHEME_ALIAS_CONFIG = {
  ACCORDION: {},
  ANCHOR_NAVIGATION: {},
  ANSWER_CARD: {},
  BADGE: {},
  BASIC_TEASER: {},
  BREADCRUMB: {},
  BOTTOM_DRAWER: {},
  BULLET_LIST: {},
  BUSINESSCARD_AUTHOR: {},
  BUSINESSCARD_CONTACT: {},
  BOX: {},
  BUTTON: {},
  CAPTION: {},
  CARD_TEASER: {},
  CAROUSEL: {},
  CHECKBOX: {},
  CHIP: {},
  CLICKABLE_IMAGE: {},
  COLOR_SEPARATOR: {},
  COMPASS: {},
  CONTACT_BAR: {},
  CONTACT_LAYER: {},
  CONTACT_LIST: {},
  CONTENT_AGGREGATOR: {},
  CONTENT_AGGREGATOR_ITEM: {},
  CONTEXT_MENU: {},
  CONTEXT_MENU_ITEM: {},
  DATA_TABLE: {},
  DATE_EVENT: {},
  DATE_PICKER: {},
  DIVIDER: {},
  DROPDOWN: {},
  DROPDOWN_OPTION: {},
  ERROR_MESSAGE: {},
  FILE_UPLOAD: {},
  FILE_PREVIEW: {},
  FOOTER_BAR: {},
  FORM_MESSAGE: {},
  HEADLINE: {},
  HEADLINE_BRAND: {},
  HERO_SECTION: {},
  ICON: {},
  IMAGE: {},
  INFO_ICON: {},
  INPUT: {},
  LINK: {},
  LINKLIST: {},
  MAP: {},
  MAP_INFO_LAYER: {},
  MODAL: {},
  MULTI_CONTENT_STAGE: {},
  NAVIGATION: {},
  NUMBER: {},
  OFFSET_TEASER: {},
  OPTION_PICKER_ITEM: {},
  PAGINATION: {},
  PRELOADER_CIRCLE: {},
  PRELOADER_SQUARES: {},
  PROGRESS_CIRCLE: {},
  PROMO_FLAG: {},
  PAGE_HEADER: {},
  PICTOGRAM: {},
  RADIO_BUTTON: {},
  READ_MORE: {},
  RTE_RENDERER: {},
  SECTION: {},
  SEGMENTED_BUTTON: {},
  SEARCH_RESULT_ITEM: {},
  SITELINK: {},
  SLIDER: {},
  SWITCH_TOGGLE: {},
  SPACER: {},
  STAGE: {},
  STATE_PILL: {},
  STEP: {},
  STEPS: {},
  TABLE_RENDERER: {},
  TABS: {},
  TAB_NAVIGATION: {},
  TAG_PILL: {},
  TEXT: {},
  TEXT_TEASER: {},
  THIRD_LEVEL_NAVIGATION: {},
  THIRD_LEVEL_NAVIGATION_ITEM: {},
  TILES_TEASER: {},
  TOOLTIP: {},
  VIDEOPLAYER: {},
  VIOLATOR: {},
  WEBSITE_NAVIGATION: {}
};

export const BACKGROUND_COLORS = [
  // COLOR_ULTRALIGHTGREY,
  // COLOR_WHITE,
  // COLOR_LIGHTGREY,

  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_GREY100,
  COLOR_GREY900,
  COLOR_NEUTRAL100,
  COLOR_NEUTRAL300,
  COLOR_NEUTRAL800,
  COLOR_RED100,
  COLOR_RED300,
  COLOR_RED500,
  COLOR_RED800,
  COLOR_YELLOW100,
  COLOR_YELLOW300,
  COLOR_YELLOW500,
  COLOR_TURQUOISE100,
  COLOR_TURQUOISE300,
  COLOR_TURQUOISE500
];

export interface BackgroundSchemeConfiguration<T> {
  // white?: T;
  // lightgrey?: T;
  // ultralightgrey?: T;

  bright?: T;
  dark?: T;
  white?: T;
  black?: T;
  grey100?: T;
  grey900?: T;
  neutral100?: T;
  neutral300?: T;
  neutral800?: T;
  red100?: T;
  red300?: T;
  red500?: T;
  red800?: T;
  yellow100?: T;
  yellow300?: T;
  yellow500?: T;
  turquoise100?: T;
  turquoise300?: T;
  turquoise500?: T;
}

interface ColorMap {
  [name: string]: string | boolean | number;
}

export interface SchemeConfig {
  schemeName: string;
  scheme?: ColorMap;
}

export type EonColor = typeof EON_COLORS[number];

/* PLOP_INJECT_ALIGNMENT */
